export const speakerData = [
    {
        "id": "RXZlbnRQZW9wbGVfNDE3MDU5MjQ=",
        "type": null,
        "firstName": "HH Sheikh",
        "lastName": "Ahmed bin Saeed Al Maktoum",
        "jobTitle": "Chairman and Chief Executive",
        "organization": "Emirates  Airline and Group",
        "photoUrl": "https://static.swapcard.com/public/images/cef9710540734f0e8132b8e5155685cd.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzEyMjE4NQ==",
                "title": "FHS Lifetime Achievement Award",
                "categories": [
                    "Awards"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "awards",
                        "translations": [
                            {
                                "value": "Awards"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "ghqNHaw_iB4",
                    "id": "RmllbGRWYWx1ZV8yODM3MzE3Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "b2378f3a-4861-4aaa-92ec-39f119e4aa6f",
                    "id": "RmllbGRWYWx1ZV8yODM3MzE4MQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEwMzg5NzY=",
        "type": null,
        "firstName": "HE Abdulla",
        "lastName": "bin Touq Al Marri",
        "jobTitle": "Minister of Economy and Tourism",
        "organization": "United Arab Emirates",
        "photoUrl": "https://static.swapcard.com/public/images/42ee3cc4823e43319c9ff340311e8e79.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU5MQ==",
                "title": "Leveraging Global Opportunities in Today’s Competitive Business World",
                "categories": [
                    "Global Investments",
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzI2NTMxNg==",
                "title": "Keynote Speeches",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyOTAyOQ==",
                "title": "KeyNote: The UAE’s Blueprint for Tourism, Innovation, and Economic Resilience",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "PDzbhjbk8F4",
                    "id": "RmllbGRWYWx1ZV8yODE2ODg0OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "4205b7e4-559b-4123-8480-228f222e6b5e",
                    "id": "RmllbGRWYWx1ZV8yODE2ODg0OA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA3MTM1NzY=",
        "type": null,
        "firstName": "Nasser",
        "lastName": "Al Nowais",
        "jobTitle": "Chairman of the Board of Directors",
        "organization": "Rotana Hotel Management Corporation P.J.S.C",
        "photoUrl": "https://static.swapcard.com/public/images/f8635bf938934af3af21186cca1768de.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcwNg==",
                "title": "Then and Now: Two Decades of Hospitality Investment Evolution",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "0PeX8aVeOy4",
                    "id": "RmllbGRWYWx1ZV8yODAyNDAxNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "c296de35-7bbc-47c6-b17f-1aa2bab70d08",
                    "id": "RmllbGRWYWx1ZV8yODcxNzM0MQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEyMzM5MDM=",
        "type": "Speaker",
        "firstName": "Abdullah",
        "lastName": "Ahmed Al Moosa",
        "jobTitle": "Founder & Chairman",
        "organization": "A. A. Al Moosa Enterprises | ARENCO Group",
        "photoUrl": "https://static.swapcard.com/public/images/dcb674f35e594a05b5d878304cca1789.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTkxOTQ3OQ==",
                "title": "Workshop: The Evolution of Branded Residences",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzEyMjE4NQ==",
                "title": "FHS Lifetime Achievement Award",
                "categories": [
                    "Awards"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "awards",
                        "translations": [
                            {
                                "value": "Awards"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "oWTRuPg4Bs4",
                    "id": "RmllbGRWYWx1ZV8yODI0MDM2Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e019ef76-1806-4d5d-ad7f-4f2216dcc8ad",
                    "id": "RmllbGRWYWx1ZV8yODI0MDM2OA=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Award Winner - Lifetime Achievement Award",
                    "id": "RmllbGRWYWx1ZV8yODI0MDM2OQ=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2MDQ1NDk=",
        "type": "Speaker",
        "firstName": "HE Shaikha",
        "lastName": "Nasser Al Nowais",
        "jobTitle": "Secretary-General Elect",
        "organization": "UN Tourism",
        "photoUrl": "https://static.swapcard.com/public/images/a8a3eed89c99418ea55cedd0edf6ea16.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc1MDYwMA==",
                "title": "Breaking Barriers, Shaping the Future: Women in Tourism & Hospitality Leadership",
                "categories": [
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA2OTM1NQ==",
                "title": "Global Expertise, Local Talent: Hospitality's Balancing Act",
                "categories": [
                    "Education Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MjkwMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "education-investment",
                        "translations": [
                            {
                                "value": "Education Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzM3OTUyMw==",
                "title": "Keynote Presentation",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyNTMzNQ==",
                "title": "Redefining Tourism Leadership for a New World",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "6bszrenRxLA",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQwOQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "17c579cb-3470-4adf-83e7-afc5792c50ef",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQwOA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE1NzI4NjQ=",
        "type": null,
        "firstName": "Alan",
        "lastName": "Faena",
        "jobTitle": "Founder and President",
        "organization": "Faena Group",
        "photoUrl": "https://static.swapcard.com/public/images/188ddd1dede0470fb0dbe8d7689da7b9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc4MDE2Nw==",
                "title": "“Art of Creation” Redefining Hospitality",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "UWiy9k7KA9g",
                    "id": "RmllbGRWYWx1ZV8yODM0NDEwOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "52e2cb95-6264-45fb-9311-8a457bbbf24b",
                    "id": "RmllbGRWYWx1ZV8yODM0NDEyMA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwNzM2NzA=",
        "type": null,
        "firstName": "HE Ahmed",
        "lastName": "Obaid Al Qaseer",
        "jobTitle": "Chief Executive Officer",
        "organization": "Sharjah Investment and Development Authority (Shurooq)",
        "photoUrl": "https://static.swapcard.com/public/images/4903ce27bf6440ae91e999eb919be0f7.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMzM2Mg==",
                "title": "Building Destinations Together: The Impact of Public-Private Partnerships",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "UCa1kHr6L94",
                    "id": "RmllbGRWYWx1ZV8yODQ5NTY2MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "79d6237c-34c2-41df-97f6-dd0ca23117c8",
                    "id": "RmllbGRWYWx1ZV8yODUyODM4Mg=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDAzNDU2NjM=",
        "type": "Speaker",
        "firstName": "Nick",
        "lastName": "Candy",
        "jobTitle": "Chief Executive Officer",
        "organization": "Candy Capital",
        "photoUrl": "https://static.swapcard.com/public/images/cd2f0cf8c3f8428e86d86e922f7b64fb.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjE2MDE2OA==",
                "title": "From London to Dubai - Perspectives from a Pioneering Developer on the Future of Branded Living in the World's most Dynamic Market for Branded Real Estate",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkxMQ==",
                "title": "Design, Legacy & Returns: How Visionary Leaders Shape the Future of Luxury Real Estate",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "ZWwrcPuaQrM",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM1Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "fb6ab9a5-b634-4d62-a3a2-5aaa5b48d58e",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM1MQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEyMDgzNDk=",
        "type": null,
        "firstName": "Marc",
        "lastName": "Dardenne",
        "jobTitle": "Chief Executive Officer",
        "organization": "Modon Holding Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/4ba04289ac88482b8eea156243b38993.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczMzg3Ng==",
                "title": "From Local Roots to Global Reach: Charting the Hospitality Expansion Journey",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "pOFcoi-fTKM",
                    "id": "RmllbGRWYWx1ZV8yODIzMzE4Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "215ffb7c-50d4-4da0-bf3d-82d5789a51a8",
                    "id": "RmllbGRWYWx1ZV8yODczNDc0OQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIyNzE0MTQ=",
        "type": null,
        "firstName": "Oliver",
        "lastName": "Hogg",
        "jobTitle": "Chief Executive Officer",
        "organization": "Arzan Investment Management",
        "photoUrl": "https://static.swapcard.com/public/images/44e8694015c14e23be9b006a20d3b074.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg5MA==",
                "title": "The Second Act: How Investors are Rewriting the Story of Hospitality Assets",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "t5WCHRTX6QI",
                    "id": "RmllbGRWYWx1ZV8yODYwNTAzMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "d1d2f931-0810-4149-8ab1-86f211339fdb",
                    "id": "RmllbGRWYWx1ZV8yODYwNTAzMw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Asset Manager",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5NTY1Mjc=",
        "type": "Speaker",
        "firstName": "Christoph",
        "lastName": "Hoffmann",
        "jobTitle": "Founder and Co-CEO",
        "organization": "25hours Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/110a097d3a08490c889dcd238931069e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc4MjU4OQ==",
                "title": "TenX Leadership Talk: Where Lifestyle Meets Living",
                "categories": [
                    "TenX Leadership Talk"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc3Ng==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "tenx-leadership-talk",
                        "translations": [
                            {
                                "value": "TenX Leadership Talk"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "wYYQ_jShsHo",
                    "id": "RmllbGRWYWx1ZV8yODQ1Mjc2Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a68502a0-7c8e-4bdf-8949-425942c5bf5e",
                    "id": "RmllbGRWYWx1ZV8yODQ3ODk1Mg=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA0OTU5MTE=",
        "type": null,
        "firstName": "Marc",
        "lastName": "Socker",
        "jobTitle": "Chief Executive Officer",
        "organization": "Maybourne",
        "photoUrl": "https://static.swapcard.com/public/images/359e92bb5f56490cb46a404b25bdbfe4.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODkxMQ==",
                "title": "Design, Legacy & Returns: How Visionary Leaders Shape the Future of Luxury Real Estate",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "dQYFeSpV2ro",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM4OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "baa8b8d4-902a-4c0c-b49a-9c386e278b5c",
                    "id": "RmllbGRWYWx1ZV8yODExNDMyMA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5ODE3MjE=",
        "type": null,
        "firstName": "Abdulla Rashed",
        "lastName": "Al Abdouli",
        "jobTitle": "Chief Executive Officer",
        "organization": "Marjan",
        "photoUrl": "https://static.swapcard.com/public/images/d9014ef249164253bdc25907878df61a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMzM2Mg==",
                "title": "Building Destinations Together: The Impact of Public-Private Partnerships",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "zrhIEoER5hA",
                    "id": "RmllbGRWYWx1ZV8yODQ2MDk4Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "c298cbe6-cec6-4f47-8881-153824e25ad7",
                    "id": "RmllbGRWYWx1ZV8yODQ2MTI3NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2MzY0MjM=",
        "type": null,
        "firstName": "Thomas",
        "lastName": "B. Meier",
        "jobTitle": "Chief Executive Officer",
        "organization": "Jumeirah",
        "photoUrl": "https://static.swapcard.com/public/images/937564805efb45f9bc59f9df5d033823.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mw==",
                "title": "Beyond Borders: Strategic Fund Structuring for Cross-Border Investments to transform the Global Hospitality Landscape",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments",
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg4Mg==",
                "title": "Hospitality 2050: The Long View from the Top",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "qIJdXTkVex4",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMwNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "33e51fcd-4593-4fc4-b396-dea62a58bc0f",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMwMw=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA3OTgwNDg=",
        "type": null,
        "firstName": "Neil",
        "lastName": "Benjelloun",
        "jobTitle": "Co-Founder & Managing Partner",
        "organization": "JL Equity Group",
        "photoUrl": "https://static.swapcard.com/public/images/dd9e50be29e54531b21ceafdf488e92f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczOTg0OA==",
                "title": "Investors with Influence: How Private Capital Shapes Hospitality Footprints",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "czlw-bdBqag",
                    "id": "RmllbGRWYWx1ZV8yODA1OTkxMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a9d0ed5c-8c59-4a25-9a1d-9c390edc7c3d",
                    "id": "RmllbGRWYWx1ZV8yODA1OTkxNQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDMxMjY=",
        "type": "Moderator",
        "firstName": "Stephen",
        "lastName": "Sackur",
        "jobTitle": "Former Presenter",
        "organization": "HARDTalk",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/03618d250d2f4c30aebff7f3a994a651.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0OQ==",
                "title": "Tourism-Led Policies for a Better World: The Importance of the Industry Getting a Seat at the Government Policy-making Table",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAwMA==",
                "title": "\"A Global Entrepreneur’s Vision\" - Stephen Sackur, Presenter of HARDtalk in an Exclusive Fireside Chat with H.E. Mohamed Ali Rashed Alabbar",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMjk4NQ==",
                "title": "Navigators of Change: Insights of a CEO’s Journey",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTU3NjUxNg==",
                "title": "Redefining the Future: A New Generation of Leadership in Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMjk5Mw==",
                "title": "Turning the Tables: Hard Talk of Stephen Sackur on his view of Global Journalism in a Changing World",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYwMg==",
                "title": "TenX Leadership Talk:  Insights of a CEO’s Journey",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU5MQ==",
                "title": "Leveraging Global Opportunities in Today’s Competitive Business World",
                "categories": [
                    "Global Investments",
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjExODIxMA==",
                "title": "Regenerative Tourism: Innovating High-End Hospitality for Tomorrow",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjExOTk5Mg==",
                "title": "TenX Leadership Talk: Leading with Purpose for Sustainable Success",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjExNTUzOA==",
                "title": "India 2047: The Future of Travel and Hospitality in India​",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA3MTcyMQ==",
                "title": "Iconic Developments: Navigating the Next Wave of Urban Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQyMA==",
                "title": "Luxury Fashion Brands in Real Estate: Crafting Spaces of Elegance",
                "categories": [
                    "Branded Residences",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA1NjYzMA==",
                "title": "Closing Remarks",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE2MDE2OA==",
                "title": "From London to Dubai - Perspectives from a Pioneering Developer on the Future of Branded Living in the World's most Dynamic Market for Branded Real Estate",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg4Mg==",
                "title": "Hospitality 2050: The Long View from the Top",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzQzMTM4NQ==",
                "title": "Flying into the Future: The Economic and Strategic Imperative of Advanced Air Mobility",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjczMzg3Ng==",
                "title": "From Local Roots to Global Reach: Charting the Hospitality Expansion Journey",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkxMQ==",
                "title": "Design, Legacy & Returns: How Visionary Leaders Shape the Future of Luxury Real Estate",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "QS5U4LnYTzc",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI1OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a899deed-e71b-4d01-94d7-7eb92c2e7c67",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI1OA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2MzExODU=",
        "type": null,
        "firstName": "Markus",
        "lastName": "Venzin",
        "jobTitle": "Chief Executive Officer",
        "organization": "EHL Group",
        "photoUrl": "https://static.swapcard.com/public/images/d8283ea68e0e411d8f6f3defac096fd4.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODc3OA==",
                "title": "Rebuilding the Workforce: Attracting and Retaining Talent in Hospitality",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2ODAyMw==",
                "title": "From Challenge to Solution: Hospitality Workforce Sprint",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "A5_yB51ja0U",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQyMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5aff99aa-95b2-4221-ac59-4e604ebd6121",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQyMA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1MTMzMzc=",
        "type": null,
        "firstName": "Saurabh",
        "lastName": "Bakshi",
        "jobTitle": "Chief Operating Officer",
        "organization": "Azizi Developments",
        "photoUrl": "https://static.swapcard.com/public/images/5bafce6d8bc04081a555086ab448a1be.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODkxMw==",
                "title": "“Hybrid Lives” – The Big Shift and Vision of Future Spaces",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "LCMhdc3Q44U",
                    "id": "RmllbGRWYWx1ZV8yODY3NzcyNw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f1a214a9-75fb-4f9c-a87c-cb9bb325d33a",
                    "id": "RmllbGRWYWx1ZV8yODc1OTM0OA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0MTkzNzU=",
        "type": null,
        "firstName": "Faizal",
        "lastName": "Kottikollon",
        "jobTitle": "Founder Chairman",
        "organization": "KEF Holdings | Tulah Clinical Wellness",
        "photoUrl": "https://static.swapcard.com/public/images/1372fd2e06274d7eb587a707c477f4ea.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzIxMzQ0MA==",
                "title": "Health Meets Hospitality: Creating Value for People and Planet",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Lu-JcAp4WN4",
                    "id": "RmllbGRWYWx1ZV8yODYyOTkxNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "1efcd3cc-d2cf-4748-9872-b7df16e2af8f",
                    "id": "RmllbGRWYWx1ZV8yODYyOTkyNQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDAwNjUwMTI=",
        "type": null,
        "firstName": "Hans",
        "lastName": "Meyer",
        "jobTitle": "Co Founder & Managing Director",
        "organization": "Zoku",
        "photoUrl": "https://static.swapcard.com/public/images/41573afd40d44444bbfe98f32c26109f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc3Mzk3NQ==",
                "title": "Work. Live. Belong. Rethinking Hospitality for the Borderless Professional",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "oEfMkBzG_ps",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM0Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f194dc72-6d37-4bec-aaa0-f1eac8389f98",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM0NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2NTc2MDA=",
        "type": "Speaker",
        "firstName": "Dimitris",
        "lastName": "Manikis",
        "jobTitle": "President EMEA",
        "organization": "Wyndham Hotel & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/7557dff7b09c456aa6a26d38112546af.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTA3NzQ4",
                "title": " Occupier CEOs discuss if there is a new normal or it’s back to normal",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAzOQ==",
                "title": "Sustainable Hospitality Challenge",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAzMA==",
                "title": "Socially Responsible Talent Development in Hospitality: A Unified Approach to ESG-Driven Acquisition, Retention, Engagement",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTU3NjUxNw==",
                "title": "EAHM Leadership Series - Creating Harmony: Aligning People, Planet, and Future Growth in Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc4MzQ1OA==",
                "title": "Our Greatest Asset: Nurturing the Power of People",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTkzMzEyMQ==",
                "title": "Hospitality Leaders Unplugged: Ask Us Anything",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyOTQ1Ng==",
                "title": "The Power of the Middle: Scalable, Sustainable, Smart",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODc3OA==",
                "title": "Rebuilding the Workforce: Attracting and Retaining Talent in Hospitality",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2MjE3Mw==",
                "title": "Capital, Coastlines & Control: The Eastern Mediterranean Investment Map for Owners",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "aKALeDCED4A",
                    "id": "RmllbGRWYWx1ZV8yODAwMzY3MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5561dbd9-a4db-41cf-b223-48af81116134",
                    "id": "RmllbGRWYWx1ZV8yODcxODYwMw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwNjE0MDQ=",
        "type": "Speaker",
        "firstName": "Haitham",
        "lastName": "Mattar",
        "jobTitle": "Managing Director MEA & South West Asia, IHG Hotel & Resort",
        "organization": "Special Advisor to Secretary General, UNWTO",
        "photoUrl": "https://static.swapcard.com/public/images/d4fcd9cf676c4a6689b8cc875eec082d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAzOQ==",
                "title": "Sustainable Hospitality Challenge",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzA0OQ==",
                "title": "Tourism-Led Policies for a Better World: The Importance of the Industry Getting a Seat at the Government Policy-making Table",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU3OQ==",
                "title": "Investing in Saudi Arabia: A Blueprint for Successful Market Entry and Investment",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTkwMTQ2Mw==",
                "title": "Fireside Chat: How to Align Tourism Strategies Across Key African Markets for Sustainable Growth",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjEwNzQ0NA==",
                "title": "A Global Perspective: UN Tourism's Role in Addressing Sustainable Growth in Travel",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg4Mg==",
                "title": "Hospitality 2050: The Long View from the Top",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "United Arab Emirates",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "pGxa7QCnAUw",
                    "id": "RmllbGRWYWx1ZV8yODA5MjAwNg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "75733741-6f43-4004-a38e-dc548152c133",
                    "id": "RmllbGRWYWx1ZV8yODA5MjAwNQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA4MTMyNzA=",
        "type": null,
        "firstName": "HE Abdulla",
        "lastName": "AbdulAlee Al humaidan",
        "jobTitle": "Director General",
        "organization": "Zayed Authority for People of Determination",
        "photoUrl": "https://static.swapcard.com/public/images/e58076d88c9347aabd669df3249cb5c1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODc4MA==",
                "title": "Hospitality with Purpose: Landmark Initiatives Reshaping Inclusion in Hospitality",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "goPHhogYTIE",
                    "id": "RmllbGRWYWx1ZV8yODA3MDM4MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "ca8a3849-1a68-46a8-ab65-415b7e72cf27",
                    "id": "RmllbGRWYWx1ZV8yODE3MjYyNA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEyMzUwNjI=",
        "type": "Moderator",
        "firstName": "Louis",
        "lastName": "Abi Abboud",
        "jobTitle": "Regional Head - Lifestyle Collective MEAIT",
        "organization": "Ennismore",
        "photoUrl": "https://static.swapcard.com/public/images/f42528c6121f404baf78500c42b22342.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNg==",
                "title": "Unpacking the Benefits of Branded Residences for Investors",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc4MDE2Nw==",
                "title": "“Art of Creation” Redefining Hospitality",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk5NDU0NQ==",
                "title": "25 Jump Street: Shaping Dubai’s Next Culinary, Bar, Art & Culture Destination",
                "categories": [
                    "F&B Experience"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "f-and-b-experience",
                        "translations": [
                            {
                                "value": "F&B Experience"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "3gIJzC3xuMQ",
                    "id": "RmllbGRWYWx1ZV8yODI0MDg5NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "0cda66c3-e218-4fac-9145-95f1628f6c4f",
                    "id": "RmllbGRWYWx1ZV8yODI0MDg5Nw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA5MjUxNjc=",
        "type": null,
        "firstName": "Dr. Carole",
        "lastName": "Ackermann",
        "jobTitle": "Chairwoman of the Board President of EHL Board of Trustees",
        "organization": "EHL Hospitality Business School",
        "photoUrl": "https://static.swapcard.com/public/images/728239bfb5a84c2c8e8210f8e79c0774.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcxMQ==",
                "title": "FHS Awards",
                "categories": [
                    "Awards"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "awards",
                        "translations": [
                            {
                                "value": "Awards"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "dnelmHlPLug",
                    "id": "RmllbGRWYWx1ZV8yODEwMTY0NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a10c69b8-8b50-4ab1-849e-3bcd1deca3e3",
                    "id": "RmllbGRWYWx1ZV8yODEwMTY0Nw=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Future Leader Award Presenter",
                    "id": "RmllbGRWYWx1ZV8yODE4NDc4NA=="
                },
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2NjA1NTY=",
        "type": "Speaker",
        "firstName": "Hassan",
        "lastName": "Ahdab",
        "jobTitle": "Chief Hospitality Operations Officer",
        "organization": "TAIBA",
        "photoUrl": "https://static.swapcard.com/public/images/9cf68577bdff4a38be44c9fbf2850f25.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjU2MzY1OA==",
                "title": "Hospitality Asset Stability: Balancing Financial Strength for Owners & Brands",
                "categories": [
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjczOTMzNw==",
                "title": "Automating the Predictable, Humanizing the Exceptional: Investing in People for the Moments that Matter",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "prtRxXEIhuE",
                    "id": "RmllbGRWYWx1ZV8yODcyODc1NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5f2475bc-74b4-44d5-9324-76e16ab7938c",
                    "id": "RmllbGRWYWx1ZV8yODcyODc1NA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2NTc2MDk=",
        "type": null,
        "firstName": "Yasser",
        "lastName": "Ahmed",
        "jobTitle": "Chief Executive Officer",
        "organization": "Action Hotels Limited",
        "photoUrl": "https://static.swapcard.com/public/images/d3d35487f51347a2a137a0c729c45aa3.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg5NA==",
                "title": "Franchise Models: A Barrier to Sustainable Hospitality—or a Catalyst for Change?",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "jZ_w1aoiuwA",
                    "id": "RmllbGRWYWx1ZV8yODAwMzY3NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "58867c6b-639d-489a-8585-4c8d1925af1d",
                    "id": "RmllbGRWYWx1ZV8yODAwMzY3OA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0OTEzODY=",
        "type": "Speaker",
        "firstName": "Safiyya",
        "lastName": "Akoojee",
        "jobTitle": "Director",
        "organization": "Thomson Wilks Inc․",
        "photoUrl": "https://static.swapcard.com/public/images/eb5c1c176f4f4f5fb136a016947019bb.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjc0Mw==",
                "title": "Maximizing Returns, Minimizing Risk: How to Optimize and Protect Value for Investors",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDI1NDc3Mg==",
                "title": "From Fear to Feasibility: A Market-Entry Playbook for Africa",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "n131WoVgkIk",
                    "id": "RmllbGRWYWx1ZV8yODY2MTQzOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e3723491-90b3-4504-9fcf-fb53b44ae273",
                    "id": "RmllbGRWYWx1ZV8yODY2MTQ0MQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Lawyer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIxNTMwNzg=",
        "type": null,
        "firstName": "Elena",
        "lastName": "Akopiyants",
        "jobTitle": "Director of F&B Operations",
        "organization": "Sharjah Investment and Development Authority (Shurooq)",
        "photoUrl": "https://static.swapcard.com/public/images/62fda574c64f4dd089204f1790b7d567.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODkyMw==",
                "title": "From Neighbourhood Gems to Five-Star Plates: How Local Concepts Are Transforming Hotel Dining",
                "categories": [
                    "F&B Experience"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "f-and-b-experience",
                        "translations": [
                            {
                                "value": "F&B Experience"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "VRgvlux-yVA",
                    "id": "RmllbGRWYWx1ZV8yODUyODU4Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "de3d1252-85fd-4da1-8951-982866892e74",
                    "id": "RmllbGRWYWx1ZV8yODUzNzkxMQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5NDMwMjE=",
        "type": "Speaker",
        "firstName": "Mr․ Saleh",
        "lastName": "Al Habdan",
        "jobTitle": "Chief Executive Officer",
        "organization": "Jabal Omar Development",
        "photoUrl": "https://static.swapcard.com/public/images/4a955f10bba74d1b8265901dca1a9f18.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzIwMTA0Mg==",
                "title": "Where Tradition Meets Modernity: Case Study by Jabal Omar Development Company",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQ1NjkyOQ==",
                "title": "From Reset to Returns: Deploying Capital in Saudi Arabia’s New Economics",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "GqqxXnJ_iBQ",
                    "id": "RmllbGRWYWx1ZV8yODgxNjE1Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f78048ff-5b01-41c5-8a09-96d80ba1083d",
                    "id": "RmllbGRWYWx1ZV8yODgxNjE2MA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwODMyNDM=",
        "type": null,
        "firstName": "Sohail",
        "lastName": "Alali",
        "jobTitle": "Investment Director",
        "organization": "Rua Al Madinah Holding",
        "photoUrl": "https://static.swapcard.com/public/images/f2e632d58b854d039e018ee9e33dcda1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyOTc2NQ==",
                "title": "From Reform to Investment: Building Global Partnerships in KSA",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "ULHF4ymOXhM",
                    "id": "RmllbGRWYWx1ZV8yODQ5ODc0NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "b8b68e41-a80a-4bfb-b5d8-45c85e39e07f",
                    "id": "RmllbGRWYWx1ZV8yODcxODYwOA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5MjU5NjQ=",
        "type": "Speaker",
        "firstName": "Fadi",
        "lastName": "Alaseri",
        "jobTitle": "Senior Director Education and Capability Building",
        "organization": "Red Sea Global",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/baeb7330bf9c4f5886147e60d2f7601a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg3MTMzNg==",
                "title": "TenX Leadership Talks: Elevating Hospitality Education in the Kingdom",
                "categories": [
                    "Talks",
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzAyNjcwNA==",
                "title": "From Vision to Vocations: Creating the Future Leaders of Saudi Hospitality",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjcxMQ==",
                "title": "FHS Awards",
                "categories": [
                    "Awards"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "awards",
                        "translations": [
                            {
                                "value": "Awards"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "te4ketdlByM",
                    "id": "RmllbGRWYWx1ZV8yODQ0MTUzNg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7b59c262-3985-4a3d-9631-3f8cd6dc4194",
                    "id": "RmllbGRWYWx1ZV8yODQ0MTUzNQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Winner - FHS Leadership Award",
                    "id": "RmllbGRWYWx1ZV8yODc2ODY5OA=="
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0MTk0MzA=",
        "type": null,
        "firstName": "Cleofe",
        "lastName": "Albiso",
        "jobTitle": "Managing Director",
        "organization": "Megaworld Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/165471d32dd148588b82041272d58dbe.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzMyOTQzMQ==",
                "title": "Beyond Paradise: Discovering the Investment Potential of the Philippines",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2Nzk0NQ==",
                "title": "The Philippines Advantage: Private Insights for Strategic Investors",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "KS0ziH4-llo",
                    "id": "RmllbGRWYWx1ZV8yODYyOTk0OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "d775eae1-8f0a-4562-be1d-63cc15237250",
                    "id": "RmllbGRWYWx1ZV8yODYyOTk2MQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2NTkxNzg=",
        "type": "Speaker;Delegate",
        "firstName": "Asif",
        "lastName": "Alidina",
        "jobTitle": "Co-Founder & CEO",
        "organization": "Inntelo AI",
        "photoUrl": "https://static.swapcard.com/public/images/222eff1a66214fe6ab3f772cc6397694.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjQ3NjUyNg==",
                "title": "Start-Up Den",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjcyMQ==",
                "title": "The Human Touch, Enhanced: Using AI to Personalize Every Step of the Hospitality Journey",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "-4LncPEQwUk",
                    "id": "RmllbGRWYWx1ZV8yODAwNDM4Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "0ba5d023-142b-4e67-8d82-3bca09e811fd",
                    "id": "RmllbGRWYWx1ZV8yODAwNDM4NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2NzI5Nzg=",
        "type": null,
        "firstName": "Roger A.",
        "lastName": "Allen",
        "jobTitle": "Group Chief Executive Officer",
        "organization": "RLA Global",
        "photoUrl": "https://static.swapcard.com/public/images/df8a10acfc5f4317b2282f54fcc786bf.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODkyNg==",
                "title": "The Real Deal: Unpacking the Financial Realities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "hrdfDlf2IXI",
                    "id": "RmllbGRWYWx1ZV8yODczNDEzMw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "8c9e43d1-9c13-49a8-92eb-2e5cb41a1c46",
                    "id": "RmllbGRWYWx1ZV8yODczNDEzMg=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1ODg4MDg=",
        "type": null,
        "firstName": "Mariam",
        "lastName": "Almansoori",
        "jobTitle": "Entrepreneur",
        "organization": "Montauk holding group",
        "photoUrl": "https://static.swapcard.com/public/images/c0b145bc053948438a4e32bdc1fbe119.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODkyMw==",
                "title": "From Neighbourhood Gems to Five-Star Plates: How Local Concepts Are Transforming Hotel Dining",
                "categories": [
                    "F&B Experience"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "f-and-b-experience",
                        "translations": [
                            {
                                "value": "F&B Experience"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "NIYCVvE1j5I",
                    "id": "RmllbGRWYWx1ZV8yODcwNzk3MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "9ae082d5-2e57-4f9c-b9df-0b761f67ced8",
                    "id": "RmllbGRWYWx1ZV8yODczNDA3NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEwNDc3NDk=",
        "type": "Speaker",
        "firstName": "Abdulrahman",
        "lastName": "Almoayed",
        "jobTitle": "CO-Founder and Chief Investment and Development Officer",
        "organization": "Golden Tulip MENA / Louvre Hotels Group",
        "photoUrl": "https://static.swapcard.com/public/images/6aae70412edd45ea9dda67db57fcb680.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMw==",
                "title": "Affordable, Scalable, In Demand: The Midscale Hotel Evolution",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTgwNw==",
                "title": "New Cities, New Guests: Capturing Demand with Midscale Hotels in Saudi Arabia",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "HOML05_Xla0",
                    "id": "RmllbGRWYWx1ZV8yODE3MDc4Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "116ac182-652a-402e-8d3a-8d48c891d032",
                    "id": "RmllbGRWYWx1ZV8yODY2MjMzOA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1MzU0ODA=",
        "type": "Speaker",
        "firstName": "Khalid",
        "lastName": "Anib",
        "jobTitle": "Chief Executive Officer",
        "organization": "Abu Dhabi National Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/f012a8ef3ffb4b599f53194f7b4d591f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk4Mw==",
                "title": "Expanding Horizons for Hospitality: Leveraging the Surge in Investment Demand",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzI2NTMwNQ==",
                "title": "Private Sector Leading the Way: Investors and Operators at the Forefront",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "zWNcYHwM7qw",
                    "id": "RmllbGRWYWx1ZV8yODcxODQ0OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "aef2a7fa-5924-4d3d-85c6-c9451e0d3dae",
                    "id": "RmllbGRWYWx1ZV8yODc0ODk5Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIxNDY2OTA=",
        "type": "Speaker",
        "firstName": "Scott",
        "lastName": "Antel",
        "jobTitle": "Founder & Owner",
        "organization": "Scotts FZ LLE",
        "photoUrl": "https://static.swapcard.com/public/images/f8adc05652d6499bb38ba9f43560f107.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk5Mw==",
                "title": "Turning the Tables: Hard Talk of Stephen Sackur on his view of Global Journalism in a Changing World",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAyNA==",
                "title": "Branded Residential is Booming: Upfront Planning for Making Your Project a Success",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTkwMjE5NQ==",
                "title": "Management Agreements and Franchise Models as Viable Strategies in Emerging Markets?",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgyNA==",
                "title": "Legal Structures: Protecting Interests of Investors, Purchasers & Brands",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjQ5MA==",
                "title": "From White Label Operators, Franchising to Traditional Management Agreements  - What is the Future?",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU3NDg1OA==",
                "title": "Top 10 things to know about investing in Hospitality in Africa",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU3NDg2MA==",
                "title": "Ownership Strategies Decoded: Franchise vs. Management Agreements Explained",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYxNjAwNQ==",
                "title": "Loyalty Beyond Stays: Creating Lifetime Value for Branded Residence Owners",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjczNg==",
                "title": "Negotiating with Operators: Mastering Contract Structures for Maximizing Returns",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDM0MzM1NQ==",
                "title": "How do Africa and the GCC fit into the current global turmoil?",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMjk3MzgyMQ==",
                "title": "Charting Franchise Growth: A Franchise Development Workshop for Africa",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk3MzgzOQ==",
                "title": "The Branded Residence Masterclass",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTU0MA==",
                "title": "Who’s in Charge? Structuring Branded Residences for Long-Term Gain",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "United Arab Emirates",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "OvuXvcCqccY",
                    "id": "RmllbGRWYWx1ZV8yODUyNzQ3MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "63bf76cb-d8bc-438d-9646-5201bd32af77",
                    "id": "RmllbGRWYWx1ZV8yODUyNzQ3MA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0MTk5Nzc=",
        "type": null,
        "firstName": "Frauke",
        "lastName": "Aoun",
        "jobTitle": "General Manager, Affini, A Tribute Portfolio Residence",
        "organization": "Business Unit Manage, Marriott International",
        "photoUrl": "https://static.swapcard.com/public/images/39242d4b35f34fb0aab501fc79b69ae9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0MTYzMg==",
                "title": "Empowering Connections: Networking Session",
                "categories": [
                    "Networking"
                ],
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "networking",
                        "translations": [
                            {
                                "value": "Networking"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "kOjx_FI0ZE0",
                    "id": "RmllbGRWYWx1ZV8yODYzMDA1NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7bc818c4-038a-4eaf-8c1c-3a15655cf14b",
                    "id": "RmllbGRWYWx1ZV8yODYzMDA1OA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Branded Residences / Extended stays / Serviced Apartments",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA3OTg1MDI=",
        "type": null,
        "firstName": "Roi",
        "lastName": "Ariel",
        "jobTitle": "General Manager",
        "organization": "Global Sustainable Tourism Council (GSTC)",
        "photoUrl": "https://static.swapcard.com/public/images/52955502235f4a4d9fce3272a4b34cab.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg5NA==",
                "title": "Franchise Models: A Barrier to Sustainable Hospitality—or a Catalyst for Change?",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "17uwv_H1ypo",
                    "id": "RmllbGRWYWx1ZV8yODA1OTk5OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "1e91d03b-e5bb-477f-a434-2c691da97b69",
                    "id": "RmllbGRWYWx1ZV8yODA2MDAwMQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIyODg0ODg=",
        "type": null,
        "firstName": "Rolf",
        "lastName": "Arndt",
        "jobTitle": "Managing Director",
        "organization": "Fairmas Services",
        "photoUrl": "https://static.swapcard.com/public/images/99c83c626289403b8c67d437a503fbce.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcyNw==",
                "title": "Efficiency engine: Automating operations for higher profit margins",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "TtH-Hie2ChM",
                    "id": "RmllbGRWYWx1ZV8yODYxMDMzMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "cbe4cdb6-e890-44fc-8fa9-ae7e15d394cb",
                    "id": "RmllbGRWYWx1ZV8yODYxMDQ2Ng=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDMyOTQ=",
        "type": null,
        "firstName": "Amit",
        "lastName": "Arora",
        "jobTitle": "Chief Operating Officer",
        "organization": "Arada Hospitality and Entertainment",
        "photoUrl": "https://static.swapcard.com/public/images/cb22de0ff76c48e080aa1ad8b770b936.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzcyNw==",
                "title": "Capitalizing on the Alternative Accommodation Boom: Unveiling Realities and Global Trends",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjkwMTU4Mg==",
                "title": "Smart Capital, Young Tenants: The Investment Case for Student Accommodation",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "3MdCah8cBBY",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI3Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "2065f8cc-018c-4a35-83fa-dddabded505a",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI3Ng=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2NzQ2MzE=",
        "type": null,
        "firstName": "Ashank",
        "lastName": "Ashok Kothari",
        "jobTitle": "Managing Director",
        "organization": "Brookfield Advisors India Pvt Ltd",
        "photoUrl": "https://static.swapcard.com/public/images/7aed1b00cc644add9dd105598fc1a698.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg5Mw==",
                "title": "A Global Perspective - From Asia to the Middle East",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "UEWE3vV7vLA",
                    "id": "RmllbGRWYWx1ZV8yODczNTI5Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "23cdc265-b0ae-4574-bd33-302ca39f4081",
                    "id": "RmllbGRWYWx1ZV8yODczNTI5Nw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2MTIwNjc=",
        "type": null,
        "firstName": "Klaus",
        "lastName": "Assmann",
        "jobTitle": "Chief Operating Officer - Middle East, India & Southeast Asia",
        "organization": "United Hospitality Management (UHM)",
        "photoUrl": "https://static.swapcard.com/public/images/3e5007a9387f44aabf1b80d0b8ff94dc.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg5NA==",
                "title": "Franchise Models: A Barrier to Sustainable Hospitality—or a Catalyst for Change?",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "NgasTP538O4",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQxMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e9a61d06-9f24-4948-894f-e0120b1f05d5",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQxMQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3NDgyMTU=",
        "type": null,
        "firstName": "Veronica",
        "lastName": "Asthana",
        "jobTitle": "Managing Director",
        "organization": "miniMAX Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/490188dc3971493081439bfceb8ae8d1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcxMQ==",
                "title": "FHS Awards",
                "categories": [
                    "Awards"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "awards",
                        "translations": [
                            {
                                "value": "Awards"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Winner - Future Leader Award",
                    "id": "RmllbGRWYWx1ZV8yODc2ODcwOA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEyMTM4NDM=",
        "type": "Moderator",
        "firstName": "Bertrand",
        "lastName": "Audrin",
        "jobTitle": "Professor & Human Capital Specialist",
        "organization": "EHL Hospitality Business School",
        "photoUrl": "https://static.swapcard.com/public/images/297ae5e757984e778f1c8eb9c88d5be1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzcyMA==",
                "title": "Company Culture and Relationships as a Competitive Advantage",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2ODAyMw==",
                "title": "From Challenge to Solution: Hospitality Workforce Sprint",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "64ES0G9mqdQ",
                    "id": "RmllbGRWYWx1ZV8yODIzNDY2Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "07894191-7678-482d-8daf-306e505e9193",
                    "id": "RmllbGRWYWx1ZV8yODIzNDY2NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDMwOTk4Mjk=",
        "type": null,
        "firstName": "George",
        "lastName": "Azar",
        "jobTitle": "Chairman & CEO",
        "organization": "Sotheby's International Realty",
        "photoUrl": "https://static.swapcard.com/public/images/5ce3ca51e5c24213854d81ee9ff71ce0.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjc0Mw==",
                "title": "Maximizing Returns, Minimizing Risk: How to Optimize and Protect Value for Investors",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "-t69RQhprxs",
                    "id": "RmllbGRWYWx1ZV8yODg2Mzg1MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "24e2f122-b371-4550-93cb-dbffb8e3f373",
                    "id": "RmllbGRWYWx1ZV8yODg2Mzg1OA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3ODQwMDU=",
        "type": null,
        "firstName": "HE Amadou",
        "lastName": "BA",
        "jobTitle": "Minister of Culture, Handicrafts and Tourism",
        "organization": "Republic of Senegal",
        "photoUrl": "https://static.swapcard.com/public/images/54d9f6af778340caa1d5a5db874d13f0.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMwMA==",
                "title": "Scaling Stories: How African Nations Are Redefining Tourism for Growth",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "nve3e8M4p8Y",
                    "id": "RmllbGRWYWx1ZV8yODc3OTYyMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "457b880a-8dd6-4098-bbf0-cac9b021db20",
                    "id": "RmllbGRWYWx1ZV8yODc3OTY0Mw=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE1NzIxNTk=",
        "type": "Speaker",
        "firstName": "Dominique",
        "lastName": "Backhouse",
        "jobTitle": "Managing Director",
        "organization": "Companion Communications",
        "photoUrl": "https://static.swapcard.com/public/images/ca738570abd94f5189cc2a011cf86559.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg4Ng==",
                "title": "The Future Is East: Mapping the Mindset of Tomorrow’s Asian Tourist",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "RyuJXXWltkI",
                    "id": "RmllbGRWYWx1ZV8yODM0NDAyOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a7ea351e-ed76-4c78-bfa0-cb5599548d7a",
                    "id": "RmllbGRWYWx1ZV8yODM0NDAzMg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Media & PR",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MTI5NDE=",
        "type": null,
        "firstName": "Dilip",
        "lastName": "Bahirwani",
        "jobTitle": "Director, Product and Technology",
        "organization": "Cavendish Maxwell",
        "photoUrl": "https://static.swapcard.com/public/images/ea63cb19892b4de6878ac3c9200e2dbb.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzMwMzMwMQ==",
                "title": "Tokenization & Digital Assets: Transforming the Future of Real Estate with Blockchain",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "8-mh_LQ5oZg",
                    "id": "RmllbGRWYWx1ZV8yODc1MDQwMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "86065193-a7a1-49de-aecb-fae4213ecd4c",
                    "id": "RmllbGRWYWx1ZV8yODc1MDQwMA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3Nzg1NjY=",
        "type": null,
        "firstName": "Abhay",
        "lastName": "Bakaya",
        "jobTitle": "Chief Development Officer",
        "organization": "Starwood Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/724f70ecab08492caba6734fa8521c92.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcwOQ==",
                "title": "Serving the Next Wave of Visitors: Meeting Mixed-Purpose Demand",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "oc-mNLYdiOM",
                    "id": "RmllbGRWYWx1ZV8yODc3Nzk5MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f1bbaa05-b9e7-4f00-bf14-6ad65d0c918a",
                    "id": "RmllbGRWYWx1ZV8yODgyMzIyOQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA0Mjk3MTk=",
        "type": null,
        "firstName": "Dirk",
        "lastName": "Bakker",
        "jobTitle": "Head of EMEA Hotels | EMEA & Global Capital Markets",
        "organization": "Colliers",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/dba7b92b95424a98b3a8c1c4d610d96b.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM2MzY=",
                "title": "The new age consumer",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMzQwODA5OA==",
                "title": "From Resilience to Growth: The European Hospitality Investment Outlook",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjczOTg0OA==",
                "title": "Investors with Influence: How Private Capital Shapes Hospitality Footprints",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "HGIIHUoCqgI",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM3Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "4826d90e-1d69-4c9d-994f-d8204013175b",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM3NQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEwOTQ1Mzg=",
        "type": "Moderator",
        "firstName": "Roy",
        "lastName": "Bannister",
        "jobTitle": "Head of Strategic Partnerships: Africa",
        "organization": "The Bench",
        "photoUrl": "https://static.swapcard.com/public/images/f72506b301d949d2b2401578805f0de3.webp",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjY5NDk0Nw==",
                "title": "Newcomers Welcome",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY4MTQzNA==",
                "title": "Closing Remarks",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc0MTYzNA==",
                "title": "FHS Africa 2026: Advisory Board Meeting",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDM0MzM1NQ==",
                "title": "How do Africa and the GCC fit into the current global turmoil?",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfNDMyMjYyNw==",
                "title": "From First Timers to Power Players : Making the Most of FHS Africa and Speed Networking",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk3Mzc5OA==",
                "title": "Welcome",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwODE5Ng==",
                "title": "One Continent, Many Currencies: Where Fintech Creates Value in Hospitality",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "EHGtBnHlwLE",
                    "id": "RmllbGRWYWx1ZV8yODE4NzUxMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "6671c362-e0ce-43c1-b0e0-46d277ca1675",
                    "id": "RmllbGRWYWx1ZV8yODE4NzUxMA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MDg5NDg=",
        "type": null,
        "firstName": "Fred",
        "lastName": "Barnachawy",
        "jobTitle": "Chief Investment Officer",
        "organization": "DeshCap",
        "photoUrl": "https://static.swapcard.com/public/images/f595547a600845359ef957c2c65b1448.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjkwMTUyNw==",
                "title": "Mitigating Risk, Managing Costs: Hospitality’s Climate-Resilient Playbook",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "nUvRKRcTqWo",
                    "id": "RmllbGRWYWx1ZV8yODc0ODk5OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "8c76b902-e058-4fb3-9930-72fca47ab9fd",
                    "id": "RmllbGRWYWx1ZV8yODc0OTAwNw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Financial Services / Banks",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE3NzE2MzE=",
        "type": "Speaker",
        "firstName": "Philip",
        "lastName": "Barnes",
        "jobTitle": "Chief Executive Officer",
        "organization": "Rotana",
        "photoUrl": "https://static.swapcard.com/public/images/244c9e623bf44f36b30b2b830b094d74.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzY0OQ==",
                "title": "Leading with Purpose: Commitment to People, Planet and Profit",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODA3MQ==",
                "title": "The Future of Global Tourism",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg4Mg==",
                "title": "Hospitality 2050: The Long View from the Top",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "j8F4F9wIFuQ",
                    "id": "RmllbGRWYWx1ZV8yODM4MDIxNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "cd4e76b0-4038-44fa-bd78-82b360d24633",
                    "id": "RmllbGRWYWx1ZV8yODYwNTAzNQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE0NzU0MDc=",
        "type": null,
        "firstName": "Leo",
        "lastName": "Barrit",
        "jobTitle": "Vice President of Sales",
        "organization": "FLYR",
        "photoUrl": "https://static.swapcard.com/public/images/40c9811151ff419b9aee30cb40dc2a47.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcyMg==",
                "title": "How Operators Drive Asset Value: Leveraging Technology, Data & AI to Maximize Owner Returns",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2Nzk1Ng==",
                "title": "TECH Lightning Round",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "ycQX33H0kqE",
                    "id": "RmllbGRWYWx1ZV8yODMwNzE0Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "d8b830e1-d3f9-47d7-b10f-5207e7c29263",
                    "id": "RmllbGRWYWx1ZV8yODMwNzE1Mg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA4MTMxNTU=",
        "type": "Moderator",
        "firstName": "Ben",
        "lastName": "Baseley-Walker",
        "jobTitle": "Founder & Managing Partner",
        "organization": "Andart Global",
        "photoUrl": "https://static.swapcard.com/public/images/d56dd714dff84ff7aaf1c558c1c30e56.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk4MQ==",
                "title": "Expanding Horizons in Tourism Destination Development",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDI0MA==",
                "title": "Insights from Asia: What lessons can be learnt from other fast growing markets around the world?",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTU0Ng==",
                "title": "Building the Future: The Changing Face of Market and Investor Growth in The Maldives",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE0OTEyOQ==",
                "title": "Building the Future: The Changing Face of Market and Investor Growth in The Maldives",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjQxNw==",
                "title": "Planning with Purpose: Integrating Tourism Strategy and Conservation in Destination Development",
                "categories": [
                    "Destination Development",
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzYzNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-development",
                        "translations": [
                            {
                                "value": "Destination Development    "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjUzMzkxMA==",
                "title": "All-Inclusive Reimagined: How Gen Z and Luxury are Redefining the Upscale Travel Experience",
                "categories": [
                    "Luxury, F&B, and Experiential Hospitality"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNzA3NTM4MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "luxury-fandb-and-experiential-hospitality",
                        "translations": [
                            {
                                "value": "Luxury, F&B, and Experiential Hospitality"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY1NDE0OA==",
                "title": "Enhancing Lives Through Innovation: Crafting Visitors' Experiences for Building Resilient, Sustainable Cities",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg4Ng==",
                "title": "The Future Is East: Mapping the Mindset of Tomorrow’s Asian Tourist",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjczMw==",
                "title": "Next-Gen Leisure: The Business of Competitive Socialising",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "v8yZH5f5hk0",
                    "id": "RmllbGRWYWx1ZV8yODA3MDI5OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "0cff48a8-1261-49fd-afc6-07cdbca9f8aa",
                    "id": "RmllbGRWYWx1ZV8yODA3MDI5Nw=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0Mzk3Nzk=",
        "type": null,
        "firstName": "Philippe",
        "lastName": "Bassoul",
        "jobTitle": "Development Director - Hotels and F&B",
        "organization": "Barrière Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/ed4b6e8b05584dd7997fd69b002245ed.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc2NTcyNQ==",
                "title": "From Day to Dusk: How Beach Clubs Redefine F&B, Wellness & Exclusivity",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "SH15Pdz-ZWA",
                    "id": "RmllbGRWYWx1ZV8yODcxODAxNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e521c544-395d-4487-af71-0c9e2ead3393",
                    "id": "RmllbGRWYWx1ZV8yODgwNzUzOQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5NTU3Nzk=",
        "type": "Moderator",
        "firstName": "Peter",
        "lastName": "Bazeli",
        "jobTitle": "Principal and Managing Director",
        "organization": "Weitzman Associates, LLC",
        "photoUrl": "https://static.swapcard.com/public/images/d0bb1f67dd6444ebb02e890ec1dd96d1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Nw==",
                "title": "Making Standalones Work - Bringing the Brand to Life in the Absence of a Co-Located Hotel",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjc0Mw==",
                "title": "Maximizing Returns, Minimizing Risk: How to Optimize and Protect Value for Investors",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "ZocvY-Pyurg",
                    "id": "RmllbGRWYWx1ZV8yODQ1MjYyMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "42e01760-a1fa-46e4-a132-784c58d3c14a",
                    "id": "RmllbGRWYWx1ZV8yODQ1MjYyMA=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIxNTMzMTA=",
        "type": null,
        "firstName": "Mariana",
        "lastName": "Beatriz Zobel De Ayala",
        "jobTitle": "Senior Vice President, Head of Leasing & Hospitality",
        "organization": "Ayala Land, Inc.",
        "photoUrl": "https://static.swapcard.com/public/images/1b9d00961029476e88bd0f8a0cf8c48f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzMyOTQzMQ==",
                "title": "Beyond Paradise: Discovering the Investment Potential of the Philippines",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2Nzk0NQ==",
                "title": "The Philippines Advantage: Private Insights for Strategic Investors",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "BhdbEdCnJ4Q",
                    "id": "RmllbGRWYWx1ZV8yODUyODYxMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "649a0a76-9493-4527-92e5-bc4cc56cec6d",
                    "id": "RmllbGRWYWx1ZV8yODUyODYxNg=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA3MTMyODY=",
        "type": null,
        "firstName": "Moussa",
        "lastName": "Beidas",
        "jobTitle": "Partner and Ideation Lead",
        "organization": "PwC Middle East",
        "photoUrl": "https://static.swapcard.com/public/images/77ea1a1f99fa45beb2a273fe33b1e130.jpeg",
        "speakerOnPlannings": [],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "SU47O770erk",
                    "id": "RmllbGRWYWx1ZV8yODAyMzk0OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7c779804-778e-4aa3-81c6-10fd43495fb8",
                    "id": "RmllbGRWYWx1ZV8yODAyMzk1Mg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA1ODkyMzY=",
        "type": null,
        "firstName": "Rene",
        "lastName": "Beil",
        "jobTitle": "Managing Director, Beaufort Global",
        "organization": "Chairman, MAARAH HOLDINGS & HAMA President Middle East",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d09177f23f4242ccaf9bb61f601bd402.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzODIwNw==",
                "title": "HAMA Workshop",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYxMjI1OA==",
                "title": "A GLOBAL PRESIDENTS FORUM: The Bulls & Bears of Global Capital Markets",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg3NA==",
                "title": "HAMA Asset Management Workshop -  The Future of Hotel Asset Management",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "frznD6klzcg",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM5Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "6451aba2-32c2-42f8-b264-e8ca67bfdce1",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM5Ng=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Asset Manager",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MTI3NzU=",
        "type": null,
        "firstName": "Brian",
        "lastName": "Betel",
        "jobTitle": "Global Head of Direct Assets",
        "organization": "ASG Iberia",
        "photoUrl": "https://static.swapcard.com/public/images/336b941172d64d6788dca904e4fcf089.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzQwODA5OA==",
                "title": "From Resilience to Growth: The European Hospitality Investment Outlook",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "OMDfWl3kAPw",
                    "id": "RmllbGRWYWx1ZV8yODc1MDI5Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a0ee821e-fc7c-47d1-a712-b93012c8e0cd",
                    "id": "RmllbGRWYWx1ZV8yODc1MDI5OQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwNjgxMTY=",
        "type": null,
        "firstName": "Camilla",
        "lastName": "Bevilacqua",
        "jobTitle": "Partner - Tourism and Hospitality",
        "organization": "Arthur D Little",
        "photoUrl": "https://static.swapcard.com/public/images/f374b270344a4c8cb5b677ba069fe0d7.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyOTc2NQ==",
                "title": "From Reform to Investment: Building Global Partnerships in KSA",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "_AQ7ZefUZQg",
                    "id": "RmllbGRWYWx1ZV8yODQ5MzkwMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "55fcc740-61b0-4139-81ca-67200402f025",
                    "id": "RmllbGRWYWx1ZV8yODQ5MzkwMA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0MTkzNTA=",
        "type": "Moderator",
        "firstName": "Anne",
        "lastName": "Biging",
        "jobTitle": "CEO/Founder",
        "organization": "Healing Hotels of the World",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/d0d7c8f10bda43cfba6f92147ecf9fa6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzIxMzQ0MA==",
                "title": "Health Meets Hospitality: Creating Value for People and Planet",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Germany",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "_4j3-vwuKYU",
                    "id": "RmllbGRWYWx1ZV8yODYyOTg5Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7d261aa6-d6d9-46c9-a633-e2db30613ad0",
                    "id": "RmllbGRWYWx1ZV8yODYyOTg5NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1MTk5NDA=",
        "type": null,
        "firstName": "Rami",
        "lastName": "Bissat",
        "jobTitle": "VP Investments and Business Development",
        "organization": "TAIBA",
        "photoUrl": "https://static.swapcard.com/public/images/512f9c276a84475493b0e050191a0230.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyOTc2NQ==",
                "title": "From Reform to Investment: Building Global Partnerships in KSA",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "bv2-R8CNjjk",
                    "id": "RmllbGRWYWx1ZV8yODY4MzYzMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "c1439ec3-4e32-4a33-97f8-c1a8c7da6ff8",
                    "id": "RmllbGRWYWx1ZV8yODY4MzYzNQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2MjY1OTQ=",
        "type": null,
        "firstName": "Felicity",
        "lastName": "Black-Roberts",
        "jobTitle": "Senior Vice President Development EAME",
        "organization": "Hyatt",
        "photoUrl": "https://static.swapcard.com/public/images/9b72ec6954e8456b9715373dfbac854c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg1Ng==",
                "title": "Resilience Strategies: Building Anti-Fragile Hospitality Investments in Resort Destinations",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Europe"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjczOTg0MQ==",
                "title": "Building Tomorrow: The Geographies and Segments Defining Growth",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "bTtL_x69Qbc",
                    "id": "RmllbGRWYWx1ZV8yODcxNjA4Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "fe86f5a6-c44a-4f60-82d7-76d2a67627f7",
                    "id": "RmllbGRWYWx1ZV8yODcxNjA4MQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0MjAxNTU=",
        "type": null,
        "firstName": "Pablo",
        "lastName": "Bofill",
        "jobTitle": "Chief Executive Officer",
        "organization": "Bofill Taller de Arquitectura",
        "photoUrl": "https://static.swapcard.com/public/images/ed7848af322f4b2fa146d6744f591ab4.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0MTYzMQ==",
                "title": "Soundscapes of Hospitality: Albania",
                "categories": [
                    "Country Pavilion Showcase"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Ng==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "country-pavilion-showcase",
                        "translations": [
                            {
                                "value": "Country Pavilion Showcase"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "B_ua7BHdtV4",
                    "id": "RmllbGRWYWx1ZV8yODYzMDA2NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "db01f7c3-a051-4a69-9cd4-086d5777fe53",
                    "id": "RmllbGRWYWx1ZV8yODYzMDA2OQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Architecture & Design",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1NjgwOTQ=",
        "type": null,
        "firstName": "David",
        "lastName": "Bonnet",
        "jobTitle": "Senior Vice President - Finance",
        "organization": "Atlantis Dubai",
        "photoUrl": "https://static.swapcard.com/public/images/7b12a59c085841b182234b1393527d08.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcwOQ==",
                "title": "Serving the Next Wave of Visitors: Meeting Mixed-Purpose Demand",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "UO6bfBzGaA4",
                    "id": "RmllbGRWYWx1ZV8yODcwMzc1OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "bcd6630a-f950-405f-8677-56c2c2613a7d",
                    "id": "RmllbGRWYWx1ZV8yODcwMzc2Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5MjU4NzI=",
        "type": null,
        "firstName": "Jack",
        "lastName": "Bowcott",
        "jobTitle": "Chief Executive Officer",
        "organization": "Goki",
        "photoUrl": "https://static.swapcard.com/public/images/547df0ad5e0d40c2b0dbada53ebd02a7.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcyNw==",
                "title": "Efficiency engine: Automating operations for higher profit margins",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2Nzk1Ng==",
                "title": "TECH Lightning Round",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "3wjWeF4kuL4",
                    "id": "RmllbGRWYWx1ZV8yODQ0MTMwOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "58831e60-7933-417c-af9f-eb4725b6bf6c",
                    "id": "RmllbGRWYWx1ZV8yODgxMDgxNA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MjY1MTY=",
        "type": "Moderator",
        "firstName": "Filip",
        "lastName": "Boyen",
        "jobTitle": "Director",
        "organization": "Filip Boyen ltd",
        "photoUrl": "https://static.swapcard.com/public/images/da2d9358d3ee42ea9155ce6c923cb23c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAzMA==",
                "title": "Socially Responsible Talent Development in Hospitality: A Unified Approach to ESG-Driven Acquisition, Retention, Engagement",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzM5NDA0Mg==",
                "title": "HAMA Asset Management Workshop - The Future of Hotel Asset Management",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "_ct8lzJAfVs",
                    "id": "RmllbGRWYWx1ZV8yODc1OTMzOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "4618af29-a28c-4e68-8d84-4dbbbeebb6fc",
                    "id": "RmllbGRWYWx1ZV8yODc1OTM0MA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0NDgwMDI=",
        "type": null,
        "firstName": "Diego",
        "lastName": "Carrete",
        "jobTitle": "Founder",
        "organization": "Fit Life FZCO",
        "photoUrl": "https://static.swapcard.com/public/images/7e07fc50e3814e448ca4019773e79d54.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczOTMzNw==",
                "title": "Automating the Predictable, Humanizing the Exceptional: Investing in People for the Moments that Matter",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "sos4GsrmKz0",
                    "id": "RmllbGRWYWx1ZV8yODY0NTg0Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "0c9cb7e6-7a26-4a4d-9917-523b703f83a9",
                    "id": "RmllbGRWYWx1ZV8yODY0NTg0OA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0MzkzNDY=",
        "type": "Moderator",
        "firstName": "Judith",
        "lastName": "Cartwright",
        "jobTitle": "CEO & Founder",
        "organization": "Black Coral Consulting",
        "photoUrl": "https://static.swapcard.com/public/images/3b16fcd6ab8a45aa862f310dd575f5a6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg1MTM5Nw==",
                "title": "TenX Leadership Talks: Emergence of Third-Party Operators in Saudi Arabia's Dynamic Market and The Prospects for Growth in Saudi Arabia?",
                "categories": [
                    "Talks",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mg==",
                "title": "Commercially Driven Asset Management in Hospitality: Strategies for Maximizing Returns",
                "categories": [
                    "Hotelisation of Traditional Assets",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2MjE3Mw==",
                "title": "Capital, Coastlines & Control: The Eastern Mediterranean Investment Map for Owners",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Award Presenter",
                    "id": "RmllbGRWYWx1ZV8yODcxNjA1Mw=="
                },
                {
                    "translations": [
                        {
                            "value": "Asset Manager",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA0ODYzNDQ=",
        "type": null,
        "firstName": "Chiara",
        "lastName": "Caruso",
        "jobTitle": "Director National Tourism Fund",
        "organization": "CDP Real Asset SGr SpA",
        "photoUrl": "https://static.swapcard.com/public/images/e11bee9a05f74145b903da206370f6ca.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA0OTU1Mg==",
                "title": "Invest in Italy:  Showcasing Unique Hospitality Projects",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Europe",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "OaUJ6rAel8s",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM4Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "2ecdec50-aa7b-4d64-bfc5-a08b03e426f4",
                    "id": "RmllbGRWYWx1ZV8yODA5NDk2Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2NTc0NzM=",
        "type": null,
        "firstName": "Atul",
        "lastName": "Chopra",
        "jobTitle": "Founder &CEO",
        "organization": "FRESHONTABLE LLC",
        "photoUrl": "https://static.swapcard.com/public/images/1e69fe4d5bdc43d79c3c43ebf01f4ab9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2OTM1OA==",
                "title": "Bridging the Gap: Integrating SDGs into Core Business Strategies for Sustainable Success",
                "categories": [
                    "Restaurant Investment",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODc4MA==",
                "title": "Hospitality with Purpose: Landmark Initiatives Reshaping Inclusion in Hospitality",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "N7v4eiXVxqQ",
                    "id": "RmllbGRWYWx1ZV8yODAwMzY0NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f6c315b3-3103-4b7f-aaa9-4f7c7cea6f8d",
                    "id": "RmllbGRWYWx1ZV8yODAwMzY0Ng=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDExNjc2NDc=",
        "type": "Speaker",
        "firstName": "Hala Matar",
        "lastName": "Choufany",
        "jobTitle": "President Middle East & Africa",
        "organization": "HVS MEA",
        "photoUrl": "https://static.swapcard.com/public/images/3089081b17034fe2a54e72640f0a6a87.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM3MDc=",
                "title": "Arab women driving leadership",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMjk4OQ==",
                "title": "Building Hotels in a Challenging Environment: Navigating Rising Construction Costs, Funding Delays, and Higher Interest Rates for Hotel Development Projects",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg2OTMyMw==",
                "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzcxNw==",
                "title": "Trailblazing Careers in Hospitality: Leading the Way",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY3OTkyNA==",
                "title": "FHS Africa Excellence Award",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjk5NA==",
                "title": "FHS Africa Excellence Award",
                "categories": [
                    "Awards"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "awards",
                        "translations": [
                            {
                                "value": "Awards"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "FwRkaumkd2Y",
                    "id": "RmllbGRWYWx1ZV8yODIxMTgwNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "17421c9c-8713-4b5a-aac3-c89d8f53f8cd",
                    "id": "RmllbGRWYWx1ZV8yODczNDc5Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE0NDg5NjU=",
        "type": null,
        "firstName": "Lizzy",
        "lastName": "Coates",
        "jobTitle": "Associate Director",
        "organization": "Considerate Group",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2a1ec03c26124bfc9c1e43fad329b86d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk3OA==",
                "title": "Measuring Progress: Quantification and Benchmarking of Social & Environmental Factors",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAwNA==",
                "title": "Embracing Sustainability: Paving the Pathway to Net Positive Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjkwMTUyNw==",
                "title": "Mitigating Risk, Managing Costs: Hospitality’s Climate-Resilient Playbook",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "PmSTIst7dyU",
                    "id": "RmllbGRWYWx1ZV8yODI5OTUyMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "9a36fdc3-d5bb-4670-83de-058f2b7eb793",
                    "id": "RmllbGRWYWx1ZV8yODI5OTUyMQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIzMTAwNjI=",
        "type": null,
        "firstName": "Patrick",
        "lastName": "Coodien",
        "jobTitle": "Director",
        "organization": "QE2 Hospitality Academy",
        "photoUrl": "https://static.swapcard.com/public/images/c15dc285eac04582b7ca09ac7dc56e5d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc2ODAyMw==",
                "title": "From Challenge to Solution: Hospitality Workforce Sprint",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "IIsUOVwo6_0",
                    "id": "RmllbGRWYWx1ZV8yODYxODM2Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "b363fa88-0c7d-4753-bbac-817d347d2aeb",
                    "id": "RmllbGRWYWx1ZV8yODYxODQxOQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5MjU0Njc=",
        "type": null,
        "firstName": "Julio",
        "lastName": "Corredor",
        "jobTitle": "Chief Executive Officer",
        "organization": "Shaden Hospitality Company, KSA",
        "photoUrl": "https://static.swapcard.com/public/images/b3243f1862cd48768189907d7097fdbc.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0MTYzOA==",
                "title": "PitchPoint: The FHS Investment Spotlight",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "R_cBpfoyEZU",
                    "id": "RmllbGRWYWx1ZV8yODQzOTg0OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "0135e47c-25da-409b-bc62-acf1ee8a97e9",
                    "id": "RmllbGRWYWx1ZV8yODQzOTk3Mg=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Investor - PitchPoint",
                    "id": "RmllbGRWYWx1ZV8yODQ1NTc1MQ=="
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA4MDA4NDI=",
        "type": null,
        "firstName": "Katrina",
        "lastName": "Craig",
        "jobTitle": "Chief Executive Officer",
        "organization": "Hotel Solutions Partnership",
        "photoUrl": "https://static.swapcard.com/public/images/9154d18030734346912e1837ebc874b0.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzMyOTQzMQ==",
                "title": "Beyond Paradise: Discovering the Investment Potential of the Philippines",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2Nzk0NQ==",
                "title": "The Philippines Advantage: Private Insights for Strategic Investors",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "N463Xmib0Vs",
                    "id": "RmllbGRWYWx1ZV8yODA2MDUyOQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f267479d-5fdd-4591-a5a8-16e712f59922",
                    "id": "RmllbGRWYWx1ZV8yODA5NDk2MA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2NjgxMTc=",
        "type": null,
        "firstName": "Geri",
        "lastName": "Cupi",
        "jobTitle": "Chief Executive Officer & Co-Founder",
        "organization": "Hotelworld AI",
        "photoUrl": "https://static.swapcard.com/public/images/df0eba3d2d924e7aa7a62add9f90bc66.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzM5NDA0Mw==",
                "title": "HAMA Asset Management Workshop - The Future of Hotel Asset Management",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "uL76D5k6KAI",
                    "id": "RmllbGRWYWx1ZV8yODczMTI4Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "d728a9ee-e7ef-4bca-991e-37b9a19c1f2e",
                    "id": "RmllbGRWYWx1ZV8yODczMTI5MA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2NTgzNjY=",
        "type": null,
        "firstName": "Peter",
        "lastName": "Daire",
        "jobTitle": "Senior Executive Advisor, Sports Consulting",
        "organization": "PwC Middle East",
        "photoUrl": "https://static.swapcard.com/public/images/a8743ec73f0f4a3a967b478a22d8e356.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczNDE1MQ==",
                "title": "Beyond the Game: How Immersive Sports and Culture Drive Tourism Growth",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "fENrqEfGH6c",
                    "id": "RmllbGRWYWx1ZV8yODAwNDIxNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "d6a18e7f-221b-4875-8d45-19366115e15a",
                    "id": "RmllbGRWYWx1ZV8yODA5MjIzNA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA4Mzg1MDg=",
        "type": null,
        "firstName": "Sam",
        "lastName": "Dawson",
        "jobTitle": "Managing Partner",
        "organization": "GSIQ",
        "photoUrl": "https://static.swapcard.com/public/images/ce7689f8c04147ca962eb350fdb36d4b.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczNDE1MQ==",
                "title": "Beyond the Game: How Immersive Sports and Culture Drive Tourism Growth",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "WNvNjH9mXXc",
                    "id": "RmllbGRWYWx1ZV8yODA4MjUxNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "0f66597b-4734-4a05-ae91-1a7d9d25f01d",
                    "id": "RmllbGRWYWx1ZV8yODA5MjIzNg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDM1NzU=",
        "type": null,
        "firstName": "Gustavo",
        "lastName": "De Hostos",
        "jobTitle": "Founder and Managing Partner",
        "organization": "FORSITE CREATIVE",
        "photoUrl": "https://static.swapcard.com/public/images/d631315b9e154c4e966a5c063cb3eb34.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAyMg==",
                "title": "Tapping into New F&B Data for Hotels and How it Can Drive Strategy for Decision Making",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg1MDk1Ng==",
                "title": "GRIF Data Report - Using Data to Competition Proof your Business and Invest in the Right Places",
                "categories": [
                    "Talks",
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE0OTk3OA==",
                "title": "Masterplanning Hotels: Driving Strategic Decisions through Sentiment Data",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg3OQ==",
                "title": "Driving strategic decisions making for hotels through bespoke F&B data",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkwNQ==",
                "title": "Hospitality Master Planning and Operational Strategy: A Data-Driven Approach to Value Creation",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "VeBJnk2bHD4",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI4Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5cbd2b35-562f-4a2a-9d71-c7965a7c1496",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI4NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3NzY1Mjg=",
        "type": null,
        "firstName": "HE Márcio",
        "lastName": "de Jesus Lopes Daniel",
        "jobTitle": "Minister of Hotels and Tourism, Republic of Angola",
        "organization": "Representing the African Union Presidency",
        "photoUrl": "https://static.swapcard.com/public/images/86f1db8854e64f709a564a061f64bfe8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMxNg==",
                "title": "Keynote Speeches",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "PXrhsZ2oFYI",
                    "id": "RmllbGRWYWx1ZV8yODc3NzU0OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f467cc95-98b5-4c68-bd39-fb9be8449b9b",
                    "id": "RmllbGRWYWx1ZV8yODgyMTI0MA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3NzY2MzM=",
        "type": "Speaker",
        "firstName": "HE Patricia",
        "lastName": "De Lille",
        "jobTitle": "Minister of Tourism",
        "organization": "Republic of South Africa",
        "photoUrl": "https://static.swapcard.com/public/images/a7e9bcb0c81141618078496f4fe860ec.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjY5OTEzNA==",
                "title": "Welcome Speech",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzI2NTMxMQ==",
                "title": "Tourism Driving Growth and Capital",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "U5VCiEVMrso",
                    "id": "RmllbGRWYWx1ZV8yODc3NzU2OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "1ff2621c-c0d4-43b3-a80c-fdb684c0960f",
                    "id": "RmllbGRWYWx1ZV8yODgwMjkzOQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE4ODgxMTQ=",
        "type": null,
        "firstName": "Giovanni",
        "lastName": "de Niederhäusern",
        "jobTitle": "Senior Vice President of Architecture & Product Design",
        "organization": "Pininfarina",
        "photoUrl": "https://static.swapcard.com/public/images/9d14b8b1515045398dac24a863444730.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjkwMTU4Mw==",
                "title": "Living the Brand: How Branded Residences Drive Culture, Capital, and Communities",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "lxkg0WClr9k",
                    "id": "RmllbGRWYWx1ZV8yODQxMTU4NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7c2b9bda-2ad9-489e-bb94-68773503e03a",
                    "id": "RmllbGRWYWx1ZV8yODQxMTU5NA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Architecture & Design",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2ODYzMzk=",
        "type": null,
        "firstName": "Richard",
        "lastName": "Dean",
        "jobTitle": "Broadcaster, Journalist, Public speaker",
        "organization": null,
        "photoUrl": "https://static.swapcard.com/public/images/4b43db3480b8433aa4be56918fc65293.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMxMQ==",
                "title": "Tourism Driving Growth and Capital",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzI2NTMwMA==",
                "title": "Scaling Stories: How African Nations Are Redefining Tourism for Growth",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyNTMzNQ==",
                "title": "Redefining Tourism Leadership for a New World",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "1A1aepN1kEU",
                    "id": "RmllbGRWYWx1ZV8yODczOTIxNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "ea42a621-aa57-4ce2-a29b-40e8e82fdb6a",
                    "id": "RmllbGRWYWx1ZV8yODczOTIyMA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Architecture & Design",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3Mjk1MDE=",
        "type": null,
        "firstName": "Saif",
        "lastName": "Desouky",
        "jobTitle": "Project Director",
        "organization": "Anax Developments",
        "photoUrl": "https://static.swapcard.com/public/images/80fb741ad3404dcc9c88ecdf566e68d6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzQwMjc2Ng==",
                "title": "Iconic by Design: Crafting The Next  Wave of Luxury Living",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "b_Y2zhtEHwc",
                    "id": "RmllbGRWYWx1ZV8yODc2MDkyMw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e966f88e-5078-46e5-8b59-edd78822ba4c",
                    "id": "RmllbGRWYWx1ZV8yODc2MDkyNw=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA5MjI5OTA=",
        "type": null,
        "firstName": "Eoghan",
        "lastName": "Devlin",
        "jobTitle": "Project Quantity Surveyor",
        "organization": "Compass Project Consulting",
        "photoUrl": "https://static.swapcard.com/public/images/3259a69356834400abb0f4f15cd65e90.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczOTMzOQ==",
                "title": "From Groundbreaking to Grand Opening: Aligning Project Delivery with Operational Success",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "mYBsLGcgkaw",
                    "id": "RmllbGRWYWx1ZV8yODA5OTkzMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "376ad346-ffad-44db-8646-e25968eea625",
                    "id": "RmllbGRWYWx1ZV8yODgzMzIwMw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDAzNTc3NDY=",
        "type": "Moderator",
        "firstName": "Fritz",
        "lastName": "Dickamp",
        "jobTitle": "Managing Director",
        "organization": "Studio  49",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2036c6d15c0647e4ad00d055e433e9be.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Mg==",
                "title": "How will you 'Lead The Change'?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMjk5MQ==",
                "title": "Embracing the Era of the Digital Traveler: Transforming Hotel Operations for the Future",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTU3NjUxNw==",
                "title": "EAHM Leadership Series - Creating Harmony: Aligning People, Planet, and Future Growth in Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc5MjI0NA==",
                "title": "Welcome to the Data Talks",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5MDk1Nw==",
                "title": "Welcome to the Digital Talks",
                "categories": [
                    "Talks",
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgwNw==",
                "title": "Back to Basics: Addressing Key Bottlenecks in Hospitality Innovation Before Advancing to Advanced Technologies",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQxOA==",
                "title": "Cyber Resilience in Hospitality: Future-proofing your Data",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg5OQ==",
                "title": "TenX Leadership Talk: Driving Change Across a Continent",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkyMw==",
                "title": "From Neighbourhood Gems to Five-Star Plates: How Local Concepts Are Transforming Hotel Dining",
                "categories": [
                    "F&B Experience"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "f-and-b-experience",
                        "translations": [
                            {
                                "value": "F&B Experience"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "JYAcXSmA-HI",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM1NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f27004cf-01dd-4a7f-87b0-6f5897bc59b3",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM1NA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0Mzk0Mjg=",
        "type": null,
        "firstName": "Sarah",
        "lastName": "Duignan",
        "jobTitle": "Director, Client Relationships",
        "organization": "STR, a CoStar Group Company",
        "photoUrl": "https://static.swapcard.com/public/images/d6e9b1be93184e2e860029c865367c33.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU4Mw==",
                "title": "What Are the Numbers Telling Us? A Look at Hotel Performance From a Global Perspective",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg3Mg==",
                "title": "Beyond the Peak:  What the Numbers Say About the Next Chapter in Hospitality",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "w40QOwiRXNk",
                    "id": "RmllbGRWYWx1ZV8yODcxNzY5OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e8f64bed-9ce4-4897-b45c-318fa8512bd7",
                    "id": "RmllbGRWYWx1ZV8yODcxNzY5OA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE0NzU1NDQ=",
        "type": null,
        "firstName": "Maarten",
        "lastName": "Edelman",
        "jobTitle": "VP International Sales",
        "organization": "dailypoint",
        "photoUrl": "https://static.swapcard.com/public/images/995c085e78414a0086ffa5ea8f01381d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjgxNDczNA==",
                "title": "TECH Lightning Round",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjcyMg==",
                "title": "How Operators Drive Asset Value: Leveraging Technology, Data & AI to Maximize Owner Returns",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Wh3kfNjgFe8",
                    "id": "RmllbGRWYWx1ZV8yODMwNzE4MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "c4f0efb2-3a37-4d77-9cde-8e72d71a885b",
                    "id": "RmllbGRWYWx1ZV8yODMwNzE4Nw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDExMjI4NjU=",
        "type": "Moderator",
        "firstName": "Catherine",
        "lastName": "Edwards",
        "jobTitle": "Chief Growth Officer",
        "organization": "QUO Global",
        "photoUrl": "https://static.swapcard.com/public/images/56b5c581532147f6a330a6a89310b1b3.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg2OTMyMw==",
                "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – An unbiased Perspective",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzk2MQ==",
                "title": "The Future of Wellness: Brand Challenges and Opportunities",
                "categories": [
                    "Wellness & Medical Tourism"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "wellness-and-medical-tourism",
                        "translations": [
                            {
                                "value": "Wellness & Medical Tourism"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyOTQ2MA==",
                "title": "Branding with Culture: Forming a Dynamic Ecosystem that Resonates and Connects",
                "categories": [
                    "Branding & Culture"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branding-and-culture",
                        "translations": [
                            {
                                "value": "Branding & Culture"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjQwNA==",
                "title": "Branding Saudi: Forming an Authentic Identity in a Global Market",
                "categories": [
                    "Branding & Culture",
                    "Focus on Saudi Arabia"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branding-and-culture",
                        "translations": [
                            {
                                "value": "Branding & Culture"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYxMDAxOA==",
                "title": "Spotlight on Vietnam",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMA==",
                "title": "From Mass to Class: The Upscale Shift in the All-Inclusive Hospitality Market",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjkwMTU4Mg==",
                "title": "Smart Capital, Young Tenants: The Investment Case for Student Accommodation",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "p6yABVpOV8Q",
                    "id": "RmllbGRWYWx1ZV8yODE5Nzk5NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e0e4444e-19ff-477a-851a-153119f8f001",
                    "id": "RmllbGRWYWx1ZV8yODE5Nzk5Mw=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5MzAyNTI=",
        "type": null,
        "firstName": "Helena",
        "lastName": "Egan",
        "jobTitle": "Senior Director of Global Industry Relations",
        "organization": "World Sustainable Hospitality Alliance",
        "photoUrl": "https://static.swapcard.com/public/images/2c5e6c44789d4d099cf6257936ecfe0d.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjkwMTUyNw==",
                "title": "Mitigating Risk, Managing Costs: Hospitality’s Climate-Resilient Playbook",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "zlN_BuURjQE",
                    "id": "RmllbGRWYWx1ZV8yODgxMjQ1NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "580f5258-0e41-40bd-89cf-6f1245c66dbd",
                    "id": "RmllbGRWYWx1ZV8yODgxMjU4Ng=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1ODg3ODM=",
        "type": null,
        "firstName": "Laura",
        "lastName": "Eggleton",
        "jobTitle": "General Manager",
        "organization": "Hotel Indigo Dubai Downtown",
        "photoUrl": "https://static.swapcard.com/public/images/76d70213f0bc4155bd76c1ae3c18911b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcxMQ==",
                "title": "FHS Awards",
                "categories": [
                    "Awards"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "awards",
                        "translations": [
                            {
                                "value": "Awards"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "R2MUmWmIvWg",
                    "id": "RmllbGRWYWx1ZV8yODcxODUzNw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f5b3725f-8ee6-4d48-935a-2efe479329c6",
                    "id": "RmllbGRWYWx1ZV8yODc2ODk4Mg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1ODg4MjU=",
        "type": null,
        "firstName": "Heba",
        "lastName": "El Dessouky",
        "jobTitle": "Hospitality Development Director",
        "organization": "City Edge Developments",
        "photoUrl": "https://static.swapcard.com/public/images/28ca84dbfbfd4690a0915dc7820e7c40.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzUzMjk4MA==",
                "title": "Egypt’s North Coast: From Seasonal Escape to Year-Round Destination",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "-__45fjnsVo",
                    "id": "RmllbGRWYWx1ZV8yODcxODU4NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "98ab6715-8cd0-40c5-b920-7133e15aafcd",
                    "id": "RmllbGRWYWx1ZV8yODgxMDc5MQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDMxNTc=",
        "type": "Moderator",
        "firstName": "Oussama",
        "lastName": "El Kadiri",
        "jobTitle": "Partner - Head of Hospitality, Tourism & Leisure - MENA",
        "organization": "Knight Frank MENA",
        "photoUrl": "https://static.swapcard.com/public/images/b06bf060eee04b5fb2379c8ea3f919fd.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjQ3NjQxOA==",
                "title": "Balancing Growth: Unlocking the Potential of Mid-Market Hospitality in Saudi Arabia's Luxury Landscape",
                "categories": [
                    "Focus on Saudi Arabia",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ5NTE1OQ==",
                "title": "Closing the Gap: Boosting Conversion from Hotel Signings to Openings in Africa",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY4OTEzMQ==",
                "title": "Tourism Trends: North Africa",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ5NTc5Mw==",
                "title": "Branded Residences vs. Shared Ownership: Navigating the Future of Hospitality Real Estate",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMw==",
                "title": "Affordable, Scalable, In Demand: The Midscale Hotel Evolution",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTc3Mg==",
                "title": "From Ambition to Execution: The Playbook for Growth in Saudi Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTgwNw==",
                "title": "New Cities, New Guests: Capturing Demand with Midscale Hotels in Saudi Arabia",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "United Arab Emirates",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "craIpLmT0Fw",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI2NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "2d283205-2e4b-4ab1-a9cd-c68cb6497039",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI2NA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE0NTIyNDI=",
        "type": null,
        "firstName": "Amr",
        "lastName": "El Nady",
        "jobTitle": "Head of Hotels & Hospitality MEA and Managing Director, Global Hotel Desk",
        "organization": "JLL",
        "photoUrl": "https://static.swapcard.com/public/images/982df6695622462cb476e3a7cc2650db.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAxNQ==",
                "title": "Hotel Transactions: Insights for 2023",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg0MjgwMg==",
                "title": "Diversifying the Economy: Strategies for Attracting Foreign Direct Investment and Achieving Vision 2030 Objectives through Innovative Funding Mechanisms",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzY0Nw==",
                "title": "Emergence of Real Estate Investment Trusts in the Middle East",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc0NDM5Ng==",
                "title": "The Middle East Playbook: How to Enter and Succeed in Hospitality Investment",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg3NQ==",
                "title": "Mapping the Money: Tracking Smart Capital in a Changing Hospitality Landscape",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "GDfdJdip0LY",
                    "id": "RmllbGRWYWx1ZV8yODMwMDE1Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f7a203ce-02f7-4a52-a3a5-eebb8330b772",
                    "id": "RmllbGRWYWx1ZV8yODMwMDE1Mg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0OTUyNDk=",
        "type": null,
        "firstName": "Selim",
        "lastName": "El Zein",
        "jobTitle": "Vice President - Head of Asset Management & Investments",
        "organization": "Deyaar Development PJSC",
        "photoUrl": "https://static.swapcard.com/public/images/210f46e7564649758cb2d6105c085e2c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczOTg0OA==",
                "title": "Investors with Influence: How Private Capital Shapes Hospitality Footprints",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "eohUlLU6ODo",
                    "id": "RmllbGRWYWx1ZV8yODcxODM3MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "0b94268b-db74-49f9-a26e-4bd2eba607f6",
                    "id": "RmllbGRWYWx1ZV8yODc0OTgxMQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5MzAzMzE=",
        "type": "Speaker",
        "firstName": "Tarek",
        "lastName": "Elkady",
        "jobTitle": "Vice President Investments",
        "organization": "Osoolre",
        "photoUrl": "https://static.swapcard.com/public/images/cc513b964f454364b47f376cb3d19b0e.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyOTc2NQ==",
                "title": "From Reform to Investment: Building Global Partnerships in KSA",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "nFsCHBMSlRk",
                    "id": "RmllbGRWYWx1ZV8yODgxMjQ2OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e184f653-92ce-4834-9b5b-1ceec0b6ba61",
                    "id": "RmllbGRWYWx1ZV8yODgxMjQ2OA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2NDU0ODM=",
        "type": "Speaker",
        "firstName": "Larissa",
        "lastName": "Esser",
        "jobTitle": "Senior Advisor, Representative to the GCC",
        "organization": "Colliers",
        "photoUrl": "https://static.swapcard.com/public/images/17a8fd55607b40008b6b49ac4cde22e7.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA1MTE4Nw==",
                "title": "Spotlight European Hospitality: 2024, the Turning Point for Transactional Activity",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Europe",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0Nw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-europe",
                        "translations": [
                            {
                                "value": "Focus on Europe "
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg5Mw==",
                "title": "A Global Perspective - From Asia to the Middle East",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "4r31CIgruUk",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQzMw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "9731c08b-7a58-44d2-af66-914fb2320746",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQzMg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5MjgyNzQ=",
        "type": null,
        "firstName": "Olivier",
        "lastName": "Eynard",
        "jobTitle": "Chief Operating Officer",
        "organization": "RIKAS Hospitality Group",
        "photoUrl": "https://static.swapcard.com/public/images/f4549ec46c6640749656bcb366aa8224.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc2NTcyNQ==",
                "title": "From Day to Dusk: How Beach Clubs Redefine F&B, Wellness & Exclusivity",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "GjW1d-0oTqg",
                    "id": "RmllbGRWYWx1ZV8yODgxMjExOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "c3bda3d5-ef8f-4c39-811d-f45562ff5852",
                    "id": "RmllbGRWYWx1ZV8yODgxMjEyMQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1MTA1MTc=",
        "type": "Speaker",
        "firstName": "Ayman",
        "lastName": "Ezzeddine",
        "jobTitle": "Senior Director Development",
        "organization": "Radisson Hotel Group",
        "photoUrl": "https://static.swapcard.com/public/images/29bcc24eaa2e4b15877b20aaf9a571ae.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjQ3NjQxOA==",
                "title": "Balancing Growth: Unlocking the Potential of Mid-Market Hospitality in Saudi Arabia's Luxury Landscape",
                "categories": [
                    "Focus on Saudi Arabia",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkwOA==",
                "title": "Investing in Mixed-Use Real Estate: Strategies for Maximizing Value in Modern Developments",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTgwNw==",
                "title": "New Cities, New Guests: Capturing Demand with Midscale Hotels in Saudi Arabia",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "zcjXjXS1V4M",
                    "id": "RmllbGRWYWx1ZV8yODcxODQyNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "88918320-f85e-437d-8c32-81f64e7bb8f5",
                    "id": "RmllbGRWYWx1ZV8yODcxODQyMw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwNzUwMjE=",
        "type": null,
        "firstName": "Kris",
        "lastName": "Fade",
        "jobTitle": "Founder, Fade Fit",
        "organization": "Radio and TV Personality, Entrepreneur",
        "photoUrl": "https://static.swapcard.com/public/images/a54243594e98473fa79e91c0b089651f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjk5NDU0NQ==",
                "title": "25 Jump Street: Shaping Dubai’s Next Culinary, Bar, Art & Culture Destination",
                "categories": [
                    "F&B Experience"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "f-and-b-experience",
                        "translations": [
                            {
                                "value": "F&B Experience"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Nbzu-uzPCOA",
                    "id": "RmllbGRWYWx1ZV8yODQ5NTkyNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "9159fb37-d8b6-48b1-8647-fba2235784b2",
                    "id": "RmllbGRWYWx1ZV8yODQ5NTkzMg=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDMwMDI3NTE=",
        "type": null,
        "firstName": "Varisha",
        "lastName": "Faisal",
        "jobTitle": null,
        "organization": null,
        "photoUrl": "https://static.swapcard.com/public/images/8338db8f604146a7b3a81d266ea675e8.jpeg",
        "speakerOnPlannings": [],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Young leader",
                    "id": "RmllbGRWYWx1ZV8yODgyOTMwOA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3NzM0OTQ=",
        "type": null,
        "firstName": "Omar",
        "lastName": "Faisal Issa",
        "jobTitle": "Vice President Strategy",
        "organization": "TAIBA",
        "photoUrl": "https://static.swapcard.com/public/images/d3dfb76b5acf4cc19cad6befd21e7da1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc4MDE2OA==",
                "title": "Future of Hospitality Concepts and Operating Models",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "7QFbivoQie4",
                    "id": "RmllbGRWYWx1ZV8yODc3NzA0NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a6975155-8501-48af-8154-ae31f8186bc9",
                    "id": "RmllbGRWYWx1ZV8yODgwOTMyMQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwNzQ5OTA=",
        "type": null,
        "firstName": "Rabih",
        "lastName": "Fakhreddine",
        "jobTitle": "Founder & Group CEO",
        "organization": "7 Management",
        "photoUrl": "https://static.swapcard.com/public/images/3cd1f078955148f2b57f73d714b5aaa6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjk5NDU0NQ==",
                "title": "25 Jump Street: Shaping Dubai’s Next Culinary, Bar, Art & Culture Destination",
                "categories": [
                    "F&B Experience"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "f-and-b-experience",
                        "translations": [
                            {
                                "value": "F&B Experience"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "fTQNzM72zr4",
                    "id": "RmllbGRWYWx1ZV8yODQ5NTkyMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "727ada63-59c1-4ba7-af47-1c802d921089",
                    "id": "RmllbGRWYWx1ZV8yODYzMDAwOQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Restaurant Operator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwMzEzOTk=",
        "type": "Speaker",
        "firstName": "Hamza",
        "lastName": "Farooqui",
        "jobTitle": "Founder & CEO",
        "organization": "Millat Group",
        "photoUrl": "https://static.swapcard.com/public/images/4647f1b3e985405383b25e68d832ede9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyOTY4MA==",
                "title": "Assessing the Significance and Economic Viability of International Brands in African Destinations",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzczNg==",
                "title": "Insights into Africa's Dynamic Investment Landscape",
                "categories": [
                    "Focus on Africa",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY1Mzc0Mg==",
                "title": "Luxury Hospitality as a Catalyst for Urban Renewal",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzI2NTMwOQ==",
                "title": "Capital Meets Culture: Financing Africa’s Tourism Transformation",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg4OQ==",
                "title": "De-Risking Africa: Building Trust and Track Records for Institutional Investment",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk3MzgwMA==",
                "title": "From Capital Markets to Ownership Models: De-Risking and Scaling Hospitality Investment in Africa",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDM0MTYwOQ==",
                "title": "Career Journeys & Lessons from the Industry",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTU1Nw==",
                "title": "Investing into the Kingdom: Connecting Global Capital with Saudi’s High-End Hospitality Pipeline",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "SO_JcgkpNRg",
                    "id": "RmllbGRWYWx1ZV8yODQ4NjIwNg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f8d605a8-686e-4792-ba72-6b42941dcc18",
                    "id": "RmllbGRWYWx1ZV8yODQ4NjIwNQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE3NTYzMDg=",
        "type": "Speaker",
        "firstName": "Rabih",
        "lastName": "Feghali",
        "jobTitle": "Hospitality Visionary",
        "organization": "Parsli",
        "photoUrl": "https://static.swapcard.com/public/images/1719e57690bc4e9d85ef68319e3d2b6b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Nw==",
                "title": "The BIG Project Pitch: International Hospitality Projects Revealed",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkxMw==",
                "title": "“Hybrid Lives” – The Big Shift and Vision of Future Spaces",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "oe5eL_Lt0pA",
                    "id": "RmllbGRWYWx1ZV8yODM3ODg3Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f39b4801-1418-4881-bebe-170a53489899",
                    "id": "RmllbGRWYWx1ZV8yODM3ODg5MA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3Nzc2MzQ=",
        "type": null,
        "firstName": "Liam",
        "lastName": "Findlay",
        "jobTitle": "Chief Executive Officer",
        "organization": "Miral Destinations",
        "photoUrl": "https://static.swapcard.com/public/images/97095f9e330b4653816b5821667bf9c2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMwOQ==",
                "title": "Capital Meets Culture: Financing Africa’s Tourism Transformation",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "BrqYiaX4JLM",
                    "id": "RmllbGRWYWx1ZV8yODc3Nzc0MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7b62b4c7-80a3-4157-a1e2-5b5055c6d172",
                    "id": "RmllbGRWYWx1ZV8yODc3NzczOQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5MDg0NTM=",
        "type": null,
        "firstName": "Sean",
        "lastName": "Fitzpatrick",
        "jobTitle": "Chief Experience Officer",
        "organization": "Tatler Asia",
        "photoUrl": "https://static.swapcard.com/public/images/02101c0c710a4b58b6a11d1bef6e5176.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg4Ng==",
                "title": "The Future Is East: Mapping the Mindset of Tomorrow’s Asian Tourist",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "4-GNWmjD_es",
                    "id": "RmllbGRWYWx1ZV8yODQxOTgzMA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5a231d6d-8416-413d-a54e-941ff5a68d1a",
                    "id": "RmllbGRWYWx1ZV8yODQxOTgzNA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5ODk0Njk=",
        "type": null,
        "firstName": "H.E Siandou",
        "lastName": "Fofana",
        "jobTitle": "Minister of Tourism and Leisure",
        "organization": "Republic of Côte d’Ivoire",
        "photoUrl": "https://static.swapcard.com/public/images/7055c634cd9c4c2dbd4454e585a19297.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMwMA==",
                "title": "Scaling Stories: How African Nations Are Redefining Tourism for Growth",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "WRWu7lJivqE",
                    "id": "RmllbGRWYWx1ZV8yODgyNjcxMw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "3bfffd1a-5345-4e9b-8d2e-133b7febc1fd",
                    "id": "RmllbGRWYWx1ZV8yODgyNjcxNg=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE4MTEzOTk=",
        "type": null,
        "firstName": "Marco",
        "lastName": "G Malacrida",
        "jobTitle": "Founder",
        "organization": "Italia Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/30dd69a3649242ff91ab5f717dcb9146.webp",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjk5NDQzOA==",
                "title": "From Heritage to Growth: New Hospitality Investment Hotspots in Italy",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "vtGeMdRPIJY",
                    "id": "RmllbGRWYWx1ZV8yODM4NTk1Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "8fae8ed8-e8e8-4a56-8178-9c2876cce20d",
                    "id": "RmllbGRWYWx1ZV8yODM4NTk1Ng=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MTY3MTE=",
        "type": null,
        "firstName": "Lola",
        "lastName": "Gamester",
        "jobTitle": "Founder",
        "organization": "Rook AI",
        "photoUrl": "https://static.swapcard.com/public/images/9b76c1c97f7f432c82ec7034092332b0.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0MTYzNQ==",
                "title": "PitchPoint: The FHS Investment Spotlight",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Xp6v28ht4mU",
                    "id": "RmllbGRWYWx1ZV8yODc1NTQ5Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a1efc5a6-3741-4bb6-93d1-bc4695e3374d",
                    "id": "RmllbGRWYWx1ZV8yODc1NTUwNQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Tech Startup - PitchPoint",
                    "id": "RmllbGRWYWx1ZV8yODc5OTM3Mw=="
                },
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA4MDA4OTk=",
        "type": null,
        "firstName": "Giuliano",
        "lastName": "Gasparini, FRICS, CRE, HAMA, IoH, CHIA",
        "jobTitle": "Head of Hospitality Asset Management",
        "organization": "WASL Group",
        "photoUrl": "https://static.swapcard.com/public/images/f3de406246bb44c0903b1f8c403900a8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0NDM5Ng==",
                "title": "The Middle East Playbook: How to Enter and Succeed in Hospitality Investment",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzMwMzMwMQ==",
                "title": "Tokenization & Digital Assets: Transforming the Future of Real Estate with Blockchain",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "wR2kzuMC5q4",
                    "id": "RmllbGRWYWx1ZV8yODA2MDU0Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7512bf37-fb84-45c1-889e-36af1cdbf392",
                    "id": "RmllbGRWYWx1ZV8yODA2MDU0Ng=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk2MDA3NjI=",
        "type": "Speaker",
        "firstName": "Marinos",
        "lastName": "Giannopoulos",
        "jobTitle": "Chief Executive Officer",
        "organization": "Enterprise Greece",
        "photoUrl": "https://static.swapcard.com/public/images/f64b0852d09c48dcb39f24586ec27376.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMzM2Mg==",
                "title": "Building Destinations Together: The Impact of Public-Private Partnerships",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "aszwync6Gn8",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMyOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "9fb26afb-24b6-4304-9d3f-1eddadef48ce",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMyNw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Government / Tourism Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0Mzk4MzY=",
        "type": null,
        "firstName": "Chiara",
        "lastName": "Gibertini",
        "jobTitle": "𝗕𝗿𝗮𝗻𝗱𝗲𝗱 𝗥𝗲𝘀𝗶𝗱𝗲𝗻𝘁𝗶𝗮𝗹 𝗗𝗲𝘃𝗲𝗹𝗼𝗽𝗺𝗲𝗻𝘁 𝗠𝗮𝗻𝗮𝗴𝗲𝗿",
        "organization": "Pininfarina SpA",
        "photoUrl": "https://static.swapcard.com/public/images/1347749fc5954d0189168c41a90867f2.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjk5NDQzOA==",
                "title": "From Heritage to Growth: New Hospitality Investment Hotspots in Italy",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "SBzf09mqj6I",
                    "id": "RmllbGRWYWx1ZV8yODcxODA4Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "8c6c821b-9b3d-4452-a34e-bbb6c794835e",
                    "id": "RmllbGRWYWx1ZV8yODczNDAzMQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Architecture & Design",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0Mzk2NzA=",
        "type": null,
        "firstName": "Angelo",
        "lastName": "Goggioli",
        "jobTitle": "Global Key Account Director Hospitality & Residential",
        "organization": "Technogym",
        "photoUrl": "https://static.swapcard.com/public/images/5837ef9318044d74a5f9af4d02a3df27.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMg==",
                "title": "Wellbeing Ecosystems: Building Destinations Around Health and Harmony",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "helm8kzCMvw",
                    "id": "RmllbGRWYWx1ZV8yODcxMzQ2OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7ae01381-9e75-4319-8eac-75ad6148da4e",
                    "id": "RmllbGRWYWx1ZV8yODczNTMyNA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Wellness / Spa",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0MTkyMTk=",
        "type": null,
        "firstName": "Blendi",
        "lastName": "Gonxhja",
        "jobTitle": "Minister of Tourism, Culture and Sports",
        "organization": "Ministry of Tourism, Culture and Sports",
        "photoUrl": "https://static.swapcard.com/public/images/9bcae0225f66460696ebbdb8f8f5ebd4.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0MTYzMQ==",
                "title": "Soundscapes of Hospitality: Albania",
                "categories": [
                    "Country Pavilion Showcase"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Ng==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "country-pavilion-showcase",
                        "translations": [
                            {
                                "value": "Country Pavilion Showcase"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "jKT54AV1jjg",
                    "id": "RmllbGRWYWx1ZV8yODYyOTg4Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7ed4c5b7-f4a0-4dff-8ffb-121fc9628c4e",
                    "id": "RmllbGRWYWx1ZV8yODYyOTg4NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5NjAxMTA=",
        "type": null,
        "firstName": "Dr. Senthil",
        "lastName": "Gopinath",
        "jobTitle": "Chief Executive Officer, ICCA",
        "organization": "Chair, Events Industry Council",
        "photoUrl": "https://static.swapcard.com/public/images/b6bc53d922f64a3c8db38dfb01a965d1.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMwOQ==",
                "title": "Capital Meets Culture: Financing Africa’s Tourism Transformation",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "XR1Sst9Yjvk",
                    "id": "RmllbGRWYWx1ZV8yODgyMTg2Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "6e4dc090-1664-42fc-853a-17a01aba0ca5",
                    "id": "RmllbGRWYWx1ZV8yODgyMTg2Ng=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwMTU3MzI=",
        "type": null,
        "firstName": "Chris",
        "lastName": "Graham",
        "jobTitle": "Managing Director",
        "organization": "Graham Associates",
        "photoUrl": "https://static.swapcard.com/public/images/8ab313175ef64617a7acc3573d231887.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM3MTQ=",
                "title": "The prospects & benefits of branded residential development in the Kingdom",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMjc4MjU5MQ==",
                "title": "The Misconception Myth: Why Branded Residences Aren’t Just Hotels with Keys",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "NTbNGTWsjOM",
                    "id": "RmllbGRWYWx1ZV8yODQ3ODMxNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "eeabbc0d-1ee9-4f40-8f44-d39e813d6908",
                    "id": "RmllbGRWYWx1ZV8yODQ3ODMyOQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2Nzc0MjU=",
        "type": "Speaker",
        "firstName": "Olivier",
        "lastName": "Granet",
        "jobTitle": "Managing Partner & Co-CEO",
        "organization": "Kasada Capital Management",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/32a23f374acb499983657003a1453830.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAxMQ==",
                "title": "Strategic Financing of Hospitality Assets: Navigating Uncertainty and Rising Interest Rates for Optimal Funding Solutions",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAwMzE3MQ==",
                "title": "Fireside Chat: How to Align Tourism Strategies Across Key African Markets for Sustainable Growth: From an Investor's Perspective",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU3NDg1NQ==",
                "title": "Investor Council - Closed Door Session",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY4MTQyOQ==",
                "title": "From Potential to Prosperity: Africa’s Tourism Growth and the Role of Public-Private Synergy",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg3NQ==",
                "title": "Mapping the Money: Tracking Smart Capital in a Changing Hospitality Landscape",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDMzMDY0OA==",
                "title": "A New Platform for Progress: Africa Hospitality Investor's Council",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "South Africa",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Xewf8b8hAng",
                    "id": "RmllbGRWYWx1ZV8yODAxMzE4Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "0eeee266-975c-4cf7-b27e-e992ff795d7a",
                    "id": "RmllbGRWYWx1ZV8yODAxMzE4NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA1OTY3Mzc=",
        "type": "Moderator",
        "firstName": "Gemma",
        "lastName": "Greenwood",
        "jobTitle": "Director, Content Inc.",
        "organization": "Moderator, Emcee, media training specialist, editor and communications consultant",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/28f93f5e7809429484223268fc818522.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAxOA==",
                "title": "Welcome to FHS Intelligence Talks",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTU4MDc0OQ==",
                "title": "Women Belong in the Kitchen: Pursuing Gender Equity in the Culinary World",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTU4MDc0OA==",
                "title": "Closing Remarks",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAyOQ==",
                "title": "The Opportunity for Luxury Brand and Hotel Partnerships: Exploring Demand Trends and Collaboration Success Factors",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU3NQ==",
                "title": "Welcome Back",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA4ODY3OQ==",
                "title": "From Search to Stay: Enhancing Booking Tech for a Seamless Guest Journey",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc0MTYzMQ==",
                "title": "Soundscapes of Hospitality: Albania",
                "categories": [
                    "Country Pavilion Showcase"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Ng==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "country-pavilion-showcase",
                        "translations": [
                            {
                                "value": "Country Pavilion Showcase"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzUzMjk3OQ==",
                "title": "From Heritage to Growth: New Hospitality Investment Hotspots in Italy",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk5NDQzOA==",
                "title": "From Heritage to Growth: New Hospitality Investment Hotspots in Italy",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "KGMFkCpvQ5I",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQwMA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "00e1a38f-7ad0-410f-8368-ec94bd96501b",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM5OQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0Mzk4NzU=",
        "type": "Speaker",
        "firstName": "Paul",
        "lastName": "Griep",
        "jobTitle": "Founder, Sustainable Hospitality Challenge - Director Industry Relations and Alumni",
        "organization": "Hotelschool the Hague",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/e83e40532f97441986d87e699f53d5e6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAzOQ==",
                "title": "Sustainable Hospitality Challenge",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAwNQ==",
                "title": "Sustainable Hospitality Challenge - The Hospitality Leaders of Tomorrow Reimagining our Industry",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYwNw==",
                "title": "Sustainable Hospitality Challenge - The Hospitality Leaders of Tomorrow Reimagining our Industry",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjczOTMzNw==",
                "title": "Automating the Predictable, Humanizing the Exceptional: Investing in People for the Moments that Matter",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Y8FveMlAKCs",
                    "id": "RmllbGRWYWx1ZV8yODY4MjA5NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "48890e92-2607-49ca-9635-d241bb0c58f2",
                    "id": "RmllbGRWYWx1ZV8yODY4MjA5Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgzNjI3OQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1NTc1NTE=",
        "type": null,
        "firstName": "Michael",
        "lastName": "Grieve",
        "jobTitle": "Chief Brand Officer",
        "organization": "Jumeirah",
        "photoUrl": "https://static.swapcard.com/public/images/c32be1e0c117481b8375cc8c25118b46.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcwOQ==",
                "title": "Serving the Next Wave of Visitors: Meeting Mixed-Purpose Demand",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "R6sHTI0rAB0",
                    "id": "RmllbGRWYWx1ZV8yODY5Nzc0OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a50f34ad-3bda-42bd-abdc-38c9b57fe749",
                    "id": "RmllbGRWYWx1ZV8yODY5Nzc1Mw=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI4NTIyNjE=",
        "type": null,
        "firstName": "Paul",
        "lastName": "Griffiths",
        "jobTitle": "Chief Executive Officer",
        "organization": "Dubai Airports",
        "photoUrl": "https://static.swapcard.com/public/images/5a2b9cf9f3544a5e89a8cbe61d6e9902.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzU1NA==",
                "title": "TenX Leadership Talk: Building Tomorrow's Foundation for the Future of Travel",
                "categories": [
                    "Talks",
                    "Projects & Destinations"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzQzMTM4NQ==",
                "title": "Flying into the Future: The Economic and Strategic Imperative of Advanced Air Mobility",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Y0eJtkvcZ4Y",
                    "id": "RmllbGRWYWx1ZV8yODgwNzg0NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "fdf88602-6e1b-4062-a6a2-06e2a50fd082",
                    "id": "RmllbGRWYWx1ZV8yODgwNzg0NA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA0NTQzMDU=",
        "type": "Guest",
        "firstName": "Michaela",
        "lastName": "Guzy",
        "jobTitle": "Founder, CEO, Executive Producer + OnAir",
        "organization": "OhThePeopleYouMeet Productions",
        "photoUrl": "https://static.swapcard.com/public/images/91629162c2294f04836ebb8aef433e17.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMzM2Mg==",
                "title": "Building Destinations Together: The Impact of Public-Private Partnerships",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "LrDAGwzSuxQ",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM3OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "dfd29cc6-f05c-4e76-b445-1d4cee24de40",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM3OA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Media & PR",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MTMyMTA=",
        "type": null,
        "firstName": "Tony",
        "lastName": "Habre",
        "jobTitle": "Founder",
        "organization": "AlphaMind Group",
        "photoUrl": "https://static.swapcard.com/public/images/820bd70571d84c9c9f14aaeac301f410.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzQyNzIxNw==",
                "title": "Deal Dynamics: Finding the Sweet Spot Between Ownership Vision and Investor Value",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "xs3aVV-V-Gg",
                    "id": "RmllbGRWYWx1ZV8yODc1MDYxMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "d1fdc4bf-10f4-44d3-be79-ecf8534cd8a8",
                    "id": "RmllbGRWYWx1ZV8yODgxMDc1Mw=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEwOTQ3MDE=",
        "type": "Moderator",
        "firstName": "James",
        "lastName": "Hacon",
        "jobTitle": "Founder & Partner",
        "organization": "Think Hospitality",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/44ab6f5238b9455ea55791f45685aab1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk4Mg==",
                "title": "The Impact of Third-Party Outlets on Hotel Revenue and Real Estate Value – What are the Keys to Choosing the Right Operator, Concept and Agreement?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDIzNA==",
                "title": "Four Levers of Revenue Optimisation for Restaurants and Hotel F&B, with Practical Advice on Maximising Sales and Profitability",
                "categories": [
                    "Talks",
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDQ4OQ==",
                "title": "Founder Chat: In conversation with  Ashish Tulsian on understanding how to leverage  AI & Power of data for your restaurant business",
                "categories": [
                    "Talks",
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDI0Ng==",
                "title": "The future of investment into Saudi F&B – what are the emerging vehicles and opportunities to bring investment into the market?",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5NDI0MQ==",
                "title": "Lessons learned from tough times – opening in challenging markets and what tactics you can employ to overcome the hurdles",
                "categories": [
                    "Talks",
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1OQ==",
                "title": "The World's First AI-Created Restaurant",
                "categories": [
                    "Restaurant Investment",
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE0NzcxNg==",
                "title": "The World's First AI-Created Restaurant In Action",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Mg==",
                "title": "The World's First AI-Created Restaurant Revealed",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4MA==",
                "title": "Hoteliers Are From Mars, Restauranters Are From Venus: Why Hoteliers Can’t Run Restaurants?",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkxMA==",
                "title": "Welcome to Restaurant Investment Trends Transforming Hotels",
                "categories": [
                    "F&B Experience"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "f-and-b-experience",
                        "translations": [
                            {
                                "value": "F&B Experience"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzQyNzIxNw==",
                "title": "Deal Dynamics: Finding the Sweet Spot Between Ownership Vision and Investor Value",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "qcWK51aCJTQ",
                    "id": "RmllbGRWYWx1ZV8yODE4NzU2MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e8d8796f-a69e-4885-89eb-768bdb97c618",
                    "id": "RmllbGRWYWx1ZV8yODE4NzU2MA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA1NTE3OTE=",
        "type": "Speaker",
        "firstName": "Bani",
        "lastName": "Haddad",
        "jobTitle": "Founder & Co-CEO",
        "organization": "Aleph Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/fbfab4a15cf74a07b9742e0c0b601c64.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgyOTY4MA==",
                "title": "Assessing the Significance and Economic Viability of International Brands in African Destinations",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0MQ==",
                "title": "The Future of Hospitality Management: From White Label Operators, Franchising, to Traditional Management Agreements",
                "categories": [
                    "Global Investments",
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU5MjYwNQ==",
                "title": "Africa's Hospitality Boom: Is the Sector Growing Fast Enough to Meet Rising Demand?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg5NA==",
                "title": "Franchise Models: A Barrier to Sustainable Hospitality—or a Catalyst for Change?",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk3MzgwMQ==",
                "title": "Show, Don't Tell: Real Strategies, Real Challenges, Real Returns",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "United Arab Emirates",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "A6F0pvR7sfY",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM5MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "8e400adc-e017-4490-b76f-82ccd671feed",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM5MA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwMTc2Mzg=",
        "type": null,
        "firstName": "Stephane",
        "lastName": "Haddad",
        "jobTitle": "Associate Dean Executive Education",
        "organization": "EHL Hospitality Business School",
        "photoUrl": "https://static.swapcard.com/public/images/ef300e1e4ccf4392928b955a82fde972.jpeg",
        "speakerOnPlannings": [],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "VJbu1pdBc9g",
                    "id": "RmllbGRWYWx1ZV8yODQ3ODk5Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "05ba87e8-0c04-4d8e-a146-6ba2fc0bab46",
                    "id": "RmllbGRWYWx1ZV8yODQ3OTAxNA=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Jury",
                    "id": "RmllbGRWYWx1ZV8yODQ3OTAyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5MzY5NzE=",
        "type": null,
        "firstName": "Graham",
        "lastName": "Hallett",
        "jobTitle": "Chief Development Officer",
        "organization": "Marjan",
        "photoUrl": "https://static.swapcard.com/public/images/730ad2dc15e14a25bcb243ff53db7ede.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczOTMzOQ==",
                "title": "From Groundbreaking to Grand Opening: Aligning Project Delivery with Operational Success",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "RE2JskJd3OY",
                    "id": "RmllbGRWYWx1ZV8yODgxNDQ5Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5546d4cf-2598-4aed-9343-60a38243547f",
                    "id": "RmllbGRWYWx1ZV8yODgyNTMwMQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5MjU3MDU=",
        "type": null,
        "firstName": "Roland",
        "lastName": "Hancock",
        "jobTitle": "Partner, Education and Skills Leader and Chief Sustainability Officer",
        "organization": "PwC Middle East",
        "photoUrl": "https://static.swapcard.com/public/images/5c63fc1010664ed7bf576af10a0da398.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODc3OA==",
                "title": "Rebuilding the Workforce: Attracting and Retaining Talent in Hospitality",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2ODAyMw==",
                "title": "From Challenge to Solution: Hospitality Workforce Sprint",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "IgMjGvQXLqg",
                    "id": "RmllbGRWYWx1ZV8yODQ0MDY3OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7b1fabd5-f5ca-4763-84cc-31e929c4cbf3",
                    "id": "RmllbGRWYWx1ZV8yODQ0MTM5Nw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0OTM3MzM=",
        "type": null,
        "firstName": "Dr. Aron",
        "lastName": "Hari Harilela",
        "jobTitle": "Chairman & CEO",
        "organization": "Harilela Hotels Ltd",
        "photoUrl": "https://static.swapcard.com/public/images/ccd1b2b4e0f648609ef760ee34272e6b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg5Mw==",
                "title": "A Global Perspective - From Asia to the Middle East",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "x5fyRA2Yd9I",
                    "id": "RmllbGRWYWx1ZV8yODY2MjI5OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "4966ae11-6c6f-4b08-936d-c5f9ff071fcf",
                    "id": "RmllbGRWYWx1ZV8yODY2MjMwMQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1MzY1Njg=",
        "type": null,
        "firstName": "Shady",
        "lastName": "Hassan",
        "jobTitle": "Vice President Development - North Africa",
        "organization": "Marriott International",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/7eac2ffcfdf347919edc046828636810.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTQ2ODE=",
                "title": "The three minute pitch to owners - LOYALTY SCHEMES & DRIVING DISTRIBUTION",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjk5OQ==",
                "title": "Beyond Yield: The Emotional Architecture of Luxury Resort Brands",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "ELNkLXkRAXA",
                    "id": "RmllbGRWYWx1ZV8yODcxODQ4Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "75e30075-6075-4e37-b0b1-e0d9528b3b20",
                    "id": "RmllbGRWYWx1ZV8yODcxODQ4NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3NzE5MDc=",
        "type": null,
        "firstName": "Ryan",
        "lastName": "Hattingh",
        "jobTitle": "Group CEO",
        "organization": "Agon Capital",
        "photoUrl": "https://static.swapcard.com/public/images/7c480d7f3ad04291a96c87f38980cc37.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc2NTcyNQ==",
                "title": "From Day to Dusk: How Beach Clubs Redefine F&B, Wellness & Exclusivity",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "zroUpmZpZEk",
                    "id": "RmllbGRWYWx1ZV8yODc3NjE0NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "01ae4f08-bd2a-4c91-b6a2-340d47957a56",
                    "id": "RmllbGRWYWx1ZV8yODc3NjE1MA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2NTA4Nzc=",
        "type": null,
        "firstName": "Li",
        "lastName": "Hawkins",
        "jobTitle": "Partner and  Managing Director",
        "organization": "Insight Out",
        "photoUrl": "https://static.swapcard.com/public/images/d0fc720125d6408bafe5d3b59a1ba361.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcyMg==",
                "title": "How Operators Drive Asset Value: Leveraging Technology, Data & AI to Maximize Owner Returns",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "i46p5CaQlgY",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQzOQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7b3d9950-1e22-447f-9617-6f4e91e26624",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQzOA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIxNDg4MTY=",
        "type": null,
        "firstName": "Elias",
        "lastName": "Hayek",
        "jobTitle": "Shareholder, Co-Chair Hospitality Industry Group, Middle East and Europe",
        "organization": "Greenberg Traurig",
        "photoUrl": "https://static.swapcard.com/public/images/21120f4a8f3246fa94e3fc7640c60be0.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjczOQ==",
                "title": "Owners Forum: The Power Struggle – Owners vs. Operators (Invitation-Only)",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "pnieMg-k_BI",
                    "id": "RmllbGRWYWx1ZV8yODUyODE0MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "35122f5a-55c7-4957-a537-216e024edd15",
                    "id": "RmllbGRWYWx1ZV8yODUyODE1Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Lawyer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA3NTQwODI=",
        "type": "Speaker",
        "firstName": "Ufi",
        "lastName": "Ibrahim",
        "jobTitle": "Chief Executive Officer",
        "organization": "Energy & environment Alliance",
        "photoUrl": "https://static.swapcard.com/public/images/0d24a3ede6754d94af12cb2d5485395f.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYzNTg0MA==",
                "title": "Capital at a Crossroads: How Sustainability is Rewriting the Rules of Hotel Investment",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzM5NDA0NQ==",
                "title": "HAMA Asset Management Workshop - The Future of Hotel Asset Management",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjc0MA==",
                "title": "Capital at a Crossroads: How Sustainability is Rewriting the Rules of Hotel Investment",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg5MQ==",
                "title": "Empowering Communities Through Livelihood Opportunities in the Hospitality Sector",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDMzMDY0OA==",
                "title": "A New Platform for Progress: Africa Hospitality Investor's Council",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "g-Um1tjBEI0",
                    "id": "RmllbGRWYWx1ZV8yODAzODE4OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "6b7ba9de-a994-49bf-92cb-2b8b9b0b3980",
                    "id": "RmllbGRWYWx1ZV8yODgxMDU3NA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MjA2Mzc=",
        "type": null,
        "firstName": "Dr․ Eng. Abdelkhalek",
        "lastName": "Ibrahim",
        "jobTitle": "Senior technical assistant to the minister",
        "organization": "Ministry of housing, utilities and urban communities",
        "photoUrl": "https://static.swapcard.com/public/images/62f0d76201c2484b8037d797de431fe7.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzUzMjk4MA==",
                "title": "Egypt’s North Coast: From Seasonal Escape to Year-Round Destination",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "ARH5TY_f7gk",
                    "id": "RmllbGRWYWx1ZV8yODc1Njk4OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5c58baeb-959f-4a6c-af3d-589c85f08ce0",
                    "id": "RmllbGRWYWx1ZV8yODgxMDc2Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Government / Tourism Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA3OTg1MTY=",
        "type": "Speaker",
        "firstName": "Riyan",
        "lastName": "Itani",
        "jobTitle": "Founder",
        "organization": "Global Branded Residences Ltd.",
        "photoUrl": "https://static.swapcard.com/public/images/0a8fedf8c19444388ccf07bf5208b2c7.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMg==",
                "title": "Future Telling – What Shapes and Forms will Branded Residences Take in Coming Years",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY3OTMzMQ==",
                "title": "Unveiling Market Trends: Insights into Branded Residences in Africa",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYwMDY5NQ==",
                "title": "Global Branded Residences Market Update – Data & Insights",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY2OTQ5MQ==",
                "title": "What Does Luxury Mean in Asia – A Branded Residences Perspective",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkyMg==",
                "title": "Branded Residences Uncovered: Global Performance Review & Insights",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkyNg==",
                "title": "The Real Deal: Unpacking the Financial Realities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "HCS-iSf_KFM",
                    "id": "RmllbGRWYWx1ZV8yODA2MDAwNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "40d850a0-f47f-4ede-b9f2-dac4d19a949a",
                    "id": "RmllbGRWYWx1ZV8yODA2MDAwNA=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk5NDc2NzI=",
        "type": null,
        "firstName": "Guy",
        "lastName": "Ivesha",
        "jobTitle": "Founder & CEO",
        "organization": "Maslow's",
        "photoUrl": "https://static.swapcard.com/public/images/d0a80b6655cd4601b2b50214463224d5.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODkxMw==",
                "title": "“Hybrid Lives” – The Big Shift and Vision of Future Spaces",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "DtxQed4bZKk",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM0MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "1fcb425a-59d4-4de6-8ba9-b82ed59ef100",
                    "id": "RmllbGRWYWx1ZV8yODU0MDgwMQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0MjA0ODY=",
        "type": null,
        "firstName": "Michael",
        "lastName": "Jalbert",
        "jobTitle": "Chief Executive Officer",
        "organization": "Forbes Global Properties",
        "photoUrl": "https://static.swapcard.com/public/images/6569da7a8f4149368514b681bec45023.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0MTYzMQ==",
                "title": "Soundscapes of Hospitality: Albania",
                "categories": [
                    "Country Pavilion Showcase"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Ng==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "country-pavilion-showcase",
                        "translations": [
                            {
                                "value": "Country Pavilion Showcase"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "_4JC22FKyHU",
                    "id": "RmllbGRWYWx1ZV8yODYzMDA5Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "af82cc08-f7ad-4a3b-b7fc-6b1359ea239e",
                    "id": "RmllbGRWYWx1ZV8yODYzMDA5OQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Real Estate Broker/Surveyor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEwOTUyNjg=",
        "type": null,
        "firstName": "Barun",
        "lastName": "Jolly",
        "jobTitle": "Senior Vice President and Business Unit General Manager",
        "organization": "Robinsons Land Corporation",
        "photoUrl": "https://static.swapcard.com/public/images/afc6d3634d774a239cdc8a9fd8c42518.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzMyOTQzMQ==",
                "title": "Beyond Paradise: Discovering the Investment Potential of the Philippines",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2Nzk0NQ==",
                "title": "The Philippines Advantage: Private Insights for Strategic Investors",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "0MugFvsdHgI",
                    "id": "RmllbGRWYWx1ZV8yODE4Nzc5OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "03e760ab-1b62-4613-91d7-d32d6ae1a014",
                    "id": "RmllbGRWYWx1ZV8yODE4NzgwNQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MDgxOTg=",
        "type": null,
        "firstName": "Neal",
        "lastName": "Jones",
        "jobTitle": "Chief Operating Officer – Europe and Africa, EMEA OPR, Global Leader – Design Hotels",
        "organization": "Marriott International",
        "photoUrl": "https://static.swapcard.com/public/images/5281e5990a3d48b0861828e92a35c893.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMwNQ==",
                "title": "Private Sector Leading the Way: Investors and Operators at the Forefront",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "1hAqj6G8mH0",
                    "id": "RmllbGRWYWx1ZV8yODc0NzgzNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "aef78309-8f6e-4139-bd1e-97202506f1b9",
                    "id": "RmllbGRWYWx1ZV8yODc0NzgzOQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2NzI1OTU=",
        "type": null,
        "firstName": "Prasanth",
        "lastName": "Kalangi",
        "jobTitle": "Founder and Chief Executive Officer",
        "organization": "Zoniqx",
        "photoUrl": "https://static.swapcard.com/public/images/d674523f92404b99ae20961edb94ff03.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzMwMzMwMQ==",
                "title": "Tokenization & Digital Assets: Transforming the Future of Real Estate with Blockchain",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MTI1NDQ=",
        "type": null,
        "firstName": "Rabih Elie",
        "lastName": "Karam",
        "jobTitle": "Group Chief Executive Officer",
        "organization": "Al Ain Asset Management",
        "photoUrl": "https://static.swapcard.com/public/images/2974d7b205b44a8982612fef12a0b443.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjc0Mw==",
                "title": "Maximizing Returns, Minimizing Risk: How to Optimize and Protect Value for Investors",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "pMMR0lO7eZ0",
                    "id": "RmllbGRWYWx1ZV8yODc1MDIxNg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "dec185dd-9bc2-498f-a2e6-1c55154c6d21",
                    "id": "RmllbGRWYWx1ZV8yODgyMjI2NA=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2NTc2MzQ=",
        "type": null,
        "firstName": "Rizwan",
        "lastName": "Kassim",
        "jobTitle": "Founder and CEO",
        "organization": "Rikas Hospitality Group",
        "photoUrl": "https://static.swapcard.com/public/images/153d512434a3451ca966aa2edcb8306b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg1MDk1OQ==",
                "title": "Utilising Independent F&B Operators to Revitalise a Hotel Asset",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgwOTM2NA==",
                "title": "How Lifestyle Hotel and F&B Brands are Disrupting the Future of Hospitality in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4NA==",
                "title": "Unlocking F&B Success: Boosting Hotel Real Estate Value with Effective Third-Party Outlet Agreements",
                "categories": [
                    "Restaurant Investment"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "restaurant-invest-grif",
                        "translations": [
                            {
                                "value": "Restaurant Investment"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAzNTg1Mw==",
                "title": "FHS Awards 2024",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk5NDU0NQ==",
                "title": "25 Jump Street: Shaping Dubai’s Next Culinary, Bar, Art & Culture Destination",
                "categories": [
                    "F&B Experience"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "f-and-b-experience",
                        "translations": [
                            {
                                "value": "F&B Experience"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "GdewcFdQFhQ",
                    "id": "RmllbGRWYWx1ZV8yODAwMzY4MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "8a03ec3a-bbff-44cd-8aab-1971e6a2c2e3",
                    "id": "RmllbGRWYWx1ZV8yODc0MDM3MA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA3MTQ1Mjk=",
        "type": "Moderator",
        "firstName": "David",
        "lastName": "Keen",
        "jobTitle": "Founder & CEO",
        "organization": "QUO",
        "photoUrl": "https://static.swapcard.com/public/images/a86d177f6c904537a377d4246f2f7bc7.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Mg==",
                "title": "How will you 'Lead The Change'?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU4NA==",
                "title": "Brand Dilemma: Navigating the Pros and Cons of Launching New Brands – A Strategic Exploration for Hospitality Decision-Makers",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQwMQ==",
                "title": "Saudi Vision 2030: Reimagining Hospitality",
                "categories": [
                    "Projects & Destinations",
                    "Focus on Saudi Arabia",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyOTk0Mw==",
                "title": "Forming Culture to Build Brands",
                "categories": [
                    "Workshop"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjM5MQ==",
                "title": "Where Vision Shapes Opportunity",
                "categories": [
                    "Focus on Saudi Arabia"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzI1OTYwMw==",
                "title": "Shaping Tomorrow’s Icons: The Power of Storytelling in Mega-Developments",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzMwMjkzNA==",
                "title": "Driving New Experiences: The Evolution of an Automotive Luxury Brand into Hospitality",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDMyOTQxMw==",
                "title": "From Perception to Capital: How Nation Branding Drives Investment",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTc2OA==",
                "title": "Ultra-Luxury or Smart Luxury? Capital Allocation in a Changing Saudi Market",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTc4NQ==",
                "title": "Building Beyond Boundaries: Creating World-Class Tourism Destinations",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "bbvgFfc3pmc",
                    "id": "RmllbGRWYWx1ZV8yODAyNDMzOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "829b2b17-b6fb-44f1-a837-c271a083433d",
                    "id": "RmllbGRWYWx1ZV8yODYzMTcwNA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA3ODA1MjE=",
        "type": null,
        "firstName": "Dr Khaled",
        "lastName": "Khalifa",
        "jobTitle": "Senior Advisor, Representative to the GCC",
        "organization": "United Nations High Commissioner for Refugees",
        "photoUrl": "https://static.swapcard.com/public/images/1b59a6c9f4ee46e3a51538ed24259a0d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg5MQ==",
                "title": "Empowering Communities Through Livelihood Opportunities in the Hospitality Sector",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "g3xI6iz5smk",
                    "id": "RmllbGRWYWx1ZV8yODA1MzUyMw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "6511de30-627e-43f2-bdf2-955e21f0a9c5",
                    "id": "RmllbGRWYWx1ZV8yODA1MzUzMQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI4NTIyMzk=",
        "type": null,
        "firstName": "Anthony",
        "lastName": "Khoury",
        "jobTitle": "UAE General Manager",
        "organization": "Joby Aviation",
        "photoUrl": "https://static.swapcard.com/public/images/98b4e614ef07492588720107df2c7bf1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzQzMTM4NQ==",
                "title": "Flying into the Future: The Economic and Strategic Imperative of Advanced Air Mobility",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "DxBiOpo9JJI",
                    "id": "RmllbGRWYWx1ZV8yODgwNzgzMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "beb7e3fe-32e6-41c5-9412-d732f4c84dab",
                    "id": "RmllbGRWYWx1ZV8yODgwNzgzNg=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk4Nzg1OTY=",
        "type": null,
        "firstName": "Shaun",
        "lastName": "Killa",
        "jobTitle": "Design Director  and Founder",
        "organization": "Killa Design",
        "photoUrl": "https://static.swapcard.com/public/images/480e40cae3534f8d9a4fa35c74791cff.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjk5OQ==",
                "title": "Beyond Yield: The Emotional Architecture of Luxury Resort Brands",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "HgtfzwjtswU",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMzNw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "fe0133f2-fa49-4b12-a83d-8f8bbd974cdc",
                    "id": "RmllbGRWYWx1ZV8yODI0NDE1OQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Architecture & Design",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MTI4NDg=",
        "type": null,
        "firstName": "Darren",
        "lastName": "King",
        "jobTitle": "Chief Executive Officer",
        "organization": "Roomnet",
        "photoUrl": "https://static.swapcard.com/public/images/e7d93b5831d04c4eb86dd6c49a3708dc.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjgxNDczNA==",
                "title": "TECH Lightning Round",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "HY93kkrCEV4",
                    "id": "RmllbGRWYWx1ZV8yODc1MDMwOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "95a103f5-3869-4040-b34b-900f06bb799e",
                    "id": "RmllbGRWYWx1ZV8yODc1MDMxNQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5MzAzNjA=",
        "type": null,
        "firstName": "Dimitrios",
        "lastName": "Kolaxis",
        "jobTitle": "Senior Vice President Hospitality",
        "organization": "Dubai Holdings",
        "photoUrl": "https://static.swapcard.com/public/images/99d00c366612418d8f97439b190fb722.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjkwMTUyNw==",
                "title": "Mitigating Risk, Managing Costs: Hospitality’s Climate-Resilient Playbook",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "mPqwCeCj9k0",
                    "id": "RmllbGRWYWx1ZV8yODgxMjQ3MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "1deefdd7-70b0-4615-bac7-ea12279ecf77",
                    "id": "RmllbGRWYWx1ZV8yODgxMjQ3NA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA3NjY4MTU=",
        "type": null,
        "firstName": "Jiri",
        "lastName": "Konecny",
        "jobTitle": "Founder and Chief Executive Officer",
        "organization": "ELKO EP",
        "photoUrl": "https://static.swapcard.com/public/images/ecf4c658c6544516b279c3f2015c9cad.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc2Nzk1Mw==",
                "title": "Smart Hospitality, Smarter Returns: Measuring the ROI of Automation",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "gLHEpxbU6E0",
                    "id": "RmllbGRWYWx1ZV8yODA0ODIyMA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "0abd45aa-1071-4d8e-9ec7-d4da0f1f514d",
                    "id": "RmllbGRWYWx1ZV8yODA4MjQ4MQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2Nzc4OTg=",
        "type": "Speaker",
        "firstName": "Jan-Patrick",
        "lastName": "Kruger",
        "jobTitle": "Managing Director",
        "organization": "Pandox AB",
        "photoUrl": "https://static.swapcard.com/public/images/05a186889c3b416e8dc982036522525f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjU5MjY2NQ==",
                "title": "Masterclass: How engagement, culture and leadership make or break brand & property value in the region (and beyond)?",
                "categories": [
                    "NextGen Talent & Hospitality Education"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzYxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen-talent-and-hospitality-education",
                        "translations": [
                            {
                                "value": "NextGen Talent & Hospitality Education"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzQwODA5OA==",
                "title": "From Resilience to Growth: The European Hospitality Investment Outlook",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "_mMSbuu4fOk",
                    "id": "RmllbGRWYWx1ZV8yODAxMzI0OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "dc59cf10-bc8a-4610-acdc-248a852500d4",
                    "id": "RmllbGRWYWx1ZV8yODc0NzU3Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE3NzA3ODA=",
        "type": "Speaker",
        "firstName": "Theodor",
        "lastName": "Kubak",
        "jobTitle": "Co-Founder, President Emeritus, Director of the Supervisory Board,",
        "organization": "HAMA Europe",
        "photoUrl": "https://static.swapcard.com/public/images/d4b31ffd5bbf4a779499a807ec6d7d44.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTA3NzU1",
                "title": " Who bears the pain: the new normal for landlord / tenant relationships",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAyMQ==",
                "title": "The Business Case for ESG Integration: Exploring the Commercial Benefits and Opportunities for Real Estate Investors and Developers",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjQ4Nw==",
                "title": "The Future of Hotel Asset Management - HAMA Asset Management Workshop - Invitation Only",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYxMjI1OA==",
                "title": "A GLOBAL PRESIDENTS FORUM: The Bulls & Bears of Global Capital Markets",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNjY0MQ==",
                "title": "The Future of Hotel Asset Management - HAMA Asset Management Workshop - Invitation Only",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "FBg7PAQRqCc",
                    "id": "RmllbGRWYWx1ZV8yODM4MDEzMw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "67ad5ee6-f71f-4182-9041-cb5ca741fcf7",
                    "id": "RmllbGRWYWx1ZV8yODM4MDEzMg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Financial Services / Banks",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5OTExMzU=",
        "type": null,
        "firstName": "John",
        "lastName": "L. Ololtuaa, CBS",
        "jobTitle": "Principal Secretary, State Department for Tourism",
        "organization": "Republic of Kenya",
        "photoUrl": "https://static.swapcard.com/public/images/fad92fd639da482cba611914470b9f2d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMwMA==",
                "title": "Scaling Stories: How African Nations Are Redefining Tourism for Growth",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "xOmw9-DELZM",
                    "id": "RmllbGRWYWx1ZV8yODgyNjc4Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "dd4620fd-75b5-4b6f-9fa3-013544bf2fab",
                    "id": "RmllbGRWYWx1ZV8yODgyOTY1MA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA0MjQxMDI=",
        "type": null,
        "firstName": "Barry",
        "lastName": "Landsberg",
        "jobTitle": "Principal",
        "organization": "Landsberg Residential Consulting Inc.",
        "photoUrl": "https://static.swapcard.com/public/images/7cd2a06bdb2a4649a3f86ea63102a299.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNw==",
                "title": "Operator Perspective - A Look at How Leading Operators of Branded Residences View their Relationship With Development Partners and Homeowner Communities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMw==",
                "title": "Structuring Rentals Programs to Appeal to Buyers, While Protecting the Interests of Hotel Owners & Developers",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkyMA==",
                "title": "Welcome to the Branded Residences Forum at FHS World 2025",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc0NTczNg==",
                "title": "Legal Structures: Protecting Interests of Investors, Purchasers & Brands",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "VFjEvIgPO0k",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM3Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "0e05fa51-11be-49ed-b04d-44be42d18ef1",
                    "id": "RmllbGRWYWx1ZV8yODcxMjMzOA=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk2MjMxNTM=",
        "type": "Speaker",
        "firstName": "Grégory",
        "lastName": "Lanter",
        "jobTitle": "Group Deputy CEO",
        "organization": "CLUB MED",
        "photoUrl": "https://static.swapcard.com/public/images/6cc089291ce348109203eb2799b0e53e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAwMQ==",
                "title": "Creating Thriving Mixed-Use Developments: The Synergy of Culture, Entertainment and Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc5Mjk5MA==",
                "title": "Splashes of Success: Saudi Arabia's Thriving Leisure Landscape for the Changing Demographics",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA3MzU5MQ==",
                "title": "The Rise of Luxury Hospitality: Trends and Differentiators Shaping the Future of High-End Tourism",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjUzMzkxMA==",
                "title": "All-Inclusive Reimagined: How Gen Z and Luxury are Redefining the Upscale Travel Experience",
                "categories": [
                    "Luxury, F&B, and Experiential Hospitality"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNzA3NTM4MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "luxury-fandb-and-experiential-hospitality",
                        "translations": [
                            {
                                "value": "Luxury, F&B, and Experiential Hospitality"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMA==",
                "title": "From Mass to Class: The Upscale Shift in the All-Inclusive Hospitality Market",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "GonEnSPPT8c",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMzMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f44eccc1-4d11-4967-93ed-8f71d38d315a",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMzMA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Branded Residences / Extended stays / Serviced Apartments",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2MzY0Mjk=",
        "type": null,
        "firstName": "Gerald",
        "lastName": "Lawless",
        "jobTitle": "Non Executive Board Member",
        "organization": null,
        "photoUrl": "https://static.swapcard.com/public/images/4810083eacef4480a2702b3ab285e870.webp",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcwNg==",
                "title": "Then and Now: Two Decades of Hospitality Investment Evolution",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "23POR7O2HnI",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMxOQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "80d0aa89-4685-4164-bce9-1acb8741b136",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMxOA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIyNzQxOTI=",
        "type": null,
        "firstName": "Alexander",
        "lastName": "Lee",
        "jobTitle": "Chief Growth Officer",
        "organization": "Jumeirah",
        "photoUrl": "https://static.swapcard.com/public/images/2c4bd6a9931149ffa5ffad0689d7a2d9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczOTg0MQ==",
                "title": "Building Tomorrow: The Geographies and Segments Defining Growth",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "KIMrcFg_Dok",
                    "id": "RmllbGRWYWx1ZV8yODYwNTIwOQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "8b8c0d4d-0ec2-47b9-957e-913ed916ceff",
                    "id": "RmllbGRWYWx1ZV8yODYwNTIxNQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDMwOTI1MjM=",
        "type": "Speaker;Delegate",
        "firstName": "Markus",
        "lastName": "Lehnert",
        "jobTitle": "SVP International Hotel Development EMEA",
        "organization": "Marriott International, Inc.",
        "photoUrl": "https://static.swapcard.com/public/images/027fdf857ebd48c4a965a5a88d08598a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTI5Mjk=",
                "title": "Keynote & discussion on: The future of hospitality- what is our plan for the next 10 years? Or is it 5 more realistic to plan?",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTc5ODQ4OQ==",
                "title": "A New Dawn: Pioneering the Rise of Lifestyle Hospitality Brands in Africa's Urban and Leisure Destinations",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYzNTgzOQ==",
                "title": "Hospitality for the next Billion: Lifestyle & Midscale as Engines of Growth",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc4MDE2OA==",
                "title": "Future of Hospitality Concepts and Operating Models",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "Switzerland",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "bnBZGH3Px1s",
                    "id": "RmllbGRWYWx1ZV8yODg1OTUxMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "2ccac233-8b77-456f-9dcc-b927ec2b5f8d",
                    "id": "RmllbGRWYWx1ZV8yODg1OTUxMQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDM0NDI=",
        "type": "Speaker",
        "firstName": "Professor Marc",
        "lastName": "Lepere",
        "jobTitle": "Lead in ESG & Sustainability, Executive Education, Department of Banking & Finance",
        "organization": "King’s Business School",
        "photoUrl": "https://static.swapcard.com/public/images/349224791da74287bc999e28ae9c3c0e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjU3NjA3MA==",
                "title": "Risk or Rhetoric: Navigating Climate Risk, Regulation, and Reality in 2025",
                "categories": [
                    "Sustainability & ESG",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzY0NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-esg",
                        "translations": [
                            {
                                "value": "Sustainability & ESG"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg3OA==",
                "title": "Risk or Rhetoric: Navigating Climate Risk, Regulation, and Reality in 2025",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjc0MA==",
                "title": "Capital at a Crossroads: How Sustainability is Rewriting the Rules of Hotel Investment",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "eKD7gwiPReA",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI4Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "8bcc727f-1d5c-4afd-8ebb-f3ae44567aa4",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI4Mg=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA5MjI3NTA=",
        "type": "Speaker",
        "firstName": "Serena",
        "lastName": "Lim",
        "jobTitle": "Chief Growth Officer",
        "organization": "The Ascott Limited",
        "photoUrl": "https://static.swapcard.com/public/images/cca0cb3e45514a56a843e289363626ad.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQxOQ==",
                "title": "Serviced Residences Reimagined:  A New Era of Accommodation",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY1ODUzMQ==",
                "title": "Setting the Scene for Hospitality Asset Stability: Balancing Financial Strength for Owners & Brands",
                "categories": [
                    "Investment, Finance & Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzY3Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-finance-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment, Finance & Real Estate "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjczOTg0MQ==",
                "title": "Building Tomorrow: The Geographies and Segments Defining Growth",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQ2NTU5MA==",
                "title": "Living, Not Lodging: The Convergence of Residential, Extended Stay & Hospitality in KSA",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "p2Q0leGU7-M",
                    "id": "RmllbGRWYWx1ZV8yODA5OTg4NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "9812f6fb-28b3-4464-a5da-d0d406602156",
                    "id": "RmllbGRWYWx1ZV8yODE3MzM4MQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEwNDg1MDk=",
        "type": null,
        "firstName": "Costas",
        "lastName": "Livadaris",
        "jobTitle": "Hospitality & Leisure Lead - EMEA",
        "organization": "Parsons",
        "photoUrl": "https://static.swapcard.com/public/images/794d9a4c17024aa88316e87b45d868d4.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczOTMzOQ==",
                "title": "From Groundbreaking to Grand Opening: Aligning Project Delivery with Operational Success",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "K0qRAfaxSxs",
                    "id": "RmllbGRWYWx1ZV8yODE3MTIyNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "4c88fe7a-9110-4028-b0b3-8628f1b6bee8",
                    "id": "RmllbGRWYWx1ZV8yODE3MTIzMA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIyNDA4NzM=",
        "type": null,
        "firstName": "Filippo",
        "lastName": "Lodi",
        "jobTitle": "Director",
        "organization": "UNS United Network Studio",
        "photoUrl": "https://static.swapcard.com/public/images/a31918a02d17499d960cf15658978dde.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMg==",
                "title": "Wellbeing Ecosystems: Building Destinations Around Health and Harmony",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "GBX3ginTLYk",
                    "id": "RmllbGRWYWx1ZV8yODU2ODQyNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a8b16632-fb3a-4bd7-b980-8ed8b371e852",
                    "id": "RmllbGRWYWx1ZV8yODYyMDMwMA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Architecture & Design",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5OTExNTc=",
        "type": null,
        "firstName": "H.E. Dr. José",
        "lastName": "Luís Sá Nogueira",
        "jobTitle": "Minister of Tourism & Transport",
        "organization": "Republic of Cabo Verde",
        "photoUrl": "https://static.swapcard.com/public/images/92d15fdee7dc4493ac9380a643170584.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMwMA==",
                "title": "Scaling Stories: How African Nations Are Redefining Tourism for Growth",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "UFsWNxSdX1Q",
                    "id": "RmllbGRWYWx1ZV8yODgyNjc4OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "fabc7fa0-28ed-4120-af59-8ab4e4423533",
                    "id": "RmllbGRWYWx1ZV8yODgyOTY1Mw=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI4NTM0OTA=",
        "type": null,
        "firstName": "H.E. Rodney",
        "lastName": "M. Sikumba",
        "jobTitle": "Minister of Tourism, Republic of Zambia",
        "organization": "Representing the UN Tourism Regional Commission for Africa",
        "photoUrl": "https://static.swapcard.com/public/images/c94af1ecd24547c0a842bd423bd59a0e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMxNg==",
                "title": "Keynote Speeches",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "nw1ieT0Dc7o",
                    "id": "RmllbGRWYWx1ZV8yODgwNzk4NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "4108ebd4-6a0b-4db5-821b-8061f1147351",
                    "id": "RmllbGRWYWx1ZV8yODgyOTY1NQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2ODgxMDQ=",
        "type": "Speaker",
        "firstName": "Lindsay",
        "lastName": "Madden-Nadeau",
        "jobTitle": "Senior Director Wellness Strategy and Development",
        "organization": "Red Sea Global",
        "photoUrl": "https://static.swapcard.com/public/images/91728e12fa1443138e53e6cc829bfc43.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMg==",
                "title": "Wellbeing Ecosystems: Building Destinations Around Health and Harmony",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQ3NjE5Mw==",
                "title": "Investing in Wellbeing: The ROI Case for Wellness Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "R3QuVhg4hWc",
                    "id": "RmllbGRWYWx1ZV8yODc0MDA3Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "0ae1af88-e539-4f12-9719-705f95ff9be6",
                    "id": "RmllbGRWYWx1ZV8yODc0MDA4Mg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Wellness / Spa",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwNzM1ODI=",
        "type": "Moderator",
        "firstName": "Jeremy",
        "lastName": "Maggs",
        "jobTitle": "Journalist, Radio Host and Television Presenter",
        "organization": null,
        "photoUrl": "https://static.swapcard.com/public/images/6d0489aefda94f66b37c1421ad707ea9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMwOQ==",
                "title": "Capital Meets Culture: Financing Africa’s Tourism Transformation",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg4OQ==",
                "title": "De-Risking Africa: Building Trust and Track Records for Institutional Investment",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk3MzgwMA==",
                "title": "From Capital Markets to Ownership Models: De-Risking and Scaling Hospitality Investment in Africa",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDM2NzA1OQ==",
                "title": "Climbing the Hotel Leadership Ladder: Roles, Rotations and Readiness for GM Level",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "iVhX-pLQPq4",
                    "id": "RmllbGRWYWx1ZV8yODQ5NTY0Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "daaba0dd-e4cf-4b7e-962a-ad7587f2360a",
                    "id": "RmllbGRWYWx1ZV8yODQ5NTY1MA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5NzQ4ODg=",
        "type": null,
        "firstName": "Dean",
        "lastName": "Main,",
        "jobTitle": "Founding Partner and Chief Executive Officer",
        "organization": "Rhodium Residence Management",
        "photoUrl": "https://static.swapcard.com/public/images/026ce18422334ac3bb12d78446f1e16e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc4MjU5MQ==",
                "title": "The Misconception Myth: Why Branded Residences Aren’t Just Hotels with Keys",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "q0NyMHh4J9M",
                    "id": "RmllbGRWYWx1ZV8yODQ1NjA0Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5d2e94a4-0737-4166-9039-b56dc3ee30a0",
                    "id": "RmllbGRWYWx1ZV8yODQ1NjA3NA=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDM2NTk=",
        "type": "Moderator",
        "firstName": "Ali",
        "lastName": "Manzoor",
        "jobTitle": "Senior Director",
        "organization": "CBRE",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/ee75f5da2004484ebe7a16782b1cd54b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk5Nw==",
                "title": "Hospitality Development in Saudi Arabia: Transforming our World - Vision 2030",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgyMDAxNA==",
                "title": "Travelling for Good: Innovations in Luxury Travel for Responsible Tourism Development",
                "categories": [
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNw==",
                "title": "Operator Perspective - A Look at How Leading Operators of Branded Residences View their Relationship With Development Partners and Homeowner Communities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjUzMzkxNQ==",
                "title": "Unveiling Market Trends: Insights into Branded Residences in the Kingdom",
                "categories": [
                    "Branded Residences"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjc0NQ==",
                "title": "The Perfect Fit: Selecting the Right Brand for Residential Success",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "3SIw6j0fhvo",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI5NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e5b244e2-6e1f-4d8b-be25-156cf740e7c4",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI5NA=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0MTkzMjM=",
        "type": null,
        "firstName": "Maria",
        "lastName": "Margarita M. Nograles",
        "jobTitle": "Chief Operating Officer",
        "organization": "Tourism Promotions Board Philippines",
        "photoUrl": "https://static.swapcard.com/public/images/79414cb8a6624c8f9e4c8b56e0497a9a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc2Nzk0NQ==",
                "title": "The Philippines Advantage: Private Insights for Strategic Investors",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "ZIL8H1ceNbo",
                    "id": "RmllbGRWYWx1ZV8yODYyOTg4OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "ce2423fd-2e60-4e26-8b16-fab099bd5213",
                    "id": "RmllbGRWYWx1ZV8yODYyOTg5Mg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Government / Tourism Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA4MzgzODA=",
        "type": "Moderator",
        "firstName": "Nicolas",
        "lastName": "Mayer",
        "jobTitle": "Partner, Global Industry Leader Tourism",
        "organization": "PwC Middle East",
        "photoUrl": "https://static.swapcard.com/public/images/9369526c6d1a466eaec8dc0d84247e41.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA2ODg2OQ==",
                "title": "Who’s Really in Charge? The Hidden Power of Third Party Management in Hospitality",
                "categories": [
                    "Global Investments",
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjczOTg0MQ==",
                "title": "Building Tomorrow: The Geographies and Segments Defining Growth",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "_tt3oX0NQls",
                    "id": "RmllbGRWYWx1ZV8yODA4MjQ5Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "47bbd46b-ea62-43d8-a1cf-7254e5a7b2b5",
                    "id": "RmllbGRWYWx1ZV8yODA5NDIyNA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3Mjk1OTc=",
        "type": "Speaker",
        "firstName": "Lindsay",
        "lastName": "McGinn",
        "jobTitle": "Global Vice President, Residential Marketing",
        "organization": "Accor One Living",
        "photoUrl": "https://static.swapcard.com/public/images/40e3583390b74ba990aac2988788e0b8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjU4NDUwMw==",
                "title": "The Brand Advantage: How Branding Enhances Sales & Marketing in Residential Real Estate",
                "categories": [
                    "Branded Residences"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYxMDAxOQ==",
                "title": "Cognitive Marketing and the Power of Brand Magnetism",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzQwMjc2Ng==",
                "title": "Iconic by Design: Crafting The Next  Wave of Luxury Living",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "7d74y7uJM34",
                    "id": "RmllbGRWYWx1ZV8yODc2MDk3MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "8c6c7955-f12a-4376-a643-193fea267476",
                    "id": "RmllbGRWYWx1ZV8yODc2MDk3MA=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk0MjE1OTU=",
        "type": null,
        "firstName": "Jaidev",
        "lastName": "Menezes",
        "jobTitle": "Regional Vice President, Mixed-Use Development EMEA",
        "organization": "Marriott International",
        "photoUrl": "https://static.swapcard.com/public/images/22a5723e4e294c73987b5bee25753722.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAyNA==",
                "title": "Branded Residential is Booming: Upfront Planning for Making Your Project a Success",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjc0NQ==",
                "title": "The Perfect Fit: Selecting the Right Brand for Residential Success",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "KfwExG9kwZ4",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMyNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "20d03ec7-8bae-43ac-a5a6-2e4288d18af1",
                    "id": "RmllbGRWYWx1ZV8yODY5NTU2OQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MjY1Nzc=",
        "type": null,
        "firstName": "Adrian",
        "lastName": "Messerli",
        "jobTitle": "President - Hotel Operations, EMEA",
        "organization": "Four Seasons",
        "photoUrl": "https://static.swapcard.com/public/images/1170a614e5904d2eba40ac0152ca07b6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMwNQ==",
                "title": "Private Sector Leading the Way: Investors and Operators at the Forefront",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "rtpUHL-X6dw",
                    "id": "RmllbGRWYWx1ZV8yODc1OTM2OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "40849f4f-03e9-4dd5-a1ab-9d0eb923ea84",
                    "id": "RmllbGRWYWx1ZV8yODc1OTM3MQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDMwMDU1MDk=",
        "type": null,
        "firstName": "Henk",
        "lastName": "Meyknecht",
        "jobTitle": "Chief Hospitality Officer",
        "organization": "Private Equity, Assets & Entities",
        "photoUrl": "https://static.swapcard.com/public/images/161ce2bc90f047bd88dc4184b337570d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczOTMzOQ==",
                "title": "From Groundbreaking to Grand Opening: Aligning Project Delivery with Operational Success",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "iTxVJ3I9HJk",
                    "id": "RmllbGRWYWx1ZV8yODgyODg3MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "ff8338d0-dd64-4ca8-b60a-a58d2ac46143",
                    "id": "RmllbGRWYWx1ZV8yODgyODg2OQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzk2NDA1MTY=",
        "type": "Speaker",
        "firstName": "Elie",
        "lastName": "Milky",
        "jobTitle": "Chief Development Officer for the Middle East, Northeast Africa, Greece, and Cyprus",
        "organization": "Radisson Hotel Group",
        "photoUrl": "https://static.swapcard.com/public/images/651d88045d184b34a984f5007f20415a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMjk4Ng==",
                "title": "Building Sustainable Hospitality: Setting the Scene for Hotel Development in the Middle East",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgyMDAxOA==",
                "title": "Domestic Tourism in Secondary Cities: How Major Hotel Groups can help to Unlock New Opportunities?",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgzMDQzMA==",
                "title": "Navigating Regulatory Shifts: Legal Dynamics Reshaping Hospitality Real Estate in the Region and their Impact on Tourism Offerings",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1MQ==",
                "title": "Emerging Lifestyle Brands: Bridging Luxury and Midscale Markets with Locally Inspired Experiences in New and Established Destinations",
                "categories": [
                    "Branding Strategies",
                    "Projects & Destinations"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3MzE3Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branding-strategies",
                        "translations": [
                            {
                                "value": "Branding Strategies"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjQwNg==",
                "title": "Saudi Arabia Tourism Outlook: Shaping the Future from 2025 to 2040",
                "categories": [
                    "Investment & Development",
                    "Religious Tourism"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzYxNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "religious-tourism",
                        "translations": [
                            {
                                "value": "Religious Tourism"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2MjE3Mw==",
                "title": "Capital, Coastlines & Control: The Eastern Mediterranean Investment Map for Owners",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTc2OA==",
                "title": "Ultra-Luxury or Smart Luxury? Capital Allocation in a Changing Saudi Market",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Dvz39YG0wa0",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMzNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "054e37fc-d930-4df1-a870-f76da6946843",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMzMw=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2NzI5OTk=",
        "type": null,
        "firstName": "Yadhu",
        "lastName": "Mittal",
        "jobTitle": "Senior Vice President – Strategy and Compliance",
        "organization": "BNW Developments",
        "photoUrl": "https://static.swapcard.com/public/images/70af9c6868774e2dab37140e1884cf99.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODkyNg==",
                "title": "The Real Deal: Unpacking the Financial Realities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "dcKzNKJzlC4",
                    "id": "RmllbGRWYWx1ZV8yODczNDE0MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "215cfa83-b526-465b-ba6e-848a772b0676",
                    "id": "RmllbGRWYWx1ZV8yODczNDE0NQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2MjA0NjA=",
        "type": null,
        "firstName": "Andrea",
        "lastName": "Monti",
        "jobTitle": "Chief Executive Officer",
        "organization": "EHL NEXT",
        "photoUrl": "https://static.swapcard.com/public/images/1a59a6163a1d4c619bfc8c5eca1c0ee3.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0MTYzNQ==",
                "title": "PitchPoint: The FHS Investment Spotlight",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "SLgE_h4brTk",
                    "id": "RmllbGRWYWx1ZV8yODcxNDAyOQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f7385a30-d3c7-45fd-bb76-134eaee7502a",
                    "id": "RmllbGRWYWx1ZV8yODcxNDAzMg=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Investor - PitchPoint",
                    "id": "RmllbGRWYWx1ZV8yODQ1NTc1MQ=="
                },
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwNDg5ODg=",
        "type": "Speaker",
        "firstName": "Govind",
        "lastName": "Mundra",
        "jobTitle": "Head of Development MEA",
        "organization": "Wyndham Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/1cec4215232f4481b23d36feadda6352.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjQ3NjQwNA==",
                "title": "Branding Saudi: Forming an Authentic Identity in a Global Market",
                "categories": [
                    "Branding & Culture",
                    "Focus on Saudi Arabia"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branding-and-culture",
                        "translations": [
                            {
                                "value": "Branding & Culture"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzE4OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-saudi-arabia",
                        "translations": [
                            {
                                "value": "Focus on Saudi Arabia"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc4MjU5MQ==",
                "title": "The Misconception Myth: Why Branded Residences Aren’t Just Hotels with Keys",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "United Arab Emirates",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "MxxVRxGI7Fs",
                    "id": "RmllbGRWYWx1ZV8yODQ4OTUyNw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "4e3fa651-6b6c-47ec-8415-351649ddcf9b",
                    "id": "RmllbGRWYWx1ZV8yODQ4OTUzMw=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3NzY2NDk=",
        "type": null,
        "firstName": "Barr․ Hannatu",
        "lastName": "Musa Musawa",
        "jobTitle": "Minister of Art, Culture, Tourism and the Creative Economy",
        "organization": "Federal Republic of Nigeria",
        "photoUrl": "https://static.swapcard.com/public/images/91b8425df2e8418f82560f3a79df8f19.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMxMQ==",
                "title": "Tourism Driving Growth and Capital",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "8uOup5A3WH0",
                    "id": "RmllbGRWYWx1ZV8yODc3NzU3Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "4877ea0e-8ad4-4e91-8232-e88bc49bcdfc",
                    "id": "RmllbGRWYWx1ZV8yODgwMjI4MA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwNjgyMDY=",
        "type": "Moderator",
        "firstName": "Nicholas",
        "lastName": "Nahas",
        "jobTitle": "Partner",
        "organization": "Arthur D Little",
        "photoUrl": "https://static.swapcard.com/public/images/e1c427f95310430ab51db3278459110b.webp",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA3MzU5MQ==",
                "title": "The Rise of Luxury Hospitality: Trends and Differentiators Shaping the Future of High-End Tourism",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjkwMTQ3NQ==",
                "title": "Unlocking Capital Flows: The Evolving Investment Landscape in the Gulf and Saudi Arabia",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "WMcYbg5nDGo",
                    "id": "RmllbGRWYWx1ZV8yODQ5Mzk0MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "9bedc536-0ba4-4d69-8a6d-db682509580c",
                    "id": "RmllbGRWYWx1ZV8yODQ5Mzk2MQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2NTgyNTg=",
        "type": null,
        "firstName": "Philippe",
        "lastName": "Najjar",
        "jobTitle": "Consulting Partner, Destinations",
        "organization": "PwC Middle East",
        "photoUrl": "https://static.swapcard.com/public/images/b423c968fa214cfda7b220c4f47c2089.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcwOQ==",
                "title": "Serving the Next Wave of Visitors: Meeting Mixed-Purpose Demand",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "khAuNnYrvPg",
                    "id": "RmllbGRWYWx1ZV8yODAwNDE3NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "ffb33662-6e86-48bb-8e58-3f3b8ab0b6c2",
                    "id": "RmllbGRWYWx1ZV8yODAwNDE3Nw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Financial Services / Banks",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5MjYwODU=",
        "type": null,
        "firstName": "Sanjay",
        "lastName": "Nandi",
        "jobTitle": "Group CEO",
        "organization": "ADMO Lifestyle Holding",
        "photoUrl": "https://static.swapcard.com/public/images/d3e5e09607f44b82ab2d0b7d98a77e85.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzQyNzIxNw==",
                "title": "Deal Dynamics: Finding the Sweet Spot Between Ownership Vision and Investor Value",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "ier9Jp1J3Ow",
                    "id": "RmllbGRWYWx1ZV8yODgxMDc0OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "475c55d0-dbac-4b95-a683-ca1a2e762068",
                    "id": "RmllbGRWYWx1ZV8yODgxMDc1MQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0NDAwMzg=",
        "type": null,
        "firstName": "Roshan",
        "lastName": "Nandwani",
        "jobTitle": "Head of Marketing and Consumer Engagement",
        "organization": "Ayala Land Hospitality Inc.",
        "photoUrl": "https://static.swapcard.com/public/images/974f37c6671344f5b25ae11548c54702.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc2Nzk0NQ==",
                "title": "The Philippines Advantage: Private Insights for Strategic Investors",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "SZIE6YbMRmU",
                    "id": "RmllbGRWYWx1ZV8yODcxODI1Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "d4326abf-a779-45d7-a819-84d4dc386e49",
                    "id": "RmllbGRWYWx1ZV8yODgxODg4NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2MjA3Mjc=",
        "type": "Moderator",
        "firstName": "Nicolas",
        "lastName": "Nasra",
        "jobTitle": "Head of Hotel Advisory",
        "organization": "Colliers MENA",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/2107edc501364b20835b2031eb656fc5.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Nw==",
                "title": "Exploring Profitable Horizons: Assessing Investment in the Booming Lifestyle Midmarket Hotel Segment",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU5Nw==",
                "title": "Navigating Tomorrow's Hospitality: The Evolutionary Intersection of AI, IT, and Human Touch for Unparalleled Guest Experiences",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc5Mjk1Nw==",
                "title": "The Power of AI in Hospitality: Practical Solutions for Investors",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxMQ==",
                "title": "Disrupting the Market: How AI in the Hospitality Industry Is Changing the Game?",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY0MzM0OA==",
                "title": "Pathways to Holistic Wellness: Mapping Saudi Arabia’s Role in Global Wellness Tourism",
                "categories": [
                    "Wellness & Medical Tourism"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU4Nzc2OQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "wellness-and-medical-tourism",
                        "translations": [
                            {
                                "value": "Wellness & Medical Tourism"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY1ODUzMQ==",
                "title": "Setting the Scene for Hospitality Asset Stability: Balancing Financial Strength for Owners & Brands",
                "categories": [
                    "Investment, Finance & Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzY3Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-finance-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment, Finance & Real Estate "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU2MzY1OA==",
                "title": "Hospitality Asset Stability: Balancing Financial Strength for Owners & Brands",
                "categories": [
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkwOA==",
                "title": "Investing in Mixed-Use Real Estate: Strategies for Maximizing Value in Modern Developments",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "nP5rY37SSjE",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQxNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "06ff3fb0-1da0-42b4-b55b-eca9736f97fe",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQxNA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIxMTYwODY=",
        "type": null,
        "firstName": "Vickum",
        "lastName": "Nawagamuwage",
        "jobTitle": "Founder and Chief Executive Officer",
        "organization": "Santani Wellness Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/55e8b858ded04957a304bf4dbcf1981c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMg==",
                "title": "Wellbeing Ecosystems: Building Destinations Around Health and Harmony",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "fgtVSiZT4l4",
                    "id": "RmllbGRWYWx1ZV8yODUxODM5OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "67cdfc3c-2519-4458-8bc8-51def84cdf41",
                    "id": "RmllbGRWYWx1ZV8yODUyMDY1MQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA1NzY0ODE=",
        "type": "Speaker",
        "firstName": "Amit",
        "lastName": "Nayak",
        "jobTitle": "Vice President",
        "organization": "Hospitality Asset Managers Association Middle East and Africa",
        "photoUrl": "https://static.swapcard.com/public/images/01ac0cb07a4a436db3e273653ef38d23.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM2NTM=",
                "title": "The international perspective",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAxMQ==",
                "title": "Strategic Financing of Hospitality Assets: Navigating Uncertainty and Rising Interest Rates for Optimal Funding Solutions",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzODIwNw==",
                "title": "HAMA Workshop",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzNDY3NA==",
                "title": "Fireside Chat on Immersive and Decentralized Media Experiences with Web3, Blockchain, AI, and NFTs",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjEzNDk0Mg==",
                "title": "India 2047: Unlocking the Future of Hospitality in a Rising Global Power",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE2MTEwMA==",
                "title": "Visionary Leadership: Driving Abu Dhabi’s Leisure and Entertainment Growth through Immersive Destinations",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyOTk0MA==",
                "title": "HAMA Workshop & Annual Debriefing",
                "categories": [
                    "Workshop"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM2MDM0OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "workshop",
                        "translations": [
                            {
                                "value": "Workshop"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg3NQ==",
                "title": "Mapping the Money: Tracking Smart Capital in a Changing Hospitality Landscape",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg3NA==",
                "title": "HAMA Asset Management Workshop -  The Future of Hotel Asset Management",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "FRGWoC5w7tU",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM5NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "c2f47a92-f074-48b8-876b-966615674d18",
                    "id": "RmllbGRWYWx1ZV8yODA5NDg5NQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE0NzU1OTU=",
        "type": null,
        "firstName": "Thomas",
        "lastName": "Niens",
        "jobTitle": "Vice President Sales",
        "organization": "Adyen",
        "photoUrl": "https://static.swapcard.com/public/images/95ccd50b14374cd58b3b056fc3586f73.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjgxNDczNA==",
                "title": "TECH Lightning Round",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjcyMg==",
                "title": "How Operators Drive Asset Value: Leveraging Technology, Data & AI to Maximize Owner Returns",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "fcdyu5P4M-U",
                    "id": "RmllbGRWYWx1ZV8yODMwNzIxOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f2910057-0805-4916-a543-1b5495f7fb3a",
                    "id": "RmllbGRWYWx1ZV8yODMwNzIyMQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDM2MDk=",
        "type": "Delegate",
        "firstName": "Siegfried",
        "lastName": "Nierhaus",
        "jobTitle": "Vice President & Head of Development Middle East, India & Africa",
        "organization": "H World International",
        "photoUrl": "https://static.swapcard.com/public/images/1520d185856a42d8883a3dcb4b287cd1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mw==",
                "title": "Beyond Borders: Strategic Fund Structuring for Cross-Border Investments to transform the Global Hospitality Landscape",
                "categories": [
                    "Projects & Destinations",
                    "Global Investments",
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU2MzY1OA==",
                "title": "Hospitality Asset Stability: Balancing Financial Strength for Owners & Brands",
                "categories": [
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg4Ng==",
                "title": "The Future Is East: Mapping the Mindset of Tomorrow’s Asian Tourist",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "R8nsZA6qHKw",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI5Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "6e7ce059-2e73-42fa-86b1-1767b2200711",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI5MQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE3OTYzMzM=",
        "type": null,
        "firstName": "Sheikh Muhammad",
        "lastName": "Noman",
        "jobTitle": "Founder and Chief Executive Officer",
        "organization": "Pegasus Capital Investments",
        "photoUrl": "https://static.swapcard.com/public/images/24a3b86d171042bc8ec09c33ea040f18.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0MTYzNQ==",
                "title": "PitchPoint: The FHS Investment Spotlight",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "hiMfIjoW8WI",
                    "id": "RmllbGRWYWx1ZV8yODM4MzQyNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "ba7921b4-eb35-4f8d-86d2-fcb9bbf7c3e1",
                    "id": "RmllbGRWYWx1ZV8yODM4MzQyOQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Investor - PitchPoint",
                    "id": "RmllbGRWYWx1ZV8yODQ1NTc1MQ=="
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDAzODM0MTA=",
        "type": "Moderator",
        "firstName": "Pelumi",
        "lastName": "Nubi",
        "jobTitle": "Founder",
        "organization": "Nubi Network",
        "photoUrl": "https://static.swapcard.com/public/images/339472298c244bc7ae0028fb9d6ea337.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjY1MzY3Ng==",
                "title": "FHS Africa Lifetime Achievement Award: A Life in Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg5OQ==",
                "title": "TenX Leadership Talk: Driving Change Across a Continent",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "EYmFmMDbCak",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM2NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "31629000-d1f4-418e-bd39-760bd32809e6",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM2Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Media & PR",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MDgxNjY=",
        "type": "Speaker",
        "firstName": "Duncan",
        "lastName": "O'Rourke",
        "jobTitle": "Chief Executive Officer, MEA APAC, PM&E",
        "organization": "Accor Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/66595e45adcf4b439209967432628876.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzY0OQ==",
                "title": "Leading with Purpose: Commitment to People, Planet and Profit",
                "categories": [
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyOTQ1Ng==",
                "title": "The Power of the Middle: Scalable, Sustainable, Smart",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzI2NTMwNQ==",
                "title": "Private Sector Leading the Way: Investors and Operators at the Forefront",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "C18hO2WoPpI",
                    "id": "RmllbGRWYWx1ZV8yODc0NzgyOQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "9f0ea874-fdf8-44f4-b350-2fedb8ab3d14",
                    "id": "RmllbGRWYWx1ZV8yODc0NzgzMQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2NzUwNjI=",
        "type": null,
        "firstName": "Jamie",
        "lastName": "Odgers",
        "jobTitle": "Vice President",
        "organization": "Elaeo Partners",
        "photoUrl": "https://static.swapcard.com/public/images/dfae8930e52442568aadc709f302fdea.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg5MA==",
                "title": "The Second Act: How Investors are Rewriting the Story of Hospitality Assets",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "9WoLEMWR2N8",
                    "id": "RmllbGRWYWx1ZV8yODczNTY4MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "19784113-4cbd-48d0-bbc9-2e5df96fabf5",
                    "id": "RmllbGRWYWx1ZV8yODczNTY4Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA0MDQyNjU=",
        "type": "Speaker",
        "firstName": "Wesam",
        "lastName": "Okasha",
        "jobTitle": "Head of Global Development",
        "organization": "TUI BLUE Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/004e2fa7959a4d6085e6e264b3c37ba3.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc4MzQ3Ng==",
                "title": "Guests' Quest for Unique Experiences: The African Approach to Authentic Leisure",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzczOA==",
                "title": "Guests' Quest for Unique Experiences: The African Approach to Authentic Leisure",
                "categories": [
                    "Focus on Africa"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYxNjAxMw==",
                "title": "Shaping Africa’s Hospitality Future: Strategic Investment and Development in Growth Markets",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjczOTMzNw==",
                "title": "Automating the Predictable, Humanizing the Exceptional: Investing in People for the Moments that Matter",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMzM2Mg==",
                "title": "Building Destinations Together: The Impact of Public-Private Partnerships",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDMyMjQ1Ng==",
                "title": "Coastal Reset: Redefining Coastal Development for the Long Term",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDM0MTYwOQ==",
                "title": "Career Journeys & Lessons from the Industry",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "translations": [
                        {
                            "value": "United Arab Emirates",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "AhDk0T82MGg",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM2Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "6a321278-3532-49a2-a87b-b60fee9b1415",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM2Ng=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3Nzc2MTE=",
        "type": null,
        "firstName": "Uzoamaka",
        "lastName": "Oshogwe",
        "jobTitle": "Managing Director & CEO",
        "organization": "Transcorp Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/36bd462207e44add8d36f50179a29c0e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMwOQ==",
                "title": "Capital Meets Culture: Financing Africa’s Tourism Transformation",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "EebYudb_NnI",
                    "id": "RmllbGRWYWx1ZV8yODc3NzczNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "d6a2ff5f-8935-43eb-885b-961f52a78381",
                    "id": "RmllbGRWYWx1ZV8yODc3NzczNA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE3ODY0NTk=",
        "type": null,
        "firstName": "Barry",
        "lastName": "O’Reilly",
        "jobTitle": "Head of Project Management UAE, Project & Development Services",
        "organization": "JLL",
        "photoUrl": "https://static.swapcard.com/public/images/2a9a9a8d5fb94fa1a64237679ac23a25.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczOTMzOQ==",
                "title": "From Groundbreaking to Grand Opening: Aligning Project Delivery with Operational Success",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "AdxSA6RO5IY",
                    "id": "RmllbGRWYWx1ZV8yODM4MTU4NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "fe55d095-fa0b-424d-a95b-75239f2b24bd",
                    "id": "RmllbGRWYWx1ZV8yODM4MTU4OA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Construction",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIyNzE1NjE=",
        "type": null,
        "firstName": "Jason",
        "lastName": "Paul Malajacan",
        "jobTitle": "Senior Vice President",
        "organization": "Artstream Hospitality Management Group",
        "photoUrl": "https://static.swapcard.com/public/images/e9917cd2615648979c35517684682b45.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzMyOTQzMQ==",
                "title": "Beyond Paradise: Discovering the Investment Potential of the Philippines",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2Nzk0NQ==",
                "title": "The Philippines Advantage: Private Insights for Strategic Investors",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "0jOrBHWRFSE",
                    "id": "RmllbGRWYWx1ZV8yODYwNTA0Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7e246551-bbb8-4eb0-899c-dcc779154986",
                    "id": "RmllbGRWYWx1ZV8yODYwNTA0OQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MjE0MzE=",
        "type": null,
        "firstName": "Sam",
        "lastName": "Payrovi",
        "jobTitle": "Founder and Chief Executive Officer",
        "organization": "The Ark Companies",
        "photoUrl": "https://static.swapcard.com/public/images/a99e7e2354e44fffb2c7d26e58014894.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0MTYzOA==",
                "title": "PitchPoint: The FHS Investment Spotlight",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "GVORLdlOUJc",
                    "id": "RmllbGRWYWx1ZV8yODc1NzY0Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "4da0fd59-ee90-4421-9b1c-68a7fdfa260a",
                    "id": "RmllbGRWYWx1ZV8yODc1NzY0Nw=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "New Brands - PitchPoint",
                    "id": "RmllbGRWYWx1ZV8yODc5OTM4Nw=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2NzI4Mjg=",
        "type": null,
        "firstName": "Jennifer",
        "lastName": "Pettinger-Haines",
        "jobTitle": "Partner, Think Hospitality",
        "organization": "Founder, The GRIF Collective",
        "photoUrl": "https://static.swapcard.com/public/images/90dc713369a04a76a01d2bb6a577c1d4.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc2NTcyNQ==",
                "title": "From Day to Dusk: How Beach Clubs Redefine F&B, Wellness & Exclusivity",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjczMw==",
                "title": "Next-Gen Leisure: The Business of Competitive Socialising",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "NC1JhktTqEk",
                    "id": "RmllbGRWYWx1ZV8yODczNDA4OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "ae717345-f08d-4da2-bddd-e655424350a7",
                    "id": "RmllbGRWYWx1ZV8yODczNDA5Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Leisure / Entertainment",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE4NjIyMDQ=",
        "type": null,
        "firstName": "Melisa",
        "lastName": "Pezuk",
        "jobTitle": "Head of Development at AMAALA",
        "organization": "Red Sea Global",
        "photoUrl": "https://static.swapcard.com/public/images/e535a218f07e43ea8169019ca5daa382.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc4MjU5MQ==",
                "title": "The Misconception Myth: Why Branded Residences Aren’t Just Hotels with Keys",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "3iI4X8dJD84",
                    "id": "RmllbGRWYWx1ZV8yODM5Nzk1Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "3baa3f30-929a-4f57-800a-75e9c153a71b",
                    "id": "RmllbGRWYWx1ZV8yODM5Nzk1OA=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0Mzk1NzU=",
        "type": null,
        "firstName": "Ronald",
        "lastName": "Philip",
        "jobTitle": "Vice President - Investment & Corporate Development",
        "organization": "Dubai World Trade Centre",
        "photoUrl": "https://static.swapcard.com/public/images/44bd8a0f490045e4a39672addbd61a3d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjk5NDU0NQ==",
                "title": "25 Jump Street: Shaping Dubai’s Next Culinary, Bar, Art & Culture Destination",
                "categories": [
                    "F&B Experience"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "f-and-b-experience",
                        "translations": [
                            {
                                "value": "F&B Experience"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkwOA==",
                "title": "Investing in Mixed-Use Real Estate: Strategies for Maximizing Value in Modern Developments",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Dx_HJFxgJUc",
                    "id": "RmllbGRWYWx1ZV8yODcxNjQyMw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "3d9cce4c-cc57-4931-9d5d-0620c827b110",
                    "id": "RmllbGRWYWx1ZV8yODcxNjQyNw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDMzMDM=",
        "type": null,
        "firstName": "Rosa",
        "lastName": "Piro",
        "jobTitle": "Chief Investment Officer",
        "organization": "Arada",
        "photoUrl": "https://static.swapcard.com/public/images/08f9fc81218941db8921678dc03d98ca.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Nw==",
                "title": "Making Standalones Work - Bringing the Brand to Life in the Absence of a Co-Located Hotel",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjc0NQ==",
                "title": "The Perfect Fit: Selecting the Right Brand for Residential Success",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "kAT9HIYu9Ps",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI4MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "76a24802-4d8e-41ac-bf31-0d7b574fde24",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI3OQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzkwMTAxMTY=",
        "type": null,
        "firstName": "Arjan",
        "lastName": "Pit",
        "jobTitle": "Managing Director",
        "organization": "UNS United Network Studio",
        "photoUrl": "https://static.swapcard.com/public/images/16d7f37e6ea345bdbb00a67350adfe34.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODkxOA==",
                "title": "Beyond the Tangible, Towards the Meaningful: Reimagining Perceived Luxury",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "gBjv8GCj6FA",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMyMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "c79ff702-3a21-4b4d-95b8-3085871b142a",
                    "id": "RmllbGRWYWx1ZV8yODcxMzMzNw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Architecture & Design",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2NDQ1MjE=",
        "type": "Speaker",
        "firstName": "Alessandra",
        "lastName": "Priante",
        "jobTitle": "President",
        "organization": "ENIT SpA",
        "photoUrl": "https://static.swapcard.com/public/images/560270140111449cb76f5ad83d9d983b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTkxNDk2MQ==",
                "title": "TenX Leadership Talks: Insights and Learnings in the Journey of Growing Your Destination",
                "categories": [
                    "Talks",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk5NDQzOA==",
                "title": "From Heritage to Growth: New Hospitality Investment Hotspots in Italy",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Qh4Ot6QzRB4",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQyNw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "19af90a1-0baf-4ba8-bde7-374b9833cc31",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQyNg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Government / Tourism Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0OTUyNTY=",
        "type": null,
        "firstName": "Daniel",
        "lastName": "Pugh",
        "jobTitle": "Partner - Head of Hospitality Valuation & Advisory",
        "organization": "Knight Frank MENA",
        "photoUrl": "https://static.swapcard.com/public/images/ac0d799491e240ee9bbaf3f392beb286.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMwNQ==",
                "title": "Private Sector Leading the Way: Investors and Operators at the Forefront",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "-erludnAFEE",
                    "id": "RmllbGRWYWx1ZV8yODcxODM3OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f3f5f996-13df-4a77-bede-2f987f62ac0e",
                    "id": "RmllbGRWYWx1ZV8yODc3NjE1OQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Moderator",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgzNjI3OQ==",
                        "translations": [
                            {
                                "name": "Type",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE3NTYzNzM=",
        "type": null,
        "firstName": "Zachary",
        "lastName": "Pulman",
        "jobTitle": "Creative Director",
        "organization": "Zachary Pulman Design Studio",
        "photoUrl": "https://static.swapcard.com/public/images/d1faa29233ae49efadeb6a6a0912a08b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjczMw==",
                "title": "Next-Gen Leisure: The Business of Competitive Socialising",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "mviG-rdvsRY",
                    "id": "RmllbGRWYWx1ZV8yODM3ODg5OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "2d983e6b-aa35-4476-9327-8d47fcf5cd1c",
                    "id": "RmllbGRWYWx1ZV8yODM3ODkwMw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Leisure / Entertainment",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEyMzU2Nzk=",
        "type": "Moderator",
        "firstName": "Dinky",
        "lastName": "Puri",
        "jobTitle": "Founder & CEO",
        "organization": "Eaglewing Hospitality Services",
        "photoUrl": "https://static.swapcard.com/public/images/29e1bb8cc3974989bd835c00fc8db9c1.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjczOQ==",
                "title": "Owners Forum: The Power Struggle – Owners vs. Operators (Invitation-Only)",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQ2NTU5MA==",
                "title": "Living, Not Lodging: The Convergence of Residential, Extended Stay & Hospitality in KSA",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "DsRcKhM6Qa4",
                    "id": "RmllbGRWYWx1ZV8yODI0MDk5NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e6b5e411-9769-429c-9648-b71249865558",
                    "id": "RmllbGRWYWx1ZV8yODc1OTM4Mg=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2NzI1Mjg=",
        "type": null,
        "firstName": "Daniel",
        "lastName": "Radwansky",
        "jobTitle": "Co-Founder and Chief Executive Officer",
        "organization": "StegX",
        "photoUrl": "https://static.swapcard.com/public/images/bea581fd9e4e467c99d47b598c65e0a3.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzMwMzMwMQ==",
                "title": "Tokenization & Digital Assets: Transforming the Future of Real Estate with Blockchain",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "dpw9lYlZyUU",
                    "id": "RmllbGRWYWx1ZV8yODczMzk3MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "83cd847c-a160-4bc5-ac76-337f6c80b178",
                    "id": "RmllbGRWYWx1ZV8yODc1OTM5Mw=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE1NzI1ODM=",
        "type": "Speaker",
        "firstName": "Vijay",
        "lastName": "Raghavan",
        "jobTitle": "Director",
        "organization": "Golden Sands Hotel Co. LLC.",
        "photoUrl": "https://static.swapcard.com/public/images/0321768571a8459d83ce4a73eab6915b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAxNQ==",
                "title": "Hotel Transactions: Insights for 2023",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYxMg==",
                "title": "Global Insights: Aligning Growth Strategies for Asset Owner Success",
                "categories": [
                    "Global Investments"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg5MA==",
                "title": "The Second Act: How Investors are Rewriting the Story of Hospitality Assets",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "2wablJukQQ0",
                    "id": "RmllbGRWYWx1ZV8yODM0NDA2NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "68fd3dd9-232f-4717-9278-5ba7953003d4",
                    "id": "RmllbGRWYWx1ZV8yODM0NDA3OA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Owner",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEyNjkwODY=",
        "type": "Speaker",
        "firstName": "Jean-Baptiste",
        "lastName": "Recher",
        "jobTitle": "Chief Development Officer Luxury Brands Middle East, Africa and Turkiye",
        "organization": "Accor",
        "photoUrl": "https://static.swapcard.com/public/images/e4e91957b92b4d7cbdea54bebe71e99d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzk1Nw==",
                "title": "Making Standalones Work - Bringing the Brand to Life in the Absence of a Co-Located Hotel",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjk5OQ==",
                "title": "Beyond Yield: The Emotional Architecture of Luxury Resort Brands",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDMyMjQ1NQ==",
                "title": "Luxury Resort & Lodge Feasibility in Africa: Getting the Fundamentals Right",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk3MzgzOQ==",
                "title": "The Branded Residence Masterclass",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTc2OA==",
                "title": "Ultra-Luxury or Smart Luxury? Capital Allocation in a Changing Saudi Market",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "United Arab Emirates",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Kujr-eJlcnA",
                    "id": "RmllbGRWYWx1ZV8yODI1MzMwNw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "9a6b39d9-a445-48e1-b573-0150014f0cde",
                    "id": "RmllbGRWYWx1ZV8yODI1MzMwNg=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2ODU3MDY=",
        "type": "Speaker",
        "firstName": "Julien",
        "lastName": "Renaud Perret",
        "jobTitle": "Executive Director Hospitality",
        "organization": "New Murabba",
        "photoUrl": "https://static.swapcard.com/public/images/1fb52e3267694691b0eca0cd3524a723.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYzMjY2MA==",
                "title": "Building for Tomorrow: At the heart of Riyadh’s New Downtown",
                "categories": [
                    "Brand & Destination"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY0NjA1MQ==",
                "title": "The Mukaab: Building Tomorrow’s Opportunities, Today",
                "categories": [
                    "Intelligence Talks"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0ODk4Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "intelligence-talks",
                        "translations": [
                            {
                                "value": "Intelligence Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzI1OTYwMw==",
                "title": "Shaping Tomorrow’s Icons: The Power of Storytelling in Mega-Developments",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc4MDE2OA==",
                "title": "Future of Hospitality Concepts and Operating Models",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "T9EKbyGiMLg",
                    "id": "RmllbGRWYWx1ZV8yODczOTExNg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5d14db08-e079-4172-9d6c-57c4809a8a20",
                    "id": "RmllbGRWYWx1ZV8yODczOTExNQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDMwOTQ3NDA=",
        "type": "Moderator",
        "firstName": "Marco S.",
        "lastName": "Rentsch",
        "jobTitle": "Partner | Global Consulting Hospitality & Tourism Center of Excellence",
        "organization": "PwC Middle East",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/9f3ea8651f7f430fab7ebea4b869ab7b.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAwMg==",
                "title": "Converging Digital Transformation in Hospitality: Cross-Industry Best Practices and Implementation Strategies",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0MQ==",
                "title": "The Future of Hospitality Management: From White Label Operators, Franchising, to Traditional Management Agreements",
                "categories": [
                    "Global Investments",
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-investments",
                        "translations": [
                            {
                                "value": "Global Investments"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc4MDE2OA==",
                "title": "Future of Hospitality Concepts and Operating Models",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "PfytY-0INJk",
                    "id": "RmllbGRWYWx1ZV8yODg2MDc1NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e337975d-6e5f-4cc7-b05d-0a9f663a7284",
                    "id": "RmllbGRWYWx1ZV8yODg2MDc1NA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA4Mzk1MDk=",
        "type": null,
        "firstName": "Pedro",
        "lastName": "Ribeiro",
        "jobTitle": "Chief Commercial Officer",
        "organization": "Rua Al Madinah Holding",
        "photoUrl": "https://static.swapcard.com/public/images/80811871e1164f51a7103c7c9b9871f9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODkwOA==",
                "title": "Investing in Mixed-Use Real Estate: Strategies for Maximizing Value in Modern Developments",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "RJAIRHvK3MM",
                    "id": "RmllbGRWYWx1ZV8yODA4MjkxMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "9015dc8f-d361-46af-a66f-9046928a1d9c",
                    "id": "RmllbGRWYWx1ZV8yODA4MjkxMQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE4OTA4MzA=",
        "type": null,
        "firstName": "Scott",
        "lastName": "Richardson",
        "jobTitle": "Academic Dean",
        "organization": "Abu Dhabi Hospitality Academy - Les Roches",
        "photoUrl": "https://static.swapcard.com/public/images/36036f397fac47529adfb5d9a50e9dd8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODc3OA==",
                "title": "Rebuilding the Workforce: Attracting and Retaining Talent in Hospitality",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "TuLhQjuePbY",
                    "id": "RmllbGRWYWx1ZV8yODQxMjM3NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "bc9cc4a5-51eb-4579-8a8f-70fc2291e7f4",
                    "id": "RmllbGRWYWx1ZV8yODQxMjM3Nw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0OTM3NjM=",
        "type": null,
        "firstName": "Adelajda",
        "lastName": "Roka",
        "jobTitle": "General Director",
        "organization": "Territorial Development Agency",
        "photoUrl": "https://static.swapcard.com/public/images/cfd2a44458ed4b3b8583ea021dab0357.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0MTYzMQ==",
                "title": "Soundscapes of Hospitality: Albania",
                "categories": [
                    "Country Pavilion Showcase"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Ng==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "country-pavilion-showcase",
                        "translations": [
                            {
                                "value": "Country Pavilion Showcase"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "YZVDF0azH2g",
                    "id": "RmllbGRWYWx1ZV8yODY2MjMxNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "68b006c9-8112-4e02-b676-de3dd96eff76",
                    "id": "RmllbGRWYWx1ZV8yODY2MjMxNw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Government / Tourism Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1MjAyMTY=",
        "type": null,
        "firstName": "Stephen",
        "lastName": "Rossouw",
        "jobTitle": "Senior Development Director",
        "organization": "New Murabba",
        "photoUrl": "https://static.swapcard.com/public/images/ef410a1da7994f32b89ff2bf093a9e82.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjc0NQ==",
                "title": "The Perfect Fit: Selecting the Right Brand for Residential Success",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "ELrEV_9Yskg",
                    "id": "RmllbGRWYWx1ZV8yODY4MzgzNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "935f1c04-8908-4d39-9397-f6cd358e8acc",
                    "id": "RmllbGRWYWx1ZV8yODc3Mzk2Mg=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MTI2MzQ=",
        "type": null,
        "firstName": "Federico",
        "lastName": "Rota",
        "jobTitle": "Deputy Chief Executive Officer",
        "organization": "Al Ain Asset Management",
        "photoUrl": "https://static.swapcard.com/public/images/d701dda0c16041629b308d44787847f8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODkyNg==",
                "title": "The Real Deal: Unpacking the Financial Realities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "e2kuNhbxKkk",
                    "id": "RmllbGRWYWx1ZV8yODc1MDI1MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "4a5929fe-efef-485a-b17b-acfa3c8ce467",
                    "id": "RmllbGRWYWx1ZV8yODc5OTQwMg=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0Mzk5Njk=",
        "type": null,
        "firstName": "Michelle",
        "lastName": "Russo",
        "jobTitle": "CEO & Founder",
        "organization": "hotelAVE",
        "photoUrl": "https://static.swapcard.com/public/images/544611d1b3b8419abde11a8f528368b1.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYxMjI1OA==",
                "title": "A GLOBAL PRESIDENTS FORUM: The Bulls & Bears of Global Capital Markets",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "iBpjVfugFlA",
                    "id": "RmllbGRWYWx1ZV8yODcwMDY3OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "6a33647b-444a-4c8c-933e-e0baa90ad710",
                    "id": "RmllbGRWYWx1ZV8yODgwNjkyOQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Asset Manager",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA3MTMzNTA=",
        "type": null,
        "firstName": "Sophie",
        "lastName": "Ryan",
        "jobTitle": "Head of Corporate Communications, Marketing and Brand",
        "organization": "Dubai Racing Club",
        "photoUrl": "https://static.swapcard.com/public/images/85fe81c5ecf64f4380e4ad2c339edd7d.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczNDE1MQ==",
                "title": "Beyond the Game: How Immersive Sports and Culture Drive Tourism Growth",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "lusNwlwpu9s",
                    "id": "RmllbGRWYWx1ZV8yODAyMzk3NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "2052468b-85ae-4234-a669-9e022ec8291f",
                    "id": "RmllbGRWYWx1ZV8yODM5OTIyNg=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2MzI2OTc=",
        "type": null,
        "firstName": "Paul",
        "lastName": "Saba",
        "jobTitle": "Vice President and Senior Counsel - EMEA",
        "organization": "Marriott International",
        "photoUrl": "https://static.swapcard.com/public/images/26ed7f8d9cf34cf8b785dd00b71ab676.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0NTczNg==",
                "title": "Legal Structures: Protecting Interests of Investors, Purchasers & Brands",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "pDx6FDtT9eM",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQyNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7b3daa67-c299-4403-9204-61d250cf86a4",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQyMw=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2MjA0MDA=",
        "type": "Speaker",
        "firstName": "Samer",
        "lastName": "Sabra",
        "jobTitle": "Chief Hospitality Officer",
        "organization": "Jabal Omar Development Company",
        "photoUrl": "https://static.swapcard.com/public/images/8744509ba8354d31abfb050affddc9ed.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg3MTQ0NQ==",
                "title": "How the changing City Dynamic influences Hospitality Offerings and the Consumer",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU2MzY1OA==",
                "title": "Hospitality Asset Stability: Balancing Financial Strength for Owners & Brands",
                "categories": [
                    "Hotelisation of Traditional Assets"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzIwMTA0Mg==",
                "title": "Where Tradition Meets Modernity: Case Study by Jabal Omar Development Company",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyOTc2NQ==",
                "title": "From Reform to Investment: Building Global Partnerships in KSA",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTU0MA==",
                "title": "Who’s in Charge? Structuring Branded Residences for Long-Term Gain",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "vZWwW0MdHqA",
                    "id": "RmllbGRWYWx1ZV8yODcxNDAxNg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5a5e361b-1e58-4774-ab51-5df04754a9c1",
                    "id": "RmllbGRWYWx1ZV8yODcxNDAxNQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5MjM4MzM=",
        "type": null,
        "firstName": "Alida",
        "lastName": "Saleh",
        "jobTitle": "Head of Sustainability, Consulting - MEA",
        "organization": "JLL",
        "photoUrl": "https://static.swapcard.com/public/images/0714ad19bab54b879bcdd9f84b78bf5c.webp",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzQwMjcxNA==",
                "title": "The Next Chapter of Real Estate: Regeneration Over Preservation",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "vbaH3ps1K40",
                    "id": "RmllbGRWYWx1ZV8yODQzOTA0NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "1a3ca0c2-aef5-4c5d-902d-0696f51887f3",
                    "id": "RmllbGRWYWx1ZV8yODQzOTA3NQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE1NDc1MDY=",
        "type": null,
        "firstName": "Rahul",
        "lastName": "Salgia",
        "jobTitle": "Founder & CEO",
        "organization": "DigiValet",
        "photoUrl": "https://static.swapcard.com/public/images/e2225a6fcb174f869dec0029e844b5b7.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc4MjU5Mw==",
                "title": "Decoding the Data: What Guest & User Trends Tell Us",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "lpY8RXaouP0",
                    "id": "RmllbGRWYWx1ZV8yODMzMTIwMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "6032f828-593f-4e9a-920f-4f2370219a1a",
                    "id": "RmllbGRWYWx1ZV8yODMzMTIwNw=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5NjIyNjc=",
        "type": null,
        "firstName": "Zayan",
        "lastName": "Salih",
        "jobTitle": "Chief Executive Officer",
        "organization": "MDC Developers",
        "photoUrl": "https://static.swapcard.com/public/images/c1c50496024b48158e96cdd211eafc15.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjc0NQ==",
                "title": "The Perfect Fit: Selecting the Right Brand for Residential Success",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "AWD33EwIpng",
                    "id": "RmllbGRWYWx1ZV8yODgyMzIzNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "197c654f-f62c-4c05-b6b6-f40c6e3a868a",
                    "id": "RmllbGRWYWx1ZV8yODgyMzIzNA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2MTcxNTE=",
        "type": "Speaker",
        "firstName": "Jordi",
        "lastName": "Sanchís",
        "jobTitle": "Senior Development Director",
        "organization": "Meliá Hotels International",
        "photoUrl": "https://static.swapcard.com/public/images/addb55e23ef942df95b495c35e01720c.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTI5MzY=",
                "title": "Three Minute Pitch - The product differentiation – what is out there and would you invest in it (instead of investing in full-service hotel)?",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfOTk3NjU=",
                "title": "Is there a difference between all-brand companies and “leisure/ resort brands” - what are they focused at, what are their strengths and weaknesses…?",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfNDQwNjYzMg==",
                "title": "Reinventing All-Inclusive: How Resorts Are Meeting the New Demand for Premium, Personalised Control",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDAwNjI1NDM=",
        "type": null,
        "firstName": "Stefano",
        "lastName": "Saporetti",
        "jobTitle": "Director of Brand Diversification",
        "organization": "Aston Martin",
        "photoUrl": "https://static.swapcard.com/public/images/192e3af65e8443a7bbaccec1513a2d08.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzMwMjkzNA==",
                "title": "Driving New Experiences: The Evolution of an Automotive Luxury Brand into Hospitality",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Ug6DN-HxMwE",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM0Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "847e0631-cd0e-46c7-871e-24f66a5ef4c1",
                    "id": "RmllbGRWYWx1ZV8yODA5MjI0MQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2MzY0Mjc=",
        "type": null,
        "firstName": "Piergiorgio",
        "lastName": "Schirru",
        "jobTitle": "Executive Vice President",
        "organization": "Blastness",
        "photoUrl": "https://static.swapcard.com/public/images/afbf1b623d61489aa9a487fd7ef3f2f8.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA4ODY3OQ==",
                "title": "From Search to Stay: Enhancing Booking Tech for a Seamless Guest Journey",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjcyMQ==",
                "title": "The Human Touch, Enhanced: Using AI to Personalize Every Step of the Hospitality Journey",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2Nzk1Mw==",
                "title": "Smart Hospitality, Smarter Returns: Measuring the ROI of Automation",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "4OjDgsXF-JQ",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMxMw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5c771e6e-b000-4a29-a9a6-ed106c585a36",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMxMg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDMyMjc=",
        "type": null,
        "firstName": "Dr Achim",
        "lastName": "Schmitt",
        "jobTitle": "Dean",
        "organization": "EHL Hospitality Business School",
        "photoUrl": "https://static.swapcard.com/public/images/59c9b07cb33945c89c4da07845a14f95.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODc3Ng==",
                "title": "A Wake-Up Call for Hospitality: The Race for Talents is On the Rise",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "EpuTSPEzty0",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI2OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "cf73c5ba-7857-45c4-82e5-ff4e653e6d17",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI2Nw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIwODM0ODU=",
        "type": null,
        "firstName": "Stephan",
        "lastName": "Schupbach",
        "jobTitle": "Partner / Owner and Chief Executive Officer",
        "organization": "Chedi Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/b48a814c92ce4a32b58d83b8b6996a34.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcwOQ==",
                "title": "Serving the Next Wave of Visitors: Meeting Mixed-Purpose Demand",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "QO-GwFkl6HU",
                    "id": "RmllbGRWYWx1ZV8yODQ5ODc4MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "c5b7f07b-7ee8-420f-af3b-ee2d06377273",
                    "id": "RmllbGRWYWx1ZV8yODQ5ODc4OA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDExNjc0MjY=",
        "type": "Speaker",
        "firstName": "Muin",
        "lastName": "Serhan",
        "jobTitle": "Chief Executive Officer",
        "organization": "Amsa Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/144a200935cd4bdfa2c5abf157ce8a37.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjQ3NjM4NA==",
                "title": "Rethinking Hospitality Schools: Education, Experience & Environment",
                "categories": [
                    "NextGen Talent & Hospitality Education"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzYxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen-talent-and-hospitality-education",
                        "translations": [
                            {
                                "value": "NextGen Talent & Hospitality Education"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjUzNTg4NA==",
                "title": "Could Hotel F&B set a World first by dominating the Mid Sector Dining Market in the kingdom?",
                "categories": [
                    "Luxury, F&B, and Experiential Hospitality"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNzA3NTM4MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "luxury-fandb-and-experiential-hospitality",
                        "translations": [
                            {
                                "value": "Luxury, F&B, and Experiential Hospitality"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjQxMQ==",
                "title": "The Future Workforce: Empowering Talent, Leadership, and Inclusion",
                "categories": [
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMw==",
                "title": "Affordable, Scalable, In Demand: The Midscale Hotel Evolution",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTc3Mg==",
                "title": "From Ambition to Execution: The Playbook for Growth in Saudi Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "4x9c3GaQGi8",
                    "id": "RmllbGRWYWx1ZV8yODIxMTczNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e7ad3013-d78f-4ca5-86a7-bfdbe17d1660",
                    "id": "RmllbGRWYWx1ZV8yODIxMTczMw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0NDAwODA=",
        "type": "Speaker",
        "firstName": "Ali",
        "lastName": "Shahid",
        "jobTitle": "Chief Executive Officer",
        "organization": "The Bench",
        "photoUrl": "https://static.swapcard.com/public/images/45fc1d8c9cab4063bd3bf8207e26f47e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA0MQ==",
                "title": "Morning Run",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzA0Mg==",
                "title": "How will you 'Lead The Change'?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAxMg==",
                "title": "Morning Run",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTYwODMyNA==",
                "title": "Announcements & Signing Ceremonies",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgwOTM2Mw==",
                "title": "Fireside Chat with Desdemona The Robot",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgyMDAyMQ==",
                "title": "Beyond the Hype - A Practical Insight into AI and the Future of Business",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA1NjYzNw==",
                "title": "Beyond the AI Hype - An Interactive Workshop with Practical Problem Solving Demos",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc0MTYzNQ==",
                "title": "PitchPoint: The FHS Investment Spotlight",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc0MTYzOA==",
                "title": "PitchPoint: The FHS Investment Spotlight",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "A17xgfJEbPU",
                    "id": "RmllbGRWYWx1ZV8yODcxODMwMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "8b182089-7e8b-452a-992e-209c20c7ca5a",
                    "id": "RmllbGRWYWx1ZV8yODgwMjU1Ng=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5OTIzNTI=",
        "type": "Speaker",
        "firstName": "Lada",
        "lastName": "Shelkovnikova",
        "jobTitle": "Partner Hotels & Hospitality",
        "organization": "Watson Farley & Williams LLP",
        "photoUrl": "https://static.swapcard.com/public/images/528b359d38c043c184204673e00cc8cb.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYxNjAwNA==",
                "title": "Branded Residences Contracting – The New World of Agreement",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc0NTczNg==",
                "title": "Legal Structures: Protecting Interests of Investors, Purchasers & Brands",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "paniq2kf58s",
                    "id": "RmllbGRWYWx1ZV8yODQ2NTI0Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "2fe42acd-59c5-4cef-92a1-471830492aec",
                    "id": "RmllbGRWYWx1ZV8yODQ2NTI0NQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                },
                {
                    "translations": [
                        {
                            "value": "Lawyer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDMyNDg=",
        "type": "Speaker",
        "firstName": "Jitesh",
        "lastName": "Shetty",
        "jobTitle": "CEO & Co-founder",
        "organization": "Credibl Innovations Inc",
        "photoUrl": "https://static.swapcard.com/public/images/5f9343cd47a348bdb432c63b7b50981d.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjE2MDI3NA==",
                "title": "Data-Driven Sustainability: Transforming Hospitality with AI",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjkwMTUyNw==",
                "title": "Mitigating Risk, Managing Costs: Hospitality’s Climate-Resilient Playbook",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "jGOZvf6Mp0I",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI3MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "d3701f8b-94b9-4666-a8b5-38a00b6b3df6",
                    "id": "RmllbGRWYWx1ZV8yODA5NDg5Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE2ODgwMjU=",
        "type": null,
        "firstName": "Khalid",
        "lastName": "Shiba",
        "jobTitle": "Chief Information Smart Officer",
        "organization": "HDL Automation",
        "photoUrl": "https://static.swapcard.com/public/images/67703b7eca0440dc8c827b97238a6638.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc2Nzk1Mw==",
                "title": "Smart Hospitality, Smarter Returns: Measuring the ROI of Automation",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "1ghN6WlZyJ8",
                    "id": "RmllbGRWYWx1ZV8yODM2OTUxMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "39f9f531-333d-4635-b2cb-a997412e7733",
                    "id": "RmllbGRWYWx1ZV8yODg5MzU0MA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE4NzM4MDY=",
        "type": null,
        "firstName": "Sajid",
        "lastName": "Siddique",
        "jobTitle": "Senior Vice President - Head - Real Estate Structuring & Advisory",
        "organization": "Mashreq Bank",
        "photoUrl": "https://static.swapcard.com/public/images/283aaef666d440d78f67a1ccb229d887.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg3NQ==",
                "title": "Mapping the Money: Tracking Smart Capital in a Changing Hospitality Landscape",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "D61KuSFy49w",
                    "id": "RmllbGRWYWx1ZV8yODQwNzkzMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a2d045c0-5d4b-4cdd-870d-0a99aa0f89d6",
                    "id": "RmllbGRWYWx1ZV8yODQwNzkzNQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MjY1NTY=",
        "type": null,
        "firstName": "Benjamin",
        "lastName": "Sinclair",
        "jobTitle": "Chief Brand Development Officer",
        "organization": "Faena Hotels & Residences",
        "photoUrl": "https://static.swapcard.com/public/images/eeb8ef4d59894c87b1bbd6d38d6e6b02.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc4MDE2OA==",
                "title": "Future of Hospitality Concepts and Operating Models",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "CTdqcyozR98",
                    "id": "RmllbGRWYWx1ZV8yODc1OTM1OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "28f75f50-c0be-4d6e-b988-eba4864291be",
                    "id": "RmllbGRWYWx1ZV8yODc1OTM2MQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1MzU0NzY=",
        "type": "Moderator",
        "firstName": "A.J.",
        "lastName": "Singh",
        "jobTitle": "Professor",
        "organization": "UTRGV Robert C. Vackar College of Business and Entrepreneurship",
        "photoUrl": "https://static.swapcard.com/public/images/1fb7dff7af2d430e9959241d9694222f.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjQ3NjM4NA==",
                "title": "Rethinking Hospitality Schools: Education, Experience & Environment",
                "categories": [
                    "NextGen Talent & Hospitality Education"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzYxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen-talent-and-hospitality-education",
                        "translations": [
                            {
                                "value": "NextGen Talent & Hospitality Education"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYxMjI1OA==",
                "title": "A GLOBAL PRESIDENTS FORUM: The Bulls & Bears of Global Capital Markets",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "ZcaetdHT6hk",
                    "id": "RmllbGRWYWx1ZV8yODY4NzA4OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "32646029-eb04-4e03-af53-d02f546fbf62",
                    "id": "RmllbGRWYWx1ZV8yODY4NzA4OA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Education",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3MTI1ODc=",
        "type": "Speaker",
        "firstName": "Gaurav",
        "lastName": "Sinha",
        "jobTitle": "Founder and Chief Executive Officer",
        "organization": "Insignia Worldwide",
        "photoUrl": "https://static.swapcard.com/public/images/5c0bdbed5ede499d8ea3309aa7f40819.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM2OTk=",
                "title": "How to promote Saudi as a sustainable destination",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTUzMzAxNg==",
                "title": "Preserving Legacy: Embracing Heritage in Hospitality Design",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5MTg0MQ==",
                "title": "Empowering Hospitality: Leading the Way in Crafting a Diverse, Inclusive Lifestyle Brand and Transforming Human Experience",
                "categories": [
                    "Talks",
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE0NDE1NQ==",
                "title": "Next-Gen Lifestyle Brands: Leveraging International Branding to Integrate Local Art, Culture, and Destination Experiences",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc4MjU4OQ==",
                "title": "TenX Leadership Talk: Where Lifestyle Meets Living",
                "categories": [
                    "TenX Leadership Talk"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc3Ng==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "tenx-leadership-talk",
                        "translations": [
                            {
                                "value": "TenX Leadership Talk"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "YrQq4nJkLOs",
                    "id": "RmllbGRWYWx1ZV8yODc1MDIyOQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "8b185ea3-839c-418b-947f-027792aac998",
                    "id": "RmllbGRWYWx1ZV8yODc1MDIzMw=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDExMjI4MzM=",
        "type": null,
        "firstName": "Daria",
        "lastName": "Smith",
        "jobTitle": "Managing Director MEA",
        "organization": "The Bench",
        "photoUrl": "https://static.swapcard.com/public/images/611d80cc5422499981a2a951900b2289.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg5Mzk3Mw==",
                "title": "Welcome back to the Future Stage",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY2NTc0MQ==",
                "title": "Curated Connections - Technology, AI & Tech",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjczNA==",
                "title": "From First Timer to Power Player: Making the Most of FHS World",
                "categories": [
                    "Networking"
                ],
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "networking",
                        "translations": [
                            {
                                "value": "Networking"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "9H_A_wMNU1Y",
                    "id": "RmllbGRWYWx1ZV8yODE5Nzk4NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e2a78e59-9b21-4d3f-8f2d-f63f8ea907d8",
                    "id": "RmllbGRWYWx1ZV8yODE5Nzk4Mw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI3NTU4NjY=",
        "type": null,
        "firstName": "VALERIO",
        "lastName": "SOLDANI",
        "jobTitle": "TRADE COMMISSIONER TO THE UAE AND OMAN",
        "organization": "ITALIAN TRADE COMMISSION",
        "photoUrl": "https://static.swapcard.com/public/images/3af92776657c43d0a28c8ee81a808dcf.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzUzMjk3OQ==",
                "title": "From Heritage to Growth: New Hospitality Investment Hotspots in Italy",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "fr0ZV5hmDus",
                    "id": "RmllbGRWYWx1ZV8yODc3MDM2Ng=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "7aba2be3-5621-43ca-aff3-0944455751e3",
                    "id": "RmllbGRWYWx1ZV8yODgxMDc2NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Government / Tourism Official",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5Nzc2NDc=",
        "type": null,
        "firstName": "Jesko von den",
        "lastName": "Steinen",
        "jobTitle": "Experience Consulting Innovation Lead",
        "organization": "PwC Middle East",
        "photoUrl": "https://static.swapcard.com/public/images/319023e8a9b4465387c47172aa8f3ac9.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcyMQ==",
                "title": "The Human Touch, Enhanced: Using AI to Personalize Every Step of the Hospitality Journey",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "gblhBdhQMc8",
                    "id": "RmllbGRWYWx1ZV8yODQ1OTQ2Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "09ca62db-4b13-4161-a1fd-f644f3e8c317",
                    "id": "RmllbGRWYWx1ZV8yODQ1OTQ2Ng=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDExNzI5MTQ=",
        "type": null,
        "firstName": "Armand",
        "lastName": "Steinmeyer",
        "jobTitle": "VP Business Development",
        "organization": "The Ascott Limited",
        "photoUrl": "https://static.swapcard.com/public/images/fcdffee5ba4b4ba9a721a1d4c93ed95e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODkxMw==",
                "title": "“Hybrid Lives” – The Big Shift and Vision of Future Spaces",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "QVLXpRX4vSw",
                    "id": "RmllbGRWYWx1ZV8yODIxMzk5MA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "f3dfb7c4-3bb3-4ac1-8f38-da223c1b1962",
                    "id": "RmllbGRWYWx1ZV8yODIxMzk4OQ=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0Mzk5NDk=",
        "type": null,
        "firstName": "Adrian",
        "lastName": "Strittmatter",
        "jobTitle": "Chief Executive Officer",
        "organization": "Saentys",
        "photoUrl": "https://static.swapcard.com/public/images/e52d5f64150f4273a75dea1152cae812.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxOQ==",
                "title": "Marketing Case Studies - Short Presentations by Leading Marketing Professionals Who Have Helped Drive the Success of Branded Residence Projects",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzQwMjc2Ng==",
                "title": "Iconic by Design: Crafting The Next  Wave of Luxury Living",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "QsNPlS0a2hM",
                    "id": "RmllbGRWYWx1ZV8yODcxODE4Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "6a5812ff-e72b-4ff4-a738-54408278e344",
                    "id": "RmllbGRWYWx1ZV8yODg2NDExNg=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI4MzUwMTg=",
        "type": "Speaker",
        "firstName": "Shafi",
        "lastName": "Syed",
        "jobTitle": "Global Head, Hotel Development & Acquisitions",
        "organization": "Equinox Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/ad7f93afb486456fa4cccb328def120c.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYxMDAyMQ==",
                "title": "Beyond Hospitality: How Fashion, Automotive Brands and Private Clubs are Shaping Branded Residences",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMg==",
                "title": "Wellbeing Ecosystems: Building Destinations Around Health and Harmony",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "FKpfKZycg6A",
                    "id": "RmllbGRWYWx1ZV8yODgwMjE1Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "18272861-2b49-4966-84c1-3e4706906c04",
                    "id": "RmllbGRWYWx1ZV8yODgwMjE1Ng=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI5NTYyNDg=",
        "type": null,
        "firstName": "Cheick-Oumar",
        "lastName": "Sylla",
        "jobTitle": "Division Director for North Africa and the Horn of Africa",
        "organization": "IFC",
        "photoUrl": "https://static.swapcard.com/public/images/085ad8f8b88449ffa7d66a14d08053c7.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzI2NTMxMQ==",
                "title": "Tourism Driving Growth and Capital",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "lhI1zLH8hTY",
                    "id": "RmllbGRWYWx1ZV8yODgyMTI1OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "effdaa63-7044-43f9-8cb4-efe171623ce9",
                    "id": "RmllbGRWYWx1ZV8yODgyMTg2Mg=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDM2Njg=",
        "type": "Speaker",
        "firstName": "Joe",
        "lastName": "Tabet",
        "jobTitle": "Founder - Architect",
        "organization": "JT+Partners",
        "photoUrl": "https://static.swapcard.com/public/images/12ea8fb5d1f74560952c588cedf25515.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTg1NjIzMA==",
                "title": "TenX Leadership Talks: To the Metaverse with Hospitality",
                "categories": [
                    "Talks",
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxMg==",
                "title": "Digital Transformation - The Future of Design and Customer Experience",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjUxMDkyMg==",
                "title": "The Guest Experience Reimagined: A Saudi Hospitality Design Challenge",
                "categories": [
                    "NextGen Talent & Hospitality Education"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzYxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen-talent-and-hospitality-education",
                        "translations": [
                            {
                                "value": "NextGen Talent & Hospitality Education"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjQxNw==",
                "title": "Planning with Purpose: Integrating Tourism Strategy and Conservation in Destination Development",
                "categories": [
                    "Destination Development",
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzYzNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-development",
                        "translations": [
                            {
                                "value": "Destination Development    "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjk5OQ==",
                "title": "Beyond Yield: The Emotional Architecture of Luxury Resort Brands",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzQwMjc2Ng==",
                "title": "Iconic by Design: Crafting The Next  Wave of Luxury Living",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "wOE6xU9YBMc",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI5OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "5a1feda7-257b-4620-add9-efb9282ada83",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI5Nw=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1MTkwMjk=",
        "type": null,
        "firstName": "Fouad",
        "lastName": "Talaat",
        "jobTitle": "Regional Manager MEA",
        "organization": "Booking.com",
        "photoUrl": "https://static.swapcard.com/public/images/08008a8ab5a8401a8a4aed9cc5a7be31.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjA4ODY3OQ==",
                "title": "From Search to Stay: Enhancing Booking Tech for a Seamless Guest Journey",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjcyMQ==",
                "title": "The Human Touch, Enhanced: Using AI to Personalize Every Step of the Hospitality Journey",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "NjUmrWzUsw0",
                    "id": "RmllbGRWYWx1ZV8yODY4MjIxNQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "ffb849f2-d600-4485-9095-45325a45fa58",
                    "id": "RmllbGRWYWx1ZV8yODY4MjIxNA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIxNDY2MTA=",
        "type": "Speaker",
        "firstName": "Eddy",
        "lastName": "Tannous",
        "jobTitle": "Chief Operating Officer",
        "organization": "Rotana Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/b883ce7dcd704266b4d35a1add04a681.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTU3NjUxNw==",
                "title": "EAHM Leadership Series - Creating Harmony: Aligning People, Planet, and Future Growth in Hospitality",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzcyMA==",
                "title": "Company Culture and Relationships as a Competitive Advantage",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg4Ng==",
                "title": "EAHM Leadership Series: CEO for the Day",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjQ5MA==",
                "title": "From White Label Operators, Franchising to Traditional Management Agreements  - What is the Future?",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODc3OA==",
                "title": "Rebuilding the Workforce: Attracting and Retaining Talent in Hospitality",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNjYyNw==",
                "title": "Culture Creates Value: How Leadership and Engagement Drive ROI, Brand Strength and Asset Performance",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "BvYLy1mGY78",
                    "id": "RmllbGRWYWx1ZV8yODUyNzQ2Mw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "3d1c3409-bae8-45f0-84ce-3c6df11146ec",
                    "id": "RmllbGRWYWx1ZV8yODcxODYxMA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg0MDM1ODc=",
        "type": "Speaker",
        "firstName": "David",
        "lastName": "Thomson",
        "jobTitle": "Senior Vice President Development",
        "organization": "The First Group Hospitality",
        "photoUrl": "https://static.swapcard.com/public/images/f1cef20495ca4b618a5c6a58e24af95e.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjQ3NjQ5MA==",
                "title": "From White Label Operators, Franchising to Traditional Management Agreements  - What is the Future?",
                "categories": [
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg5NA==",
                "title": "Franchise Models: A Barrier to Sustainable Hospitality—or a Catalyst for Change?",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "y5JqCc1XSc4",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI4OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "351b5cc2-249d-4c5d-a88a-617dc5c226aa",
                    "id": "RmllbGRWYWx1ZV8yODAwMzI4OA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2MzY0MjI=",
        "type": null,
        "firstName": "Daniel",
        "lastName": "Thorniley",
        "jobTitle": "President",
        "organization": "DT-Global Business Consulting",
        "photoUrl": "https://static.swapcard.com/public/images/4c5dfc9822fa4ee28fa0f939dff24c05.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg3OQ==",
                "title": "The impact of Geopolitics and your Business Outlook",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "r3G-YDaEBVQ",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMwMQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "95239acb-3552-4e98-9fe0-cd8440169de0",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMwMA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA0ODY2NTM=",
        "type": "Speaker",
        "firstName": "Jeff",
        "lastName": "Tisdall",
        "jobTitle": "Chief Business Officer, Global Head of Mixed-Use",
        "organization": "Accor One Living",
        "photoUrl": "https://static.swapcard.com/public/images/665f0d09e03b46308f0adb0fb8011c4e.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNQ==",
                "title": "Setting the Stage - Introduction to the Branded Residences Forum, Industry Overview, Key Insights, Concepts & Trends",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjE0NjM4NA==",
                "title": "Shared Ownership in Dubai and Across Region. Is the Promise of Vacation Ownership, Fractional and Private Residence Clubs about to be Realized?",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU2MDUxNw==",
                "title": "Keynote: Industry Insights from a Saudi Perspective",
                "categories": [
                    "Branded Residences"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYwMDU2Nw==",
                "title": "TenX Leadership Talk - State of the Industry",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjczMDQ1MQ==",
                "title": "TenX Leadership Talk - State of the Industry",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "3SP1fm2aNeQ",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM4NQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "b3766828-4022-4f8d-91b9-561f98105e21",
                    "id": "RmllbGRWYWx1ZV8yODAwMzM4NA=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2NzI4NjU=",
        "type": "Speaker",
        "firstName": "Carolyn",
        "lastName": "Turnbull",
        "jobTitle": "Chief Executive Officer",
        "organization": "Nammos Hotels & Resorts",
        "photoUrl": "https://static.swapcard.com/public/images/4adadc88ccbd47c88e840bdbb912b670.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc2NTcyNQ==",
                "title": "From Day to Dusk: How Beach Clubs Redefine F&B, Wellness & Exclusivity",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTU0Ng==",
                "title": "Beyond Branded Residences: The Rise of Branded Living in Saudi Arabia",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "d_CeTajDlYU",
                    "id": "RmllbGRWYWx1ZV8yODczNDEwNA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "ba9dce19-a2c9-40df-ba43-ac5d1f029270",
                    "id": "RmllbGRWYWx1ZV8yODczOTczNQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE4MTE1MTU=",
        "type": null,
        "firstName": "Kevin",
        "lastName": "Underwood",
        "jobTitle": "Head of Hospitality Design",
        "organization": "DesignEQ",
        "photoUrl": "https://static.swapcard.com/public/images/f420f8685d0c44ac8b856871485d122c.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjk5OQ==",
                "title": "Beyond Yield: The Emotional Architecture of Luxury Resort Brands",
                "categories": [
                    "Lifestyle and Wellness"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "lifestyle-and-wellness",
                        "translations": [
                            {
                                "value": "Lifestyle and Wellness "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "n_2zjQtaerE",
                    "id": "RmllbGRWYWx1ZV8yODM4NTk4Nw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "b7b9a859-a83e-4248-b955-08634b0c70cb",
                    "id": "RmllbGRWYWx1ZV8yODM4NTk5NQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Architecture & Design",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2MzMxNDE=",
        "type": null,
        "firstName": "Zen",
        "lastName": "Valli",
        "jobTitle": "Chief Revenue Officer",
        "organization": "RMS Cloud",
        "photoUrl": "https://static.swapcard.com/public/images/b236dc35ac9642f6b9cf607d61f4990a.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcyNw==",
                "title": "Efficiency engine: Automating operations for higher profit margins",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc2Nzk1Ng==",
                "title": "TECH Lightning Round",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    }
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "uWAIwiU3DFI",
                    "id": "RmllbGRWYWx1ZV8yODcxODg2Mg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e880b715-bbe3-45d8-9333-ae4f02c88a96",
                    "id": "RmllbGRWYWx1ZV8yODcxODg2Nw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2MzY0Mjg=",
        "type": "Speaker",
        "firstName": "Wytze",
        "lastName": "Van Den Berg",
        "jobTitle": "Vice President EMEA",
        "organization": "BWH Hotels",
        "photoUrl": "https://static.swapcard.com/public/images/55d4598b39e04a528b8baa4386febc26.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc5ODQ4OQ==",
                "title": "A New Dawn: Pioneering the Rise of Lifestyle Hospitality Brands in Africa's Urban and Leisure Destinations",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU5MjYwNQ==",
                "title": "Africa's Hospitality Boom: Is the Sector Growing Fast Enough to Meet Rising Demand?",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMw==",
                "title": "Affordable, Scalable, In Demand: The Midscale Hotel Evolution",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "XgKrGhBalJQ",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMxNg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "2079dea1-5495-46b4-9766-d0d702ce3bd9",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMxNQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfMzg2MzY0MjQ=",
        "type": "Speaker",
        "firstName": "Suma",
        "lastName": "Venkatesh",
        "jobTitle": "Executive Vice President - Real Estate & Development",
        "organization": "The Indian Hotels Company Limited",
        "photoUrl": "https://static.swapcard.com/public/images/f4770139db0a4c2b8f85cc51d5c1e2b6.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzA1MQ==",
                "title": "Why India Matters in Hospitality Investment",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc4MjkyMA==",
                "title": "Transforming Palaces: Embracing Heritage and Showcasing New Luxury",
                "categories": [
                    "Culture & Heritage"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "heritage-and-tourism",
                        "translations": [
                            {
                                "value": "Culture & Heritage"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzc0Mg==",
                "title": "Commercially Driven Asset Management in Hospitality: Strategies for Maximizing Returns",
                "categories": [
                    "Hotelisation of Traditional Assets",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA0Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "hotelisation-of-traditional-assets",
                        "translations": [
                            {
                                "value": "Hotelisation of Traditional Assets"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjczOTg0MQ==",
                "title": "Building Tomorrow: The Geographies and Segments Defining Growth",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "VB52eT0tP8Y",
                    "id": "RmllbGRWYWx1ZV8yODAwMzMwNw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "b39ea607-fad3-4add-ab97-6140210598b2",
                    "id": "RmllbGRWYWx1ZV8yODgwMzIxNQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDE5MjUzNTg=",
        "type": null,
        "firstName": "Priyanka",
        "lastName": "Vijayan",
        "jobTitle": "Director of Ventures",
        "organization": "SEED Ventures",
        "photoUrl": "https://static.swapcard.com/public/images/b9edc29eeec347368f68bd1df684c300.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjc0MTYzOA==",
                "title": "PitchPoint: The FHS Investment Spotlight",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "JhD9wQyuyag",
                    "id": "RmllbGRWYWx1ZV8yODQzOTYwNw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "a9a9d36c-6b6c-44d7-a296-f22ee8ffc86e",
                    "id": "RmllbGRWYWx1ZV8yODQzOTYxNQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Investor - PitchPoint",
                    "id": "RmllbGRWYWx1ZV8yODQ1NTc1MQ=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA1OTkxMjM=",
        "type": "Speaker",
        "firstName": "Daniel",
        "lastName": "von Barloewen",
        "jobTitle": "Senior Vice President, Global Mixed-Use Development",
        "organization": "Accor One Living",
        "photoUrl": "https://cdn-api.swapcard.com/public/images/5cf473e2ddec40608d2edc80e017428d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTUzMzAyNA==",
                "title": "Branded Residential is Booming: Upfront Planning for Making Your Project a Success",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTgwOTM2Ng==",
                "title": "The Future of Hospitality Investments in Branded Residences, Co-Living, and Serviced Apartments in the Kingdom",
                "categories": [
                    "Brand & Destination",
                    "Investment & Development"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "brand-development",
                        "translations": [
                            {
                                "value": "Brand & Destination"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment",
                        "translations": [
                            {
                                "value": "Investment & Development"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgxNw==",
                "title": "Operator Perspective - A Look at How Leading Operators of Branded Residences View their Relationship With Development Partners and Homeowner Communities",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzgyMw==",
                "title": "Structuring Rentals Programs to Appeal to Buyers, While Protecting the Interests of Hotel Owners & Developers",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjUzMzkxNQ==",
                "title": "Unveiling Market Trends: Insights into Branded Residences in the Kingdom",
                "categories": [
                    "Branded Residences"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU4NDQ5Nw==",
                "title": "Stakeholder perspectives – How do branded residences create value for investors, homeowners and brands",
                "categories": [
                    "Branded Residences"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU2NzA5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences",
                        "translations": [
                            {
                                "value": "Branded Residences"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjc0Mw==",
                "title": "Maximizing Returns, Minimizing Risk: How to Optimize and Protect Value for Investors",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTUzOQ==",
                "title": "Branded Residences 2026: From Global Trends to Saudi Opportunity",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "4PPtoKqwqmo",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQwNg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "83652b3f-e10c-459f-abea-6fa09935b86f",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQwNQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEzNjY1Njg=",
        "type": null,
        "firstName": "Rosanna",
        "lastName": "Wang",
        "jobTitle": "Chief Executive Officer and Founder",
        "organization": "Aristara",
        "photoUrl": "https://static.swapcard.com/public/images/31d2efd47aca4d488cf570abb51cd503.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjczOTMzNw==",
                "title": "Automating the Predictable, Humanizing the Exceptional: Investing in People for the Moments that Matter",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "IYc9ZLj-5mg",
                    "id": "RmllbGRWYWx1ZV8yODI4MTQ4OQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "690094c8-a325-4712-b05b-2e82afb17818",
                    "id": "RmllbGRWYWx1ZV8yODcxMTc3Nw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIxOTAyNTQ=",
        "type": null,
        "firstName": "Patrick van der",
        "lastName": "Wardt",
        "jobTitle": "Founder",
        "organization": "The Hotel IT Guy",
        "photoUrl": "https://static.swapcard.com/public/images/0af9dddc69644d6eb1253f2382dea47e.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjcyMjcyNw==",
                "title": "Efficiency engine: Automating operations for higher profit margins",
                "categories": [
                    "Innovation and Technology"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "innovation-and-technology",
                        "translations": [
                            {
                                "value": "Innovation and Technology "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "IHpns85NfyQ",
                    "id": "RmllbGRWYWx1ZV8yODU0MDg4OA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "68475da4-c915-4cbd-8c16-0210d7d504b7",
                    "id": "RmllbGRWYWx1ZV8yODU0MDg5OQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Technology",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0NDAwOTI=",
        "type": "Speaker",
        "firstName": "Matthew",
        "lastName": "Weihs",
        "jobTitle": "Founder FHS Africa",
        "organization": "The Bench",
        "photoUrl": "https://static.swapcard.com/public/images/82576161997a4e0285b1350e51510e42.webp",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTk0MTY4NA==",
                "title": "Unlocking Africa - Hotel Investment Trends & Outlook",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTgyOTY2Mg==",
                "title": "Newcomers Welcome",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc4MzQyNg==",
                "title": "Welcome",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc4MzQ1Mw==",
                "title": "FHS Africa Awards",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc4NDkyNQ==",
                "title": "Closing Remarks",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA0OTQyNQ==",
                "title": "Welcome Remarks",
                "categories": [
                    "Focus on Africa"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTA1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "focus-on-africa",
                        "translations": [
                            {
                                "value": "Focus on Africa"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU1NjkxOQ==",
                "title": "Tracking Africa's Hotel Openings in 2024",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMjY1MzcxOQ==",
                "title": "Unlocking STR Hotel Benchmarking: Insights You Can't Ignore",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMjY5NDk0Nw==",
                "title": "Newcomers Welcome",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ5NTc2NA==",
                "title": "Welcome to FHS Africa 2025",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY4Mjk2NA==",
                "title": "Official Welcome",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ5NTE2NQ==",
                "title": "FHS Africa Outstanding Contribution to Hospitality Award",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjgxMzcyMA==",
                "title": "Speed Networking (Sponsored by FSK & Partners)",
                "categories": [
                    "Networking"
                ],
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "networking",
                        "translations": [
                            {
                                "value": "Networking"
                            }
                        ]
                    },
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk3Mzc5OA==",
                "title": "Welcome",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "United Kingdom",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Grc4LnKaZag",
                    "id": "RmllbGRWYWx1ZV8yODcxODMxOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "e0c47633-c7fa-418e-895f-3e881cb13368",
                    "id": "RmllbGRWYWx1ZV8yODgyOTMxNw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Organiser",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEwNDg3OTc=",
        "type": "Moderator",
        "firstName": "Andre",
        "lastName": "Wiringa",
        "jobTitle": "Founder and CEO",
        "organization": "Start Reverse BV",
        "photoUrl": "https://static.swapcard.com/public/images/417950b0fe104be1880da95e07a59692.png",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjU5MjY2NQ==",
                "title": "Masterclass: How engagement, culture and leadership make or break brand & property value in the region (and beyond)?",
                "categories": [
                    "NextGen Talent & Hospitality Education"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzYxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen-talent-and-hospitality-education",
                        "translations": [
                            {
                                "value": "NextGen Talent & Hospitality Education"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjQxMQ==",
                "title": "The Future Workforce: Empowering Talent, Leadership, and Inclusion",
                "categories": [
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjc0MTYzNw==",
                "title": "Thinking Reverse to Go Beyond: A Reverse Learning Experience",
                "categories": [
                    "NextGen"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "nextgen",
                        "translations": [
                            {
                                "value": "NextGen"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNjYyNw==",
                "title": "Culture Creates Value: How Leadership and Engagement Drive ROI, Brand Strength and Asset Performance",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "gvGI0VPYULY",
                    "id": "RmllbGRWYWx1ZV8yODE3MTQwMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "88db6f5d-b018-487e-b77b-7295ed1d2dcd",
                    "id": "RmllbGRWYWx1ZV8yODE3MTQwMQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Consulting/Advisor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA2NDQ3MjA=",
        "type": "Speaker",
        "firstName": "Philip",
        "lastName": "Wooller",
        "jobTitle": "Senior Director, Middle East & Africa",
        "organization": "STR, a CoStar Group Company",
        "photoUrl": "https://static.swapcard.com/public/images/30e045dd96184f4aa29bf235701eccb0.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfOTM3MTc=",
                "title": "Trends shaping the industry – looking back and the future",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMTc4MzQzMQ==",
                "title": "Setting the Scene for Destination & Hotel Development in Africa",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY1MzcxOQ==",
                "title": "Unlocking STR Hotel Benchmarking: Insights You Can't Ignore",
                "categories": [],
                "fields": []
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjM4Nw==",
                "title": "Setting the Scene for Hotel Performance and Development in Saudi Arabia",
                "categories": [
                    "Investment, Finance & Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzY3Mw==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-finance-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment, Finance & Real Estate "
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ5NTE1NQ==",
                "title": "Setting the Scene for Destination & Hotel Development in Africa",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzQxNDkzMA==",
                "title": "Numbers that Matter – Understanding Africa’s Hotel Performance",
                "categories": [
                    "UAE – Africa Tourism Investment Summit"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODE3NDU1NA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "uae-africa-tourism-investment-summit",
                        "translations": [
                            {
                                "value": "UAE – Africa Tourism Investment Summit"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjk3MzgwMg==",
                "title": "Decoding the Data: What the Numbers Say About the Next Chapter in Hospitality",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTU1OQ==",
                "title": "Setting the Scene for Hotel Performance and Development in Saudi Arabia",
                "categories": [],
                "fields": [
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "United Arab Emirates",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "PSfcJP9RWkU",
                    "id": "RmllbGRWYWx1ZV8yODAwMzQzMA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "6ed3cb10-ce54-42a0-b32e-14ee5547e9f5",
                    "id": "RmllbGRWYWx1ZV8yODA5NDY5OA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDA3OTgwODY=",
        "type": "Speaker",
        "firstName": "Jonathan",
        "lastName": "Worsley",
        "jobTitle": "Chairman",
        "organization": "The Bench",
        "photoUrl": "https://static.swapcard.com/public/images/e997714c742148f99e8e4898e4978923.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc1MDU2OQ==",
                "title": "Welcome Remarks",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5MDk3NA==",
                "title": "Let's meet the Future with Desi",
                "categories": [
                    "Technology & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "technology-and-innovation",
                        "translations": [
                            {
                                "value": "Technology & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU4Ng==",
                "title": "Start-Up Den",
                "categories": [
                    "Startup Den"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "startup-den",
                        "translations": [
                            {
                                "value": "Startup Den"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDU4Nw==",
                "title": "TenX Leadership Talks: Global Ambitions - Bridging Cultures and Markets",
                "categories": [
                    "Talks",
                    "Culture & Heritage"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "heritage-and-tourism",
                        "translations": [
                            {
                                "value": "Culture & Heritage"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTc1MDYwNg==",
                "title": "FHS Awards - Winner Announcement",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMTg5MzkyNA==",
                "title": "Closing Remarks",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU1Mw==",
                "title": "Official Opening FHS World 2024",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU2MA==",
                "title": "The Future Growth of Tourism in Dubai: Harnessing Innovation, Sustainability, Accessibility and Leadership",
                "categories": [
                    "Projects & Destinations",
                    "Green Construction & Smart Cities",
                    "Sustainability & Innovation"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzNzQxMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "destination-and-urban-development",
                        "translations": [
                            {
                                "value": "Projects & Destinations"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg4NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "green-construction-and-smart-cities",
                        "translations": [
                            {
                                "value": "Green Construction & Smart Cities"
                            }
                        ]
                    },
                    {
                        "id": "RmllbGRWYWx1ZV8yNDU3Mjg5MQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-innovation",
                        "translations": [
                            {
                                "value": "Sustainability & Innovation"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzg5NA==",
                "title": "UN Tourism Women in Tech Start Up Competition Semi Finals",
                "categories": [
                    "Competitions"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDM0OTEyNA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "competitions",
                        "translations": [
                            {
                                "value": "Competitions"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzU3NQ==",
                "title": "Welcome Back",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAyNzYxMA==",
                "title": "TenX Leadership Talk: People First for the Future of Hospitality",
                "categories": [
                    "Talks"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyOA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "data-and-digital-talks",
                        "translations": [
                            {
                                "value": "Talks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAzNTg1Mw==",
                "title": "FHS Awards 2024",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjA1NjYzMA==",
                "title": "Closing Remarks",
                "categories": [
                    "FHS Opening, Awards & Signings"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEyNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-awards-and-signings",
                        "translations": [
                            {
                                "value": "FHS Opening, Awards & Signings"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjAzMDE5NA==",
                "title": "Welcome to the Branded Residences Forum",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjM0Ng==",
                "title": "Welcome to NextGen Investment Forum",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjM4OA==",
                "title": "Welcome to FHS Saudi Arabia 2025",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY3MDk0Mg==",
                "title": "Welcome Remarks",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjQ3NjQyMw==",
                "title": "FHS Awards",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU2MDUxOQ==",
                "title": "Welcome Remarks - Net Positive Solution Labs powered by World Sustainable Hospitality Alliance (On Invitation Only)",
                "categories": [
                    "Sustainability & ESG"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNjYzMzY0NQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "sustainability-and-esg",
                        "translations": [
                            {
                                "value": "Sustainability & ESG"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjU5MjY4NQ==",
                "title": "Fireside Chat: Rethinking Conservation for a Sustainable Future",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjY4OTEyMw==",
                "title": "Welcome Back: Nature as a Hospitality Marketing Tool",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYwMDU2NQ==",
                "title": "Opening Remarks",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYwMDY5OQ==",
                "title": "Closing Remarks",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjczNA==",
                "title": "From First Timer to Power Player: Making the Most of FHS World",
                "categories": [
                    "Networking"
                ],
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzNg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "networking",
                        "translations": [
                            {
                                "value": "Networking"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYxMjI1Ng==",
                "title": "Welcome to FHS World 2025",
                "categories": [
                    "Opening / Closing Remarks"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc3OA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "opening-closing-remarks",
                        "translations": [
                            {
                                "value": "Opening / Closing Remarks"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjcwNg==",
                "title": "Then and Now: Two Decades of Hospitality Investment Evolution",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMzEyMjE4NQ==",
                "title": "FHS Lifetime Achievement Award",
                "categories": [
                    "Awards"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "awards",
                        "translations": [
                            {
                                "value": "Awards"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjcxMQ==",
                "title": "FHS Awards",
                "categories": [
                    "Awards"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "awards",
                        "translations": [
                            {
                                "value": "Awards"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjk5NA==",
                "title": "FHS Africa Excellence Award",
                "categories": [
                    "Awards"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "awards",
                        "translations": [
                            {
                                "value": "Awards"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODkyMA==",
                "title": "Welcome to the Branded Residences Forum at FHS World 2025",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTU1Mg==",
                "title": "Welcome to FHS Saudi Arabia 2026",
                "categories": [],
                "fields": [
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNTUzNg==",
                "title": "Welcome to the Branded Residences Forum",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "3MRmnsaOqH4",
                    "id": "RmllbGRWYWx1ZV8yODA1OTkyMg=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "ba605e5b-2dd0-46a2-a9da-4701d3a48be9",
                    "id": "RmllbGRWYWx1ZV8yODA1OTkyMQ=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Other (Please Specify)",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDIxNDY1NjQ=",
        "type": null,
        "firstName": "James",
        "lastName": "Wrenn",
        "jobTitle": "Partner - Head of Hotel & Leisure Capital Markets | Middle East & Africa",
        "organization": "Knight Frank",
        "photoUrl": "https://static.swapcard.com/public/images/adaa5eb01b0447e3aa0080de7235e212.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg5MA==",
                "title": "The Second Act: How Investors are Rewriting the Story of Hospitality Assets",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "vqOr3qXozeI",
                    "id": "RmllbGRWYWx1ZV8yODUyNzQ1NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "bb060672-b2a5-4717-b61b-c9e7d3990296",
                    "id": "RmllbGRWYWx1ZV8yODUyNzQ2MA=="
                },
                {}
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI0MTk0NDc=",
        "type": null,
        "firstName": "David",
        "lastName": "Xiaoou Chen",
        "jobTitle": "Chairman & CEO",
        "organization": "Fields of Gold Capital and Asset Management Group",
        "photoUrl": "https://static.swapcard.com/public/images/68aa19c3fca3497999700cd044c5a106.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYxMjI1OA==",
                "title": "A GLOBAL PRESIDENTS FORUM: The Bulls & Bears of Global Capital Markets",
                "categories": [
                    "Global Outlook"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTE0Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "global-outlook",
                        "translations": [
                            {
                                "value": "Global Outlook"
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjYyODg5Mw==",
                "title": "A Global Perspective - From Asia to the Middle East",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "VE_2S2jS4O8",
                    "id": "RmllbGRWYWx1ZV8yODYyOTk4MQ=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "3f84cacf-b5a1-4d54-a205-74650438617e",
                    "id": "RmllbGRWYWx1ZV8yODYzMDAwMA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Investor",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI2NzA2MTU=",
        "type": null,
        "firstName": "Alex",
        "lastName": "Zagrebelny",
        "jobTitle": "Founder & Chief Executive Officer",
        "organization": "R.Evolution Real Estate Developer",
        "photoUrl": "https://static.swapcard.com/public/images/f369bceb30874c4db8a76f7b5a64b821.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMzQwMjcxNA==",
                "title": "The Next Chapter of Real Estate: Regeneration Over Preservation",
                "categories": [
                    "Branded Residences Forum"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yNDIzOTQ1MA==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "branded-residences-forum",
                        "translations": [
                            {
                                "value": "Branded Residences Forum"
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "Vdz5fb7SVMU",
                    "id": "RmllbGRWYWx1ZV8yODczMzcxMw=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "55a7c799-54b5-4edb-a427-0bf72d2b099d",
                    "id": "RmllbGRWYWx1ZV8yODczMzcyMQ=="
                },
                {},
                {
                    "definition": {
                        "name": "Special Label",
                        "translations": [
                            {
                                "name": "Special Label"
                            }
                        ],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNzE0Mw=="
                    },
                    "locale": "en_US",
                    "value": "Speaking at the Branded Residences Forum",
                    "id": "RmllbGRWYWx1ZV8yODE3MjMyNA=="
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDEyNjkxNjA=",
        "type": "Speaker",
        "firstName": "Maya",
        "lastName": "Ziade",
        "jobTitle": "Chief Development Officer",
        "organization": "Accor Hotels Middle East, Africa and Türkiye T",
        "photoUrl": "https://static.swapcard.com/public/images/e6002ebef3da48d58056b6d73e6d695d.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMTc1MDYwMA==",
                "title": "Breaking Barriers, Shaping the Future: Women in Tourism & Hospitality Leadership",
                "categories": [
                    "ESG & Human Capital"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yMzI1MzEzMQ==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "esg",
                        "translations": [
                            {
                                "value": "ESG & Human Capital"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMjcxMQ==",
                "title": "FHS Awards",
                "categories": [
                    "Awards"
                ],
                "fields": [
                    {},
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODY2Mjc2Mg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "awards",
                        "translations": [
                            {
                                "value": "Awards"
                            }
                        ]
                    }
                ]
            },
            {
                "id": "UGxhbm5pbmdfMjcyMzAwMw==",
                "title": "Affordable, Scalable, In Demand: The Midscale Hotel Evolution",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            },
            {
                "id": "UGxhbm5pbmdfNDQwNjYzNg==",
                "title": "Leading Forward: Women Shaping the Future of Hospitality",
                "categories": [],
                "fields": [
                    {},
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {},
                {
                    "translations": [
                        {
                            "value": "United Arab Emirates",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzgyNzM3NQ==",
                        "translations": [
                            {
                                "name": "Country",
                                "language": "en_US"
                            }
                        ]
                    }
                },
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "3n-x3TnI-rY",
                    "id": "RmllbGRWYWx1ZV8yODI1MzMwOA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "acec2133-5535-43cb-9c12-849262e5bb8d",
                    "id": "RmllbGRWYWx1ZV8yODI2MTk3Nw=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Operator/Management",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    },
    {
        "id": "RXZlbnRQZW9wbGVfNDI1NjgwNTc=",
        "type": null,
        "firstName": "David",
        "lastName": "Zisser",
        "jobTitle": "Founder and CEO",
        "organization": "OMNAM GROUP",
        "photoUrl": "https://static.swapcard.com/public/images/3b3dd71bdac14b37a81d9b8daa1e3060.jpeg",
        "speakerOnPlannings": [
            {
                "id": "UGxhbm5pbmdfMjYyODg3NQ==",
                "title": "Mapping the Money: Tracking Smart Capital in a Changing Hospitality Landscape",
                "categories": [
                    "Investment and Real Estate"
                ],
                "fields": [
                    {},
                    {
                        "id": "RmllbGRWYWx1ZV8yODMwNTgzMg==",
                        "definition": {
                            "isDefault": true,
                            "name": "Topics"
                        },
                        "value": "investment-and-real-estate",
                        "translations": [
                            {
                                "value": "Investment and Real Estate "
                            }
                        ]
                    },
                    {}
                ]
            }
        ],
        "withEvent": {
            "fields": [
                {},
                {},
                {
                    "definition": {
                        "name": "PREMAGIC_REGISTRATION_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0MQ=="
                    },
                    "locale": "en_US",
                    "value": "EG5JJ62BtYQ",
                    "id": "RmllbGRWYWx1ZV8yODcwMzc1NA=="
                },
                {
                    "definition": {
                        "name": "PREMAGIC_FACE_ID",
                        "translations": [],
                        "id": "RmllbGREZWZpbml0aW9uXzgzNDk0Mg=="
                    },
                    "locale": "en_US",
                    "value": "db8d5000-bcde-4e0d-9fcb-b95e79b9c18a",
                    "id": "RmllbGRWYWx1ZV8yODcwMzc1OA=="
                },
                {},
                {
                    "translations": [
                        {
                            "value": "Hotel Developer",
                            "language": "en_US"
                        }
                    ],
                    "definition": {
                        "id": "RmllbGREZWZpbml0aW9uXzg0NTU5OA==",
                        "translations": [
                            {
                                "name": "Business Type",
                                "language": "en_US"
                            }
                        ]
                    }
                }
            ]
        }
    }
]